! function(name, module, context) {
    //>>excludeStart("requireTmpl", pragmas.requireTmpl);
    if (window.define)
        define('hotels/filter',['vendor/mustache', 'libs/ct_view', 'libs/ct_store', 'common/filter', 'hotels/filterUtils'], module)
    else
    //>>excludeEnd("requireTmpl");
        context[name] = module(Mustache, CT.View, CT.store, CT.settings.commonFilter)
}('filter', function(Mustache, View, store, cf) {



    /**
     * internal helper methods
     ***************************************************************************************/
    var amenitiesMapper = ["amWIFI", "amAC", "am24HrCheckin", "amRestaurant", "amBar", "amCafe", "amRoomService", "amInternet", "amBusinessCenter", "amPool", "amGym"];
    var hashModifiers = ['starFilter', 'amenity', 'propertyType', 'area', 'poi', 'dbg', 'roomType', 'destinations', 'destinationsTheme', 'hotelsTheme', 'priceFilter', 'chain', 'tagsFilter', 'lolfilter', 'showFewFilter', 'localities'];
    //For chunky filters
    var chunkyFilterMap = {
        "hotelchain": 'chain',
        "propertytype": 'propertyType',
        "travellerrating": "taStarRating",
        "starrating": "starFilter",
        "amenities": "amenity",
        "price": "price",
        "localities":"localities"
    }
    var prevFilterEle = [],
        currentFilterEle = [],
        prevSerializedData = [],
        currentSerializedData = [];
    filtersToRetain = [];

    var arrayUniqueEleCnt = function(arr) {
        var lastVal = "",
            lc_cnt = 0;
        lc = arr.sort(), loc_len = lc.length, arr1 = [];
        for (var j = 0; j < loc_len; j++) {
            if (lc[j]) {
                if (lastVal == "" || lastVal != lc[j]) {
                    arr1[lc_cnt] = [lc[j], 1];
                    lastVal = lc[j];
                    lc_cnt++;
                } else {
                    arr1[lc_cnt - 1][1]++;
                }
            }
        }
        return arr1;
    }
    var changeToBinary = function(_am) {
        var _amnity = parseInt(_am, 16).toString(2);
        return _amnity;
    }

    var prop = function(name) {
        var fn;
        switch (name) {
            case 'id':
                fn = function(hotel) {
                    return hotel.id
                };
                break;
            case 'ta':
                fn = function(hotel) {};
                break;
            default:
                fn = function() {
                    return true
                }
        }
        return fn;
    }



    var filterByProp = function(name, arr) {

        try {
            var fn;
            switch (name) {
                //ta filter if it is checkbox
                //case 'ta' : fn = function(hotel){ return _.indexOf(arr, ''+Int(hotel.tar)) >= 0 }; break;
                case 'taStarRating':
                    fn = function(hotel) {
                        return hotel.tar ? (arr[0] ? parseFloat(arr[0]) <= parseFloat(hotel.tar) : true): false;
                    };
                    break;
                case 'hrsFilterSlider':
                    fn = function(hotel) {
                        if (!$.isArray(arr)) {
                            arr = arr.split("-");
                        }
                        if (Int(arr[1]) == 10 && Int(arr[0]) == 0) {
                            return true;
                        } else if (Int(arr[1]) == 10 && Int(arr[0]) != 0) {
                            if ((Math.ceil(hotel.tt / (60)) <= Int(arr[1]) || Math.ceil(hotel.tt / (60)) >= Int(arr[1])) && Math.ceil(hotel.tt / (60)) >= Int(arr[0])) {
                                return true;
                            }
                        } else if (Int(arr[1]) != 10 && Int(arr[0]) == 0) {
                            if (Math.ceil(hotel.tt / (60)) <= Int(arr[1]) && (Math.ceil(hotel.tt / (60)) >= Int(arr[0]) || Math.ceil(hotel.tt / (60)) <= Int(arr[0]))) {
                                return true;
                            }
                        } else {
                            if (Math.ceil(hotel.tt / (60)) <= Int(arr[1]) && Math.ceil(hotel.tt / (60)) >= Int(arr[0])) {
                                return true;
                            }
                        }
                    };
                    break;
                case 'hrsFilter':
                    fn = function(hotel) {
                        if (!$.isArray(arr)) {
                            arr = arr.split(",");
                        }
                        if (Int(arr[1]) == 10 && Int(arr[0]) == 0) {
                            return true;
                        } else if (Int(arr[1]) == 10 && Int(arr[0]) != 0) {
                            if ((Math.ceil(hotel.tt / (60)) <= Int(arr[1]) || Math.ceil(hotel.tt / (60)) >= Int(arr[1])) && Math.ceil(hotel.tt / (60)) >= Int(arr[0])) {
                                return true;
                            }
                        } else if (Int(arr[1]) != 10 && Int(arr[0]) == 0) {
                            if (Math.ceil(hotel.tt / (60)) <= Int(arr[1]) && (Math.ceil(hotel.tt / (60)) >= Int(arr[0]) || Math.ceil(hotel.tt / (60)) <= Int(arr[0]))) {
                                return true;
                            }
                        } else {
                            if (Math.ceil(hotel.tt / (60)) <= Int(arr[1]) && Math.ceil(hotel.tt / (60)) >= Int(arr[0])) {
                                return true;
                            }
                        }
                    };
                    break;
                case 'roomType':
                    fn = function(hotel) {
                        return hotel.rt ? (_.indexOf(arr, hotel.rt.replace(" ", "").toLowerCase()) >= 0) : true;
                    };
                    break;
                case 'payAtHotel':
                    fn = function(hotel) {
                        return hotel.pp && hotel.pp === 1 ? true : false;
                    };
                    break;
                case 'showFewFilter':
                    // var distance = CT.masterJson.get().hdfmn ? parseInt(CT.masterJson.get().hdfmn) : ""
                    var distance = CT.masterJson.get().hdfmn ? 99999999: ""
                    fn = function(hotel) {
                        if (distance != "" && hotel.distanceFromLocation != "") {
                            if (hotel.distanceFromLocation <= distance) {
                                return true;
                            }
                        }
                    }
                    break;
                case 'showLocationHotels':
                    fn = function(hotel) {
                        return hotel.distanceFromLocation && hotel.distanceFromLocation < CT.settings.general.locationRadius ? true : false;
                    };
                    break;
                case 'instantBooking':
                    fn = function(hotel) {
                        return hotel.ib && hotel.ib === true ? true : false;
                    };
                    break;
                case 'freeCancellation':
                    fn = function(hotel) {
                        return hotel.fc && hotel.fc == true ? true : false;
                    };
                    break;
                case 'tripVilla':
                    fn = function(hotel) {
                        return (hotel.viw && hotel.viw > 0) ? true : false;
                    };
                    break;
                case 'starFilter':
                    fn = function(hotel) {
                        return hotel.sr ? _.indexOf(arr, String(hotel.sr)) >= 0 : _.indexOf(arr, "1") >= 0 // if 1 star is selected show 0 star or undefined star
                    };
                    break;
                case 'amenity':
                    fn = function(hotel) {
                        var binVal = changeToBinary(hotel.amn)
                        var mappedAm = [];
                        binVal = binVal.split("").reverse().join("");
                        _.each(binVal, function(digit, index) {
                            if (+digit !== 0) {
                                if(amenitiesMap[index].class == "amInternet"){
                                    mappedAm.push("amWIFI");
                                } else if(amenitiesMap[index].class == "amFitnessCenter"){
                                    mappedAm.push("amGym");
                                }else if(amenitiesMap[index].class == "amAirportShuttle"){
                                    mappedAm.push("amPickDrop");
                                } else {
                                    mappedAm.push(amenitiesMap[index].class);
                                }
                            }
                        })
                        return _.difference(arr, mappedAm).length === 0
                    };
                    break;
                case 'price':
                    fn = function(hotel) {
                        var displayEle = CT.cache[CT.settings.currentTab].prDispUnitEle;
                        if (displayEle == "totPriceDispHeader") {
                            var pr = (CT.app !== 'dp' ? +(hotel.priceInfo !== undefined ? hotel.priceInfo.rms[0].tot : 0) : hotel.priceInfo.pf),
                                tmp;
                            tmp = CT.cache[CT.settings.currentTab].filterValues.priceMinMax;
                        } else {
                            var pr = (CT.app !== 'dp' ? +(hotel.priceInfo !== undefined ? hotel.priceInfo.rms[0].avg : 0) : hotel.priceInfo.pf),
                                tmp;
                            tmp = CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax;
                        }
                        if (pr && (pr >= Int(arr[0]) && pr <= Int(arr[1])))
                            return true

                        if (pr == 0 && tmp.min === Int(arr[0]) && tmp.max === Int(arr[1]))
                            return true;
                    };
                    break;
                case 'priceFilter':
                    fn = function(hotel) {
                        var pr = (CT.app !== 'dp' ? +(hotel.priceInfo !== undefined ? hotel.priceInfo.rms[0].tot : 0) : hotel.priceInfo.pf),
                            tmp;
                        if (arr.length < 4) {
                            for (var i = 0; i < arr.length; i++) {
                                var v = arr[i].split('-');
                                if (pr && (pr >= Int(v[0]) && pr <= Int(v[1]))) return true;
                            }
                            return false;
                        } else
                            return true;
                    };
                    break;
                case 'hotelName':
                    fn = function(hotel) {
                        //if((hotel.nm.toLowerCase().indexOf(arr.toLowerCase()) >= 0))
                        if (hotel.nm && hotel.nm.toLowerCase() == arr.toLowerCase())
                            return true;
                    };
                    break;

                case 'nearByCities':
                    fn = function(hotel) {
                        //if nearby filter is off and hotel is not having nci ( near by filter city id )
                        if (arr == 'off' && !hotel.nci)
                            return true;
                    };
                    break;

                case 'propertyType':
                    fn = function(hotel) {
                        var k, finalResult = false;
                        if (hotel.pt && hotel.pt.length > 0) {
                            for (k = 0; k < hotel.pt.length; k++) {
                                finalResult = finalResult || (_.indexOf(arr, hotel.pt[k].code) >= 0);
                            }
                            return finalResult;
                        } else {
                            return _.indexOf(arr, 'NOCAT') >= 0;
                        }
                    };
                    break;
                case 'destinations':
                    fn = function(hotel) {
                        return _.indexOf(arr, hotel.c.toString()) >= 0;
                    };
                    break;

                case 'destinationsTheme':
                    fn = function(hotel) {
                        var k, finalResult = false;
                        if (hotel.dth.length > 0) {
                            for (var k = 0; k < hotel.dth.length; k++) {
                                finalResult = finalResult || (_.indexOf(arr, hotel.dth[k]) >= 0);
                            }
                            return finalResult;
                        } else {
                            return _.indexOf(arr, 'NOCAT') >= 0;
                        }
                    };
                    break;
                case 'hotelsTheme':
                    fn = function(hotel) {
                        var k, finalResult = false;
                        if (hotel.hth.length > 0) {
                            for (var k = 0; k < hotel.hth.length; k++) {
                                finalResult = finalResult || (_.indexOf(arr, hotel.hth[k]) >= 0);
                            }
                            return finalResult;
                        } else {
                            return _.indexOf(arr, 'NOCAT') >= 0;
                        }
                    };
                    break;
                case 'deals':
                    fn = function(hotel) {
                        return hotel.priceInfo && hotel.priceInfo.oi && !hotel.displayOnlyRule ? true : false;
                    };
                    break;
                case 'quickeys':
                    fn = function(hotel) {
                        return hotel.sb && hotel.sb.sdr === 1 ? true : false;
                    };
                    break;
                case 'weSleep':
                    fn = function(hotel) {
                        return hotel.sb && hotel.sb.wsh > 0 ? true : false;
                    };
                    break;
                case 'popHotels':
                    fn = function(hotel) {
                        return hotel.sb && hotel.sb.bp > 0 && hotel.priceInfo ? true : false;
                    };
                    break;
                case 'badgeFilter':
                    fn = function(hotel) {
                        if (arr === 'allHotels') return true;
                        else if (arr === 'quickKeys') return hotel.sb && hotel.sb.sdr === 1;
                        else if (arr === 'deals') return hotel.priceInfo && hotel.priceInfo.oi && !hotel.displayOnlyRule ? true : false;
                        else if (arr === 'weSleep') return hotel.sb && hotel.sb.wsh > 0;
                        else if (arr === 'popHotels') return hotel.sb && hotel.sb.bp > 0 && hotel.priceInfo;
                        else if (arr === 'pinPoint') return true;
                        else if (arr === 'shortListed') return hotel.shortList && hotel.shortList === true;
                        else if (arr === 'onlyAirBnb') return hotel.id.indexOf("ABNB") == -1 ? false : true;
                        else if (arr === 'budgetBadgeFilter') return hotel.isBudget;
                    };
                    break;
                case 'tagsFilter':
                    fn = function(hotel) {
                        return true;
                    };
                    break;
                case 'tagsFilter':
                    fn = function(hotel) {
                        // var k, finalResult = false;
                        // if (hotel.tags && hotel.tags.length > 0) {
                        //     for (var k = 0; k < arr.length; k++) {
                        //         if (hotel.tags.indexOf(arr[k].replace("_tag", "")) != -1) {
                        //             finalResult = true;
                        //         } else {
                        //             finalResult = false;
                        //             break;
                        //         }
                        //     }
                        //     /*for (k = 0; k < hotel.priceInfo.tags.length; k++) {
                        //         finalResult = finalResult || (_.indexOf(arr, hotel.priceInfo.tags[k]+"_tag") >= 0);
                        //     }*/
                        //     return finalResult;
                        // } else {
                        //     return false
                        // }

                        return true;

                    };
                    break;
                case 'dbg':
                    fn = function(hotel) {
                        if (hotel.priceInfo)
                            return _.indexOf(arr, hotel.priceInfo.sup.replace(/:/g, '')) >= 0;
                        else return false
                    };
                    break;
                case 'chain':
                    fn = function(hotel) {
                        if (hotel.ch)
                            return _.indexOf(arr, hotel.ch) >= 0 ? true : false
                        else
                            return false;
                    };
                    break;

                default:
                    fn = function() {
                        return true
                    }
            }
            return fn;
        } catch (e) {
            _errs.push(e);
            throw e;
        }
    }




    /**
     * filter object
     ***************************************************************************************/
    var filter = {


        initialize: function() {
            CT.settings.hotel.filter.isNewFilterEnabled = (window.chunkyFiltersEnabled && CT.app === 'hotel');
            
            var _paramsHash = _.deserialize(window.location.href.split('results?')[1]);
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);

            if (_paramsHash.showDebug === "true") this.createFilter('dbg', 'checkbox')

            // var hideHotelNameFilter = CT.utils.getAbTestCookie("hotel_name_filter") === 'b';            
            switch (CT.subProd) {
                case "wg":
                    // if (window.prDispUnit === "true" && window.altFilters == "false" && !hideHotelNameFilter) this.createFilter('smallSearch', 'inputText');
                    if (window.prDispUnit === "true" && window.altFilters == "false") this.createFilter('smallSearch', 'inputText');
                    if (window.altFilters == "false") {
                        this.createFilter('price', 'slider');
                        this.createFilter('taStarRating', 'slider');
                    }
                    //if(window.altFilters == "true") this.createFilter('hrsFilterSlider', 'slider');
                    this.createFilter('destinations', 'checkbox');
                    this.createFilter('destinationsTheme', 'checkbox', undefined, undefined, $currentTab.find(".altFiltersForm"));
                    if (window.altFilters == "false") this.createFilter('hotelsTheme', 'checkbox');
                    break;
                case "airBnb":
                    if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b'){
                        this.createFilter('priceFilter', 'checkbox');
                    } 
                    else if ( (window.priceSlider && (CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") !== 'b' || window.countryCode !== 'in')) ){
                        this.createFilter('price', 'slider');
                    }
                    this.createFilter('instantBooking', 'checkbox');
                    this.createFilter('roomType', 'checkbox');
                    this.createFilter('propertyType', 'checkbox');
                    break;
                default:
                    if (window.productCode === "AG") {
                        this.createFilter('emailQuote', 'popup');
                        this.createFilter('printQuote', 'popup');
                    }
                    this.createFilter('showFewFilter', 'checkbox');
                    //added B2B condition to enable it on Agentbox and corp, also it effectively disable ABtesing for both
                    if (window.prDispUnit === "true" || window.product == "B2B") {
                        this.createFilter('smallSearch', 'inputText');
                    }
                    //For Chunky Filters adding a Subscription to be fired once hotel-content is set

                    if (window.chunkyFiltersEnabled) {
                        var that = this;
                        CT.subscribe('createChunkyFilters', function(hfd) {
                            // Remove filter with name: "Hotel chain", make condition case insensitive
                            hfd = hfd.filter(function (filter) { return filter.name.toLowerCase() !== "hotel chain" });

                            if (!hfd) {
                                //Default Order
                                //Ignore
                                delete CT.settings.hotel.filter.starFilter.smartFilterCheckBox;
                                delete CT.settings.hotel.filter.amenity.smartFilterCheckBox;
                                delete CT.settings.hotel.filter.propertyType.smartFilterCheckBox;
                                delete CT.settings.hotel.filter.taStarRating.smartFilterCheckBox;
                                CT.settings.hotel.filter.propertyType.checkAll = true;
                                CT.settings.hotel.filter.starFilter.checkAll = true;
                                CT.settings.hotel.filter.amenity.only = false;
                                CT.settings.hotel.filter.propertyType.only = true;
                                CT.settings.hotel.filter.starFilter.only = true;
                                if (CT.cache.oldFilters)
                                    CT.settings.hotel.filter.taStarRating = CT.cache.oldFilters.taStarRating;
                                CT.settings.hotel.filter.smallSearch.placeholder = "Filter by Hotel or Chain"

                                if ((window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b'){
                                    this.createFilter('priceFilter', 'checkbox');
                                } 
                                else if ( (window.priceSlider && (CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") !== 'b' || window.countryCode !== 'in')) ){
                                    this.createFilter('price', 'slider');
                                }
                                that.createFilter('deals', 'checkbox');
                                that.createFilter('payAtHotel', 'checkbox');
                                that.createFilter('freeCancellation', 'checkbox');

                                that.createFilter('starFilter', 'checkbox');
                                that.createFilter('showLocationHotels', 'checkbox')
                                
                                if (parseInt(CT.cache[CT.settings.currentTab].searchParams.all.adults) + parseInt(CT.cache[CT.settings.currentTab].searchParams.all.childs) >= 4)
                                    that.createFilter('tripVilla', 'checkbox');
                                that.createFilter('taStarRating', 'slider');
                                that.createFilter('locality', 'checkbox');
                                that.createFilter('amenity', 'checkbox');
                                that.createFilter('propertyType', 'checkbox');
                            } else {
                                
                                //Updating data from here only
                                //Update the required properties
                                //Store the taStarRatings settings in a cache
                                CT.cache.oldFilters = CT.cache.oldFilters || {};
                                if ($.isEmptyObject(CT.cache.oldFilters))
                                    CT.cache.oldFilters.taStarRating = $.extend({}, CT.settings.hotel.filter.taStarRating);
                                CT.settings.hotel.filter.taStarRating = CT.settings.hotel.filter.taRating;
                                CT.settings.hotel.filter.starFilter.checkAll = false;
                                CT.settings.hotel.filter.starFilter.smartFilterCheckBox = 1;
                                CT.settings.hotel.filter.amenity.smartFilterCheckBox = 1;
                                CT.settings.hotel.filter.amenity.checkAll = false;
                                CT.settings.hotel.filter.amenity.only = false;
                                CT.settings.hotel.filter.propertyType.smartFilterCheckBox = 1;
                                CT.settings.hotel.filter.propertyType.checkAll = false;
                                CT.settings.hotel.filter.propertyType.only = false;
                                CT.settings.hotel.filter.priceFilter.checkAll = false;
                                CT.settings.hotel.filter.locality.checkAll = false;
                                CT.settings.hotel.filter.smallSearch.placeholder = "Filter by hotel name";
                                
                                if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                                    CT.settings.hotel.filter.locality.hideFilter = !window.enableLocalityFilter;
                                } else {
                                    CT.settings.hotel.filter.locality.hideFilter = true;
                                }
                                var vIndex =[], priceIndex = -1, starIndex = -1;
                                var tempArr = _.filter(hfd, function(value, index){
                                    var filterName = value.name.replace(/\s/, '').trim().toLowerCase();
                                    if(filterName === "amenities" || filterName === "propertytype" || filterName  === "hotelchain") {
                                        vIndex.push(index);
                                        return true;
                                    }
                                    
                                    else if(filterName === 'price') {
                                        priceIndex = index;
                                    } else if(filterName === 'starrating') {
                                        starIndex = index;
                                    }
                                });

                                if(priceIndex !== -1 && priceIndex !== 0 && starIndex !== -1){
                                    var tempObj = hfd[priceIndex];
                                    hfd[priceIndex] = hfd[starIndex];
                                    hfd[starIndex] = tempObj;
                                }

                                tempArr = _.sortBy(tempArr, 'name');

                                _.forEach(vIndex,function(value,index){
                                    hfd.splice(value, 1, tempArr[index]);
                                });
                                
                                if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                                    // var copyHFD = Object.assign({}, hfd);
                                    var copyHFD = JSON.parse(JSON.stringify(hfd));
                                    // copyHFD.push({expanded: true,name: "Tags",rank: 8}, {expanded: true,name: "Locality",rank: 7});
                                    Object.keys(copyHFD).forEach(function (k,v){
                                        var keyToCheck = copyHFD[v].name.replace(/\s/, '').trim().toLowerCase()
                                        if(keyToCheck == "Amenities ".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 5
                                        } else if (keyToCheck == "Traveller Rating".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 4
                                        } else if(keyToCheck == "Price".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 1
                                        } else if(keyToCheck == "Star Rating".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 3
                                        } else if(keyToCheck == "Property type".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 6
                                        } else if(keyToCheck == "Hotel chain".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 7
                                        }  else if(keyToCheck == "Locality".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 2
                                        }
                                        /*else if(keyToCheck == "Top Locations".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 1
                                        } */
                                    })
                                    
                                    var tempCPArr = _.sortBy(copyHFD, 'uiOrder');

                                    _.forEach(tempCPArr, function(obj) {
                                        if ( obj.name == "Traveller Rating" ){
                                            that.createFilter(chunkyFilterMap[obj.name.replace(/\s/, '').trim().toLowerCase()], 'checkbox')  
                                            if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' )){
                                                that.createFilter('lolfilter', 'checkbox');
                                            }   
                                            if ( window.showTags ) {
                                                that.createFilter('tagsFilter', 'checkbox');
                                            }
                                            that.createFilter('deals', 'checkbox');    
                                            that.createFilter('payAtHotel', 'checkbox');
                                            that.createFilter('freeCancellation', 'checkbox');    
                                            that.createFilter('showLocationHotels', 'checkbox');
                                            if (parseInt(CT.cache[CT.settings.currentTab].searchParams.all.adults) + parseInt(CT.cache[CT.settings.currentTab].searchParams.all.childs) >= 4){
                                                that.createFilter('tripVilla', 'checkbox');
                                            }
                                        } else if (obj.name.replace(/\s/, '').trim().toLowerCase() ==   "locality"){
                                            that.createFilter('locality', 'checkbox');
                                        } else if (obj.name.replace(/\s/, '').trim().toLowerCase() ==   "price") {
                                            if ( (window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b'){
                                                that.createFilter('priceFilter', 'checkbox');
                                            }
                                            else if ( (window.priceSlider && (CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") !== 'b' || window.countryCode !== 'in')) ){
                                                that.createFilter('price', 'slider');
                                            }
                                                                    
                                        } else
                                            that.createFilter(chunkyFilterMap[obj.name.replace(/\s/, '').trim().toLowerCase()], 'checkbox');    
                                    });
                                } else {
                                   // var copyHFD = Object.assign({}, hfd);
                                    var copyHFD = JSON.parse(JSON.stringify(hfd));
                                    Object.keys(copyHFD).forEach(function (k,v){
                                        var keyToCheck = copyHFD[v].name.replace(/\s/, '').trim().toLowerCase()
                                        if(keyToCheck == "Amenities ".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 4
                                        } else if (keyToCheck == "Traveller Rating".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 3
                                        } else if(keyToCheck == "Price".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 1
                                        } else if(keyToCheck == "Star Rating".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 2
                                        } else if(keyToCheck == "Property type".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 5
                                        } else if(keyToCheck == "Hotel chain".replace(/\s/, '').trim().toLowerCase()){
                                            copyHFD[v].uiOrder = 6
                                        }
                                    })
                                    var tempCPArr = _.sortBy(copyHFD, 'uiOrder');

                                    _.forEach(tempCPArr, function(obj) {
                                        if (obj.name == "Traveller Rating"){
                                            that.createFilter(chunkyFilterMap[obj.name.replace(/\s/, '').trim().toLowerCase()], 'checkbox');
                                            if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' )){
                                                that.createFilter('lolfilter', 'checkbox');
                                            } 
                                            if ( window.showTags ) {
                                                that.createFilter('tagsFilter', 'checkbox');
                                            } 
                                            that.createFilter('deals', 'checkbox');    
                                            that.createFilter('payAtHotel', 'checkbox');
                                            that.createFilter('freeCancellation', 'checkbox');    
                                            that.createFilter('showLocationHotels', 'checkbox')
                                            if (parseInt(CT.cache[CT.settings.currentTab].searchParams.all.adults) + parseInt(CT.cache[CT.settings.currentTab].searchParams.all.childs) >= 4){
                                                that.createFilter('tripVilla', 'checkbox');
                                            }
                                        } else if (obj.name.replace(/\s/, '').trim().toLowerCase() ==   "price") {
                                            
                                            if ( (window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b'){
                                                that.createFilter('priceFilter', 'checkbox');
                                            }
                                            else if ( (window.priceSlider && (CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") !== 'b' || window.countryCode !== 'in')) ){
                                                that.createFilter('price', 'slider');
                                            }
                                                                    
                                        } else
                                            that.createFilter(chunkyFilterMap[obj.name.replace(/\s/, '').trim().toLowerCase()], 'checkbox');    
                                    });
                                }
                            }
                        });
                    } else {
                        if ((window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b'){
                            this.createFilter('priceFilter', 'checkbox');
                        }
                        else if ( (window.priceSlider && (CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") !== 'b' || window.countryCode !== 'in')) ){
                            this.createFilter('price', 'slider');
                        }

                        this.createFilter('instantBooking', 'checkbox');
                        this.createFilter('roomType', 'checkbox');
                        this.createFilter('deals', 'checkbox');
                        this.createFilter('quickeys', 'checkbox');
                        this.createFilter('weSleep', 'checkbox');
                        //this.createFilter('popHotels', 'checkbox');
                        this.createFilter('payAtHotel', 'checkbox');
                        this.createFilter('freeCancellation', 'checkbox');
                        this.createFilter('showLocationHotels', 'checkbox')
                        if (parseInt(CT.cache[CT.settings.currentTab].searchParams.all.adults) + parseInt(CT.cache[CT.settings.currentTab].searchParams.all.childs) >= 4)
                            this.createFilter('tripVilla', 'checkbox');
                        this.createFilter('starFilter', 'checkbox');
                        this.createFilter('taStarRating', 'slider');
                        this.createFilter('locality', 'checkbox');
                        // this.createFilter('tagsSideFilter', 'checkbox');
                        this.createFilter('propertyType', 'checkbox');
                        this.createFilter('amenity', 'checkbox');
                    }

            }
        },



        events: {
            "click input[type='checkbox']": "fltData",
            "click input[type='radio']": "fltData",
            "click h5": "toggleFilter",
            "click .showOnly": "triggerShowOnly",
            "click .showAll": "triggerCheckboxShowAll",
            "click .filters__more": "triggerShowMoreAction",
            "click .action": "triggerShowMoreAction",
            "click .allDestinations": "triggerShowMoreAction",
            //"click .clearWeekendFilter" : "resetFilters",
            //TODO: remove events which are not necessary - karthik
            /*
            "click nav ul#tastar input[type='checkbox']" : "fltData", //TODO change id to class
            "click nav ul#star input[type='checkbox']" : "fltData",
            "click nav.amenities input[type='checkbox']" : "fltData",
            "click nav.propertyType input[type='checkbox']" : "fltData",
            "click ul.pois input[type='checkbox']" : "fltData",
            */
            //"click ul.airLine input[type='checkbox']" : "fltAirlineData",
            "change select.airLine": "fltAirlineData",
            "keyup input.searchByHotel": "hotelKeywordSearch",
            "click a.killCoachMark": "showFirstRunBanners",

            //"change #PriceSlider" : "priceFilter",
            "click .showLink": 'toggleMoreFilters',
            "filters_reset": 'ShowAllData',
            "triggerFilters": 'fltData',
            "click div.personalized small a.weak": "DismissFilterMessage",
            "click div.personalized small a.fRight": "showFilterWhatThisMessgae",

            "filters_update": "update",
            "filters.create": "create",
            "filter.repaint": "triggerFilterRepaint",
            "filter.clearWeekendFilter": "resetFilters",
            "filter.repaintFilterCount": "repaintFilterCount",
            "keydown p.smallSearch input": "smallSearchKeypress"
        },

        subscriptions: {
            'disableLhrFilter': 'disableLhrFilter'
        },
        smallSearchKeypress: function(e){
            //if the key pressed is equal to enter, do not show location popup for hotels in india
            if(e.keyCode === 13){
                var paramsHash = CT.cache[CT.settings.currentTab].searchParams.all;
                if(paramsHash.country.toLowerCase() === "in" && CT.isLocationEnabled){
                    e.preventDefault();
                }
            }
        },
        triggerFilterRepaint: function(e, filterName, settings, selector, destroyExisting) {
            
            var deserializeData, tmp;
            var serializedData = this.$el.find('.filtersForm').serialize();

            settings = settings || {};

            //nope
            this.updateFilter(filterName, settings, selector, destroyExisting);
            if (filterName == 'price') {
                deserializeData = _.deserialize(serializedData, hashModifiers);
                tmp = deserializeData.price;
                if (tmp && tmp != '') {
                    //this.$el.find("." + filterName).last().slider("option", "values", [tmp.split("-")[0], tmp.split("-")[1], false]);
                    this.$el.find("." + filterName).last().priceslider({
                        min: tmp.split("-")[0],
                        max: tmp.split("-")[1],
                        isReady: true
                    });
                    this.$el.find('input[name="' + filterName + '"]').val(tmp);
                }
            }
        },



        triggerShowMoreAction: function(e) {
            var $element = $(e.target);

            e.preventDefault();
            switch ($element.attr('data-action')) {
                case 'locations':
                    CT.utils.showModalDialog('/hotelstatic/includes/modal_localities.shtml', '400px', '550px', true, false);
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_LocationAll', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_showAllLoc',
                        "filterValue": CT.cache[CT.settings.currentTab].paramsForGA,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                    break;
                case 'destinations':
                    //CT.utils.showModalDialog('/hotelstatic/includes/modal_destinations.shtml','400px','550px',true,false);
                    var $topEleMap = this.$el.find(".destinations").find("li.topDestinations");
                    var destCount = this.$el.find(".destinations").find("li label").length - this.$el.find(".destinations").find("li label.disabled").length;
                    if ($element.hasClass("shwMore")) {
                        $element.parents("nav").find("li.moreDestinations").fadeIn();
                        $element.html("- View less destinations")
                        $element.removeClass("shwMore").addClass("shwLess");
                        //$(document.body).trigger("sticky_kit:recalc");
                        CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Destinations_Show_More', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    } else {
                        $element.parents("nav").find("li.moreDestinations").hide()
                        $element.html("+ View " + destCount + " more destinations")
                            //$(document.body).trigger("sticky_kit:recalc");
                        $element.html(CT.messages.moreDestinations)
                        $element.removeClass("shwLess").addClass("shwMore");
                        //  window.scrollTo(0, 0)
                        //this.$el.trigger("sticky_kit:detach");
                        //this.$el.trigger("sticky_kit:destroy");
                        //this.$el.stick_in_parent({offset_top:55});
                        CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Destinations_Show_Less', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    }
                    break;
                    default: 
                        var filteName = "More_" + $element.attr('data-filter-name');
                        var value = $element.hasClass('shwMore') ? 'Y' : 'N';
                        // var filterCleared = {};
                        // filterCleared[filteName] = value;
                        if($element.hasClass('shwMore')){
                            $element.html('- show less').removeClass('shwMore');
                            $element.parent().find('.shwLess').show().removeClass('shwLess').addClass('shwMore');
                        } else {
                            $element.parent().find('.shwMore').hide().removeClass('shwMore').addClass('shwLess');
                            $element.html('+ show more').addClass('shwMore')
                        }
                   
            }
        },

        toggleMoreFilters: function(e) {
            if ($(e.target).html() === CT.messages.hotel.moreFilters) {
                $(e.target).hide();
            } else {
                this.$el.find('.showLink').show();
            }
            this.$el.find('.moreFilters').toggle();
        },

        //dimiss the filter personalized message
        DismissFilterMessage: function() {
            this.$el.find(".personalized").hide();
        },



        //shows the filters personalized box [what's this message] -- not using....
        showFilterWhatThisMessgae: function() {
            this.$el.find("#preCheckFilters").toggle();
            //TODO: later. move all toggle blocks to a generic widget
        },



        cityCode: function(json) {
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
            var cityCode = json.city;
            var nearByCityCodes = '';
            CT.cache[CT.settings.currentTab].city_code = cityCode;
            if (CT.app !== 'dp') {
                //this.$el.find('input.localSearch').attr('data-url', '/places/hac?fcyids=' + cityCode + '&fih=0&s=').autocomplete();
                _.forEach(CT.cache[CT.settings.currentTab].ncm, function(name, code) {
                    nearByCityCodes += ',' + code;
                });
                CT.cache[CT.settings.currentTab].nearByCityCodes = nearByCityCodes;
                $currentTab.find('input.ui-autocomplete-input').autocomplete({
                    url: "//platform"+(location.hostname.split('.')[0].indexOf('qa')>-1?'qa2':'')+".cleartrip.com/hotels/auto-suggest/v3?c="+(window.countryCode?window.countryCode.toUpperCase():'')+'&fcyids=' + cityCode + nearByCityCodes + '&fic=0&s='
                });
            }
            return true;
        },



        getFilterFormData: function() {
            return _.deserialize(this.$el.find('form').serialize(), hashModifiers);
        },

        /* not necessary unless it breaks something - coded this in updateshowcount function in searchresult.js - karthik
        showAllHotelsLink : function() {
            var flag = false, flagChkBox = false;var $currentTabView = $('#ResultContainer_'+CT.settings.currentTab)
            var checkBoxVal = ['am', 'pt', 'loc'];
            $.each(this.getFilterFormData(), function(index, value) {
                if (value.length > 0) {
                    if (value[0] !== undefined)
                        flag = true;
                }

                if ((_.indexOf(checkBoxVal, index)) && value.length > 0)
                    flagChkBox = true;
            });

            if (flag == true) {
                if (CT.cache[CT.settings.currentTab].filterValues.showall.length === 0) {
                    if (CT.app === 'dp')
                        $currentTabView.find('.primaryBar a.resetLink').show();
                    else
                        $currentTabView.find('.primaryBar a.resetLink').show();
                    if (flagChkBox == true && CT.app !== 'dp')
                        $currentTabView.find('.personalized').show();
                    CT.cache[CT.settings.currentTab].filterValues.showall[0] = true;
                }
            }
            return this;
        },
        */

        triggerAllFilters: function(settings) {
            this.fltData(null, settings);
            this.fltLocationData(settings);
            if (CT.app !== 'dp')
                this.toolBarFltData(null, settings);
        },

        sendFltObj: function(settings) {
            CT.utils.showLoader('hotel_fs');
            return this;
        },


        hotelKeywordSearch: function(e, val) {
            var _value = val || $(e.target).val();

            $(this.$el.find('.hotelName')).val(_value);
            CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Findbar', CT.cache[CT.settings.currentTab].paramsForGA, '100');

            currentFilterEle.push('hotelName');
            CT.cache[CT.settings.currentTab].recentFilterData = {
                "prevFilterEle": [],
                "currentFilterEle": currentFilterEle,
                "prevSerializedData": [],
                "currentSerializedData": []
            }
            this.fltData('', '');
            CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                "filterType": 'filter_byName',
                "filterValue": _value,
                "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
            });
        },
        resetFilters: function(e, eleList, block) {
            
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
            // var eleList = $(e.target).closest("a").attr("data-filterPopUp").split("|");
            for (var k = 0; k < eleList.length; k++) {
                switch (eleList[k]) {
                    case 'distanceWrapper':
                        //resetSliders("hrsSlider" , $(e.target).closest("a"))
                        this.$el.find('[name="hrsFilterSlider"]').val('0-10')
                        this.$el.find(".hrsFilterSlider.rangeSlider").find('.left').css({
                            'left': 0
                        })
                        this.$el.find(".hrsFilterSlider.rangeSlider").find('.right').css({
                            'left': '100%'
                        })
                        this.$el.find(".hrsFilterSlider.rangeSlider").find('.selection').css({
                            'left': 0,
                            'width': '100%'
                        })
                        var tmp = $('.hrsFilterSlider').closest('.sideBlock');
                        tmp.find('.displayFilterValue .fLeft').html("Upto 10h drive");
                        $currentTab.find(".distanceFilterButton small").html("Upto 10h drive")
                        break;
                    case 'destinationsFilterWrapper':
                        //resetCheckBox("destinations" , $(e.target).closest("a"))
                        $.each(this.$el.find('.destinations input'), function(index1, value1) {
                            $(value1).attr('checked', false).parent(); //.removeClass('marked');
                            $(value1).closest("label").removeClass("selected")
                        })
                        break;
                    case 'priceFilterWrapper':
                        //resetSliders("price" , $(e.target).closest("a"))
                        
                        CT.settings[CT.app].filter['price'].min = CT.cache[CT.settings.currentTab].filterValues.priceMinMax.min;
                        CT.settings[CT.app].filter['price'].max = CT.cache[CT.settings.currentTab].filterValues.priceMinMax.max;
                        this.$el.find(".price.rangeSlider").find('.left').css({
                            'left': 0
                        })
                        this.$el.find(".price.rangeSlider").find('.right').css({
                            'left': '100%'
                        })
                        this.$el.find(".price.rangeSlider").find('.selection').css({
                            'left': 0,
                            'width': '100%'
                        })
                        this.updateFilter('price', {
                            min: CT.settings[CT.app].filter['price'].min,
                            max: CT.settings[CT.app].filter['price'].max,
                            name: 'price'
                        }, null, true)
                        this.$el.find('[name="price"]').val('')
                        break;
                    case 'taFilterWrapper':
                        CT.settings[CT.app].filter['taStarRating'].min = 1;
                        this.$el.find(".taStarRating.rangeSlider").find('.left').css({
                            'left': 0
                        })
                        this.$el.find(".taStarRating.rangeSlider").find('.right').css({
                            'left': '100%'
                        })
                        this.$el.find(".taStarRating.rangeSlider").find('.selection').css({
                            'left': 0,
                            'width': '100%'
                        })
                        this.updateFilter('taStarRating', null, null, true)
                        this.$el.find('[name="taStarRating"]').val('')
                            //resetSliders("taFilter" , $(e.target).closest("a"))
                        break;
                    case 'experianceFilterWrapper':
                        //resetCheckBox("destinationsTheme" , $(e.target).closest("a"))
                        $.each(this.$el.find('.destinationsTheme input'), function(index1, value1) {
                            $(value1).attr('checked', false).parent(); //.removeClass('marked');
                            $(value1).closest("label").removeClass("selected")
                        })
                        break;
                    case 'propertyFilterWrapper':
                        //resetCheckBox("hotelsTheme" , $(e.target).closest("a"))
                        $.each(this.$el.find('.hotelsTheme input'), function(index1, value1) {
                            $(value1).attr('checked', false).parent(); //.removeClass('marked');
                            $(value1).closest("label").removeClass("selected")
                        })
                        break;

                }
            }
            $(block).removeClass("setFilterButton activeFilterButton popUpShown");
            $currentTab.find(".weekendFilterPopup").hide();
            this.fltData();
        },

        removeMark: function() {
            
            var _check = {
                "propertyType": this.$el.find('.propertyType input'),
                "roomType": this.$el.find('.roomType  input:checked'),
                "nearByCities": this.$el.find('.nearByCities input'),
                "starFilter": this.$el.find(".starFilter input")
            }
            var _removeCheck = {
                    "locality": this.$el.find('.locality input:checked'),
                    "amenity": this.$el.find('.amenity  input:checked'),
                    "deals": this.$el.find('.deals  input:checked'),
                    "quickeys": this.$el.find('.quickeys  input:checked'),
                    // "popHotels": this.$el.find('.popHotels  input:checked'),
                    "weSleep": this.$el.find('.weSleep  input:checked'),
                    "payAtHotel": this.$el.find('.payAtHotel  input:checked'),
                    "showLocationHotels": this.$el.find('.showLocationHotels  input:checked'),
                    "instantBooking": this.$el.find('.instantBooking  input:checked'),
                    "freeCancellation": this.$el.find('.freeCancellation  input:checked'),
                    "tripVilla": this.$el.find('.tripVilla  input:checked'),
                    "destinations": this.$el.find('.destinations input'),
                    "destinationsTheme": this.$el.find('.destinationsTheme input'),
                    "hotelsTheme": this.$el.find('.hotelsTheme input'),
                    "priceFilter": this.$el.find('.priceFilter input:checked')
                }
                //For ChunkyFilters remove starRating,tarating,propertyType,amenities
                
            if (window.chunkyFiltersEnabled) {

                _removeCheck.taStarRating = this.$el.find(".taStarRating input");
                _removeCheck.chain = this.$el.find(".chain input");
                _removeCheck.starFilter = this.$el.find(".starFilter input")
                _removeCheck.propertyType = this.$el.find('.propertyType input');
                _removeCheck.priceFilter = this.$el.find('.priceFilter input');
                //remove from Check
                delete _check.starFilter;
                delete _check.propertyType;
            }
            if (window.altFilters == "true") {
                var removeInputValue = ["hotelName", "destinationsTheme"]
            } else {
                var removeInputValue = ["hotelName"]
            }
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab)
            
            $.each(_removeCheck, function(index, value) {
                $.each(value, function(index1, value1) {
                    $(value1).attr('checked', false).parent(); //.removeClass('marked');
                    $(value1).closest("label").removeClass("selected")
                })
            });
            $.each(_check, function(index, value) {
                $.each(value, function(index1, value1) {
                    $(value1).attr('checked', true).parent(); //.addClass('marked');
                })
            });

            _.forEach(removeInputValue, function(eachInput) {
                this.$el.find('input[name=' + eachInput + ']').val('');
            }, this);

            if (window.altFilters == "true") {
                $currentTab.find('.altFiltersForm input').removeAttr("checked");
                $currentTab.find('.altFiltersForm label').removeClass("selected");
            }

            //remove the value set in smallSearch in sort bar
            $currentTab.find('.smallSearch input, .mapViewSearch input').val('');

            return this;
        },



        resetSliders: function(obj, taMin, taMax) {
            
            var filters = CT.cache[CT.settings.currentTab].filterValues,
                priceMin = (obj && obj.price.length > 0) ? obj['price'][0] : filters.priceMinMax.min,
                priceMax = (obj && obj.price.length > 0) ? obj['price'][1] : filters.priceMinMax.max,
                taMin = taMin ? taMin : 1,
                taMax = taMax ? taMax : 5,
                sliderObj = [{
                    "wrapper": ".taStarRating.rangeSlider",
                    "container": ".taStarRating",
                    "min": taMin,
                    "max": taMax
                }, {
                    "wrapper": ".price.rangeSlider",
                    "container": ".price",
                    "min": priceMin,
                    "max": priceMax
                }];
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
            //over writing slider values manually
            CT.settings[CT.app].filter['price'].min = priceMin;
            CT.settings[CT.app].filter['price'].max = priceMax;
            CT.settings[CT.app].filter['taStarRating'].min = 1;

            //over wrting slider styles manually
            _.forEach(sliderObj, function(val, index) {
                this.$el.find(val.wrapper).find('.left').css({
                    'left': 0
                })
                this.$el.find(val.wrapper).find('.right').css({
                    'left': '100%'
                })
                this.$el.find(val.wrapper).find('.selection').css({
                    'left': 0,
                    'width': '100%'
                })
            }, this);

            //setting price to null to make new filter on filter reset as it got destroyed
            CT.cache.tabsMap[CT.settings.currentTab].price = null;
            this.updateFilter('price', {
                min: priceMin,
                max: priceMax,
                name: 'price'
            }, null, true)

            this.updateFilter('taStarRating', null, null, true)
            if (window.chunkyFiltersEnabled) {
                // this.$el.find('[name="taStarRating"]')[0].setAttribute("checked",true);
                this.$el.find('[name="price"]').val('')
            } else {
                this.$el.find('[name="taStarRating"]').val('')
                this.$el.find('[name="price"]').val('')
            }

            if (CT.subProd == "wg" && window.altFilters == 'false') {
                this.$el.find('[name="hrsFilter"]').val('0,10')
                this.$el.find(".destinations").find("li.moreDestinations").hide()
                    //filter.hideDestinations({value:[0,10]})
                $currentTab.find('.distanceSlider .left').css({
                    'left': 0
                })
                $currentTab.find('.distanceSlider .right').css({
                    'left': '100%'
                })
                $currentTab.find('.distanceSlider .selection').css({
                    'left': 0,
                    'width': '100%'
                })
                $currentTab.find(".distanceSlider h5 span").html("Drive time: upto 10h");
                $currentTab.find(".distanceSlider .left").html("");
                $currentTab.find(".distanceSlider .right").html("10h");
                //  $currentTab.find(".distanceSlider .rangeSlider").priceslider(CT.settings[CT.app][CT.subProd].hrsSliderOptions)
            } else if (CT.subProd == "wg" && window.altFilters == 'true') {
                /*this.$el.find('[name="hrsFilterSlider"]').val('0-10')
                this.$el.find(".hrsFilterSlider.rangeSlider").find('.left').css({'left':0})
                this.$el.find(".hrsFilterSlider.rangeSlider").find('.right').css({'left':'100%'})
                this.$el.find(".hrsFilterSlider.rangeSlider").find('.selection').css({'left':0,'width':'100%'})
                var tmp = $('.hrsFilterSlider').closest('.block');
                    tmp.find('.displayFilterValue .fLeft').html("Upto 10h drive");
                    $currentTab.find(".distanceFilterButton small").html("Upto 10h drive")*/
                this.$el.find('[name="hrsFilter"]').val('0,10')
                this.$el.find(".destinations").find("li.moreDestinations").hide()
                    //filter.hideDestinations({value:[0,10]})
                $currentTab.find('.distanceSliderSec .left').css({
                    'left': 0
                })
                $currentTab.find('.distanceSliderSec .right').css({
                    'left': '100%'
                })
                $currentTab.find('.distanceSliderSec .selection').css({
                        'left': 0,
                        'width': '100%'
                    })
                    //$currentTab.find(".distanceSlider h5 span").html("Drive time: upto 10h");
                    //$currentTab.find(".distanceSlider .left").html("");
                    //$currentTab.find(".distanceSlider .right").html("10h");

            }

            return this;
        },



        undoLastFilter: function() {
            if (CT.cache[CT.settings.currentTab].recentFilterData &&
                CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.length == 0 &&
                $("#ResultContainer_" + CT.settings.currentTab).find(".tagList li.active").length > 0 &&
                window.showTags == true) {
                $("#ResultContainer_" + CT.settings.currentTab).find(".tagList li.active").each(function(ele) {
                    CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.push($(this).attr("data-tagid"))
                })
            }
            this.disableLhrFilter(false);
            if (CT.cache[CT.settings.currentTab].recentFilterData && CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle)
                var _currFilteredEle = CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle[CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.length - 1]
            // if(_currFilteredEle =="showFewFilter"){
            //     CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.splice([CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.length - 1])
            //     var _currFilteredEle = CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle[CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.length - 1]
            // }
            else
                var _currFilteredEle = "hotelName";
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                tmp;

            if (_currFilteredEle === "badgeFilter") {
                $currentTab.find("a.allHotels").last().click();
                delete CT.cache[CT.settings.currentTab].recentFilterData;
            } else if (_currFilteredEle === "hotelName") {
                $currentTab.find(".filtersForm .hotelName").val('');
                $currentTab.find(".secondaryBar .smallSearch input, .mapViewSearch input").val('');
                delete CT.cache[CT.settings.currentTab].recentFilterData;
                CT.fire("filters.apply");
            } else {

                var _prevSerializedData = CT.cache[CT.settings.currentTab].recentFilterData.prevSerializedData[CT.cache[CT.settings.currentTab].recentFilterData.prevSerializedData.length - 1];
                var _currSerializedData = CT.cache[CT.settings.currentTab].recentFilterData.currentSerializedData[CT.cache[CT.settings.currentTab].recentFilterData.currentSerializedData.length - 1];
                //var _prevFilteredEle = CT.cache[CT.settings.currentTab].recentFilterData.prevFilterEle[CT.cache[CT.settings.currentTab].recentFilterData.prevFilterEle.length - 1];
                var remainingEle = [],
                    areaEle;


                if (_prevSerializedData && !(_prevSerializedData[_currFilteredEle] === undefined)) {
                    remainingEle = _prevSerializedData[_currFilteredEle];
                }
                

                if ((_currFilteredEle === "taStarRating" && CT.settings.hotel.filter.taStarRating.widget == "slider") || _currFilteredEle === "price") {
                    if (!_prevSerializedData || _prevSerializedData[_currFilteredEle] == "") {
                        if (!_prevSerializedData)
                            _prevSerializedData = [];
                        if (_currFilteredEle === "taStarRating") {
                            _prevSerializedData[_currFilteredEle] = "1-5";
                        } else if (_currFilteredEle === "price") {
                            tmp = CT.cache[CT.settings.currentTab].filterValues.priceMinMax;
                            _prevSerializedData[_currFilteredEle] = tmp.min + '-' + tmp.max;
                        }
                    }

                    var ele;
                    if (_currFilteredEle === "price") {
                        ele = $('#ResultContainer_' + CT.settings.currentTab).find("." + _currFilteredEle).last().slider("option", {
                            "trigger": false,
                            "values": [_prevSerializedData[_currFilteredEle].split("-")[0], _prevSerializedData[_currFilteredEle].split("-")[1]]
                        }).slider("option", {
                            "trigger": true
                        })
                    } else {
                        ele = $('#ResultContainer_' + CT.settings.currentTab).find("." + _currFilteredEle).last().slider("option", {
                            "trigger": false,
                            "value": _prevSerializedData[_currFilteredEle].split("-")[0]
                        }).slider("option", {
                            "trigger": true
                        })
                    }

                    $('#ResultContainer_' + CT.settings.currentTab).find('.filtersForm').find('input[name="' + _currFilteredEle + '"]').val(_prevSerializedData[_currFilteredEle].split("-")[0] + '-' + _prevSerializedData[_currFilteredEle].split("-")[1])
                } else if (_currFilteredEle && _currFilteredEle.indexOf("tag")) {
                    $('#ResultContainer_' + CT.settings.currentTab).find("." + _currFilteredEle + " input").removeAttr('checked');
                    $('#ResultContainer_' + CT.settings.currentTab).find("." + _currFilteredEle).removeClass("active")

                } else {
                    
                    var ele = $('#ResultContainer_' + CT.settings.currentTab).find("." + _currFilteredEle).last()

                    ele.find('input').removeAttr('checked');

                    _.each(remainingEle, function(value) {
                        ele.find('input[value="' + value + '"]').attr('checked', 'checked');
                    });

                    if (_currFilteredEle == 'locality')
                        $currentTab.find('.smallSearch input, .mapViewSearch input').val('');
                    //var ele = $('#ResultContainer_' + CT.settings.currentTab).find("."+_currFilteredEle).last().find('input[value="' + remainingEle[0] + '"]')
                    //ele.is(":checked")?ele.removeAttr("checked"):ele.attr("checked","checked");
                }
                if ($('#ResultContainer_' + CT.settings.currentTab).find('input[name=starFilter]:checked').length == 0) {
                    var el = $('#ResultContainer_' + CT.settings.currentTab).find('input[name=starFilter]')[0]
                    //$(el).parents().find('a.showAll').hide()
                    this.showHideShowAll();
                }
                var areadistance = ""
                if (CT.masterJson.get().clni &&
                     CT.masterJson.get().clni.clat &&
                     CT.masterJson.get().clni.clng &&
                     CT.isLocationEnabled == true && 
                      (CT.cache[CT.settings.currentTab].autoCompleteLatitude != "" && CT.cache[CT.settings.currentTab].autoCompleteLatitude != undefined)) {
                    var cityLat = CT.masterJson.get().clni.clat
                    var cityLng = CT.masterJson.get().clni.clng
                    var areadistance = CT.utils.helperFunctions.getDistanceFromLatLonInKm(CT.cache[CT.settings.currentTab].autoCompleteLatitude, CT.cache[CT.settings.currentTab].autoCompleteLangitude, cityLat, cityLng)
                }
                if (areadistance != "" && areadistance > 50 && (CT.cache[CT.settings.currentTab].autoCompleteLatitude != "" || CT.cache[CT.settings.currentTab].autoCompleteLangitude != "")) {
                    $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked', false)
                    CT.cache[CT.settings.currentTab].plceselected == false
                    CT.cache[CT.settings.currentTab].arealDistancegreater = true
                } else {
                    CT.cache[CT.settings.currentTab].arealDistancegreater = false
                }
                CT.fire("filters.apply");
                if (_currFilteredEle && _currFilteredEle.indexOf('_tag') > 0 && window.showTags == true) {
                    CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.pop();
                }
                prevFilterEle.pop();
                currentFilterEle.pop()
                prevSerializedData.pop();
                currentSerializedData.pop();
                CT.cache[CT.settings.currentTab].recentFilterData.currentSerializedData.push(_.deserialize(this.$el.find('form').serialize(), hashModifiers))
            }
            if (window.showTags && $("#ResultContainer_" + CT.settings.currentTab).find(".tagList li.active").length == 0) {
                $("#ResultContainer_" + CT.settings.currentTab).find(".tagBoxClear").hide()
            }
        },

        clickBadgeFilter: function(val) {
            /*
            var badgeObj = {
                "allHotels" : 1,
                "quickKeys" : 2,
                "staffPicks" : 3,
                "shortListed" : 4
            };
            var badgeVal = (val) ? (badgeObj[val] ? badgeObj[val] : 1) : 1;
            */
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);

            // TODO: cache the jquery objects once selected from jquery selector (.toolBarControls li, ul.toolBarControls)
            $currentTab.find('.badgeFilter li').removeClass('current');
            $currentTab.find('.badgeFilter li:first').addClass('current');
            this.$el.find('[name="badgeFilter"]').val(val)
            if ($currentTab.find('.badgeFilter li a').hasClass("onlyAirBnb")) {
                var filterArrShown = CT.cache[CT.settings.currentTab].filtersShown;
                var hideSorters = CT.settings[CT.app].airBnbSortersToHide;
                var airBnbFilters = CT.settings[CT.app].airBnbFilters
                for (var k = 0; k < airBnbFilters.length; k++) {
                    $("." + airBnbFilters[k]).closest(".sideBlock").hide()
                }
                for (var k = 0; k < filterArrShown.length; k++) {
                    $("." + filterArrShown[k]).closest(".sideBlock").show()
                }

                for (var k = 0; k < hideSorters.length; k++) {
                    $("." + hideSorters[k]).closest("li").show()
                }
            }
            return this;
        },

        ShowAllData: function() {
            this.removeMark().resetSliders(null).clickBadgeFilter(null);
            this.$el.find('.showAll').hide();
            CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_ShowAll', CT.cache[CT.settings.currentTab].paramsForGA, '100');
            this.fltData();
        },

        markCheckBoxes: function(val1, val2) {
            var fObj = {
                "star": this.$el.find('#star input:checked'),
                "taStar": this.$el.find('#tastar input:checked'),
                "loc": this.$el.find('.pois input'),
                "amenity": this.$el.find('.amenities input:checked'),
                "pt": this.$el.find('.propertyType input:checked'),
                "price": this.$el.find('.priceFilter input:checked'),
            }
            for (var j = 0; j < fObj[val1].length; j++) {
                var eId = $(fObj[val1][j]).attr('id');
                if (val1 === 'am') {
                    if (_.indexOf(val2, (eId + ":not('.amNa')")) >= 0)
                        $(fObj[val1][j]).attr('checked', true);
                } else {
                    if (val1 === 'loc')
                        eId = eId.replace(/_/g, ' ');
                    if (_.indexOf(val2, eId) >= 0)
                        $(fObj[val1][j]).attr('checked', true);
                }
            }
            return this;
        },

        /*undoLastFilter : function() {
            var $ctab = CT.cache[CT.settings.currentTab].filterValues.undoFilterObj;
            if (CT.app !== 'dp')
                this.clickBadgeFilter($ctab.badgeFilter);

            this.removeMark().resetSliders($ctab).markCheckBoxes('pt', $ctab.pt).markCheckBoxes('am', $ctab.am).markCheckBoxes('loc', $ctab.extra.loc_id);
            CT.applyTheseFilters = $.extend(true, {}, CT.cache[CT.settings.currentTab].filterValues.undoFilterObj);
            this.$el.trigger('filters.apply', [CT.settings[CT.app].filters, CT.applyTheseFilters]);
        },*/

        calcCheapfareFilghts: function(flobj, fcode) {
            var _on = flobj.mapping['onward'],
                _re = flobj.mapping['return'],
                selOnAr = [],
                selOnfrArr = [],
                selOnSplfrArr = [],
                selRtAr = [],
                selRtfrArr = [],
                selRtSplfrArr = [],
                onwardIndex, returnIndex, isCombo = false;

            //helper function
            var filterAr = function(arr, arrMainObj, index, type) {
                _.forEach(arr, function(val, ij) {
                    if (_.indexOf(fcode, val.oa) >= 0) {
                        if (type === 'onward')
                            selOnAr.push({
                                "i": index,
                                'obj': arrMainObj
                            });
                        else
                            selRtAr.push({
                                "i": index,
                                'obj': arrMainObj
                            });
                        return false;
                    }
                });
            };
            var _updatePrice = function(val, index, type) {
                    if (type === 'onward')
                        selOnfrArr.push({
                            "i": val.i,
                            "fr": val.obj.fare.dfd ? CT.FlightSolution.getCheapFareSelected(val.obj, false).pr : CT.FlightSolution.getCheapFareSelected(val.obj, true).pr
                        });
                    else
                        selRtfrArr.push({
                            "i": val.i,
                            "fr": val.obj.fare.dfd ? CT.FlightSolution.getCheapFareSelected(val.obj, false).pr : CT.FlightSolution.getCheapFareSelected(val.obj, true).pr
                        });
                    if (val.obj.fare === 'SPLRT') {
                        if (type === 'onward')
                            selOnfrArr.push({
                                "i": obj.i,
                                "fr": CT.FlightSolution.getCheapFareSelected(val.obj, true).pr
                            });
                        else
                            selRtSplfrArr.push({
                                "i": obj.i,
                                "fr": CT.FlightSolution.getCheapFareSelected(val.obj, true).pr
                            });
                    }
                }
                //filtering the particular airline.
            _.forEach(_on, function(val, index) {
                filterAr(val.content, val, index, 'onward');
            });
            _.forEach(_re, function(val, index) {
                filterAr(val.content, val, index, 'return');
            });

            //getting the price for solution
            _.forEach(selOnAr, function(val, index) {
                _updatePrice(val, index, 'onward');
            });
            _.forEach(selRtAr, function(val, index) {
                _updatePrice(val, index, 'return');
            });

            //sorting by price
            selOnfrArr = selOnfrArr.sort(function(a, b) {
                return a.fr > b.fr;
            });
            if (selOnSplfrArr.length > 0)
                selOnSplfrArr = selOnSplfrArr.sort(function(a, b) {
                    return a.fr > b.fr;
                });

            selRtfrArr = selRtfrArr.sort(function(a, b) {
                return a.fr > b.fr;
            });
            if (selRtSplfrArr.length > 0)
                selRtSplfrArr = selRtSplfrArr.sort(function(a, b) {
                    return a.fr > b.fr;
                });

            if (selOnSplfrArr.length === 0 && selRtSplfrArr.length === 0) { //special fare not available
                onwardIndex = (selOnfrArr.length === 0) ? undefined : selOnfrArr[0].i;
                returnIndex = (selRtfrArr.length === 0) ? undefined : selRtfrArr[0].i;
            } else if (selOnfrArr.length === 0 && selRtfrArr.length === 0) { //normal fare not available
                if (selOnSplfrArr.length !== 0 && selRtSplfrArr.length !== 0) {
                    isCombo = CT.FlightSolution.isComboCombination(selOnSplfrArr[0].i, selRtSplfrArr[0].i, CT.masterJson.get().fl);

                    if (isCombo) { //send spl indexes
                        onwardIndex = selOnSplfrArr[0].i;
                        returnIndex = selRtSplfrArr[0].i;
                    } //else onwardIndex & returnIndex will be undefiend.
                }
            } else {
                /**
                 * special and normal fare available
                 * check if special fares are combinable,if not send normal cheap flight indexes,if yes send spl cheap flights indexes
                 * @todo - check spl flights cheaper or normal flight fares
                 */
                isCombo = CT.FlightSolution.isComboCombination(selOnSplfrArr[0].i, selRtSplfrArr[0].i, CT.masterJson.get().fl);
                if (isCombo) { //send spl indexes
                    onwardIndex = selOnSplfrArr[0].i;
                    returnIndex = selRtSplfrArr[0].i;
                } else { //send normal
                    onwardIndex = selOnfrArr[0].i;
                    returnIndex = selRtfrArr[0].i;
                }
            }

            return [onwardIndex, returnIndex, isCombo]; //TODO: convert the return value into an object later.
        },

        renderBeingPicky: function() {
            //@todo make message dynamic and call logic
            var $viewController = $('#ResultContainer_' + CT.settings.currentTab + ' .viewController'),
                html
            html = CT.to_html('beingTopickyTmpl', CT.messages.hotel.contentObj);
            $viewController.append(html);
        },

        disableLhrFilter: function(operation) {
            var disabled, sliderOp, $elem = $("#ResultContainer_" + CT.settings.currentTab).find("aside.left");
            $elem.addClass("disabled");
            $inputElem = $elem.find(":input");
            _.forEach($inputElem, function(el, idx) {
                $el = $(el);
                if ($el.is(':disabled') == false && !$el.hasClass("disabled")) {
                    $el.addClass("disabled");
                    $el.attr("disabled", operation);
                }

                if (operation == false && $el.hasClass("disabled")) {
                    $el.attr("disabled", operation);
                    $el.removeClass("disabled")
                }
            });

            $linkElem = $elem.find("a");
            _.forEach($linkElem, function(ahrEl, idx) {
                $ahrEl = $(ahrEl);
                if (operation == false) {
                    $ahrEl.unbind("click");
                } else {
                    $ahrEl.bind("click", function(e) {
                        return false;
                    });
                }
            });

            disabled = $elem.find(".rangeSlider").slider("option", "disabled");
            sliderOp = (operation == true) ? true : false;
            $elem.find(".rangeSlider").slider("option", "disabled", sliderOp);
        },

        /**
         * updateFilters - is used to preset the filters from url query parameters
         * @param params filter params hash , to be preset which is derived from the url parameter.
         * @returns filter
         */
        updateFilters: function(paramsObj) {

            var self = this;
            var hasSeocondryFilters = false;
            //TODO: prem- hotel shouldnt be hardcoded , it should be ct.app
            var filterTypes = CT.settings.hotel.filters.types;

            //$(".taStarRating.rangeSlider").last().find(".priceFilterRestraint").slider("option","values",[3,5])

            //var secondryFilterList = ["amenity", "propertyType"];
            var secondryFilterList = [];

            // filter inside secondry list; list contains the filter.id of the filterTypes.chkBox and filterTypes.slider filters

            var templates = {
                'area': "#poiChkTemplate"
            };

            var paramToTabsMap = {
                "shortlisted": "shortListed"
            };

            var prefillTypes = { //logics to prefil the filters based on filter type.
                chkBox: function(filter) {
                    var checksMap = {
                        "common": function(filter, paramsObj, chkBox) {
                            return paramsObj[filter.id] && _.indexOf(paramsObj[filter.id], chkBox.value) != -1;
                        }

                        /*
                         * not necessary - karthik
                        "locality" : function(filter, paramsObj, chkBox) {
                            return paramsObj[filter.id] && _.indexOf(paramsObj[filter.id], chkBox.value + ":" + $(chkBox).data("location")) != -1;
                        }
                        */
                    };
                    //TODO:: Locality Filter :: 
                    if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                        var $chkBoxes = self.$el.find(filter.el + ' input[type="checkbox"]');    
                    }
                    if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                        /*
                        if (filter.dynamic) {
                            // create checkbox
                            
                            var f_list = _.difference(paramsObj[filter.id], $.map($chkBoxes, function(chkBox) {
                                return chkBox.value + ":" + $(chkBox).data("location");
                            }));

                            $(f_list).each(function(i, f_value) {
                                var f_values = f_value.split(":");
                                var data = {
                                    "ldata" : f_values[0],
                                    "id" : f_values[0].replace(/\s+/g, '_'),
                                    "value" : f_values[0],
                                    "extra" : "data-location=" + f_values[1]
                                };
                                self.render($(templates[filter.id]), self.$el.find(filter.el + ' ul.list').first(), data, null, "append");
                                });
                            //TODO:: Locality Filter :: Uncoment Below Method    
                            function getAreaPoiList(paramArray, type) {
                                var list = {},
                                    tmp;
                                list.data = [];
                                if (type == 'area')
                                    tmp = CT.utils.searchAreaPoi.findAreaHotelCnt;
                                else
                                    tmp = CT.utils.searchAreaPoi.findPOIHotelCnt;

                                _.forEach(paramArray, function(eachEle) {
                                    list.data.push({
                                        id: eachEle,
                                        value: eachEle,
                                        count: tmp(eachEle),
                                        ty: type
                                    });
                                });
                                return list;
                            }
                            if (CT.isLocationEnabled == true ? filter.id == 'area' : filter.id == 'area' || filter.id == 'poi') {
                                tmp = getAreaPoiList(paramsObj[filter.id], filter.id);
                                _.forEach(tmp.data, function(eachLoc) {
                                    if (self.$el.find('.locality input[value="' + eachLoc.value + '"]').length == 0){
                                        // Patch to resolve location filter, please remove this piece of code after change.
                                        $('#ResultContainer_' + CT.settings.currentTab).find("nav.locality").find('label:last').after(CT.utils.searchAreaPoi.createChkBox(eachLoc.value, (eachLoc.ty === 'area' ? 'area' : 'poi'), eachLoc.count, "check", true));
                                    } else {
                                        self.$el.find('.locality input[value="' + eachLoc.value + '"]').attr('checked', 'checked');
                                    }
                                });
                            }

                        }
                    */
                    } else {
                        //var $chkBoxes = self.$el.find(filter.el + ' input[type="checkbox"]');    
                        if (filter.dynamic) {
                            // create checkbox
                            /*
                            var f_list = _.difference(paramsObj[filter.id], $.map($chkBoxes, function(chkBox) {
                                return chkBox.value + ":" + $(chkBox).data("location");
                            }));
    
                            $(f_list).each(function(i, f_value) {
                                var f_values = f_value.split(":");
                                var data = {
                                    "ldata" : f_values[0],
                                    "id" : f_values[0].replace(/\s+/g, '_'),
                                    "value" : f_values[0],
                                    "extra" : "data-location=" + f_values[1]
                                };
                                //self.render($(templates[filter.id]), self.$el.find(filter.el + ' ul.list').first(), data, null, "append");
                                });
                                */
                            function getAreaPoiList(paramArray, type) {
                                var list = {},
                                    tmp;
                                list.data = [];
                                if (type == 'area')
                                    tmp = CT.utils.searchAreaPoi.findAreaHotelCnt;
                                else
                                    tmp = CT.utils.searchAreaPoi.findPOIHotelCnt;
    
                                _.forEach(paramArray, function(eachEle) {
                                    list.data.push({
                                        id: eachEle,
                                        value: eachEle,
                                        count: tmp(eachEle),
                                        ty: type
                                    });
                                });
                                return list;
                            }
                            if (CT.isLocationEnabled == true ? filter.id == 'area' : filter.id == 'area' || filter.id == 'poi') {
                                tmp = getAreaPoiList(paramsObj[filter.id], filter.id);
                                _.forEach(tmp.data, function(eachLoc) {
                                    if (self.$el.find('.locality input[value="' + eachLoc.value + '"]').length == 0){
                                        // Patch to resolve location filter, please remove this piece of code after change.
                                        $('#ResultContainer_' + CT.settings.currentTab).find("nav.locality").find('label:last').after(CT.utils.searchAreaPoi.createChkBox(eachLoc.value, (eachLoc.ty === 'area' ? 'area' : 'poi'), eachLoc.count, "check", true));
                                    } else {
                                        self.$el.find('.locality input[value="' + eachLoc.value + '"]').attr('checked', 'checked');
                                    }
                                });
                            }
    
                        }
                    }
                    var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                    if (window.altFilters == "true") {
                        var $chkBoxes = $currentTab.find(filter.el + ' input[name="' + filter.id + '"]');
                    } else {
                        var $chkBoxes = self.$el.find(filter.el + ' input[name="' + filter.id + '"]');
                    }
                    //To retain filters
                    if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                        CT.cache[CT.settings.currentTab].prevFilters = CT.cache[CT.settings.currentTab].prevFilters || JSON.parse(localStorage.getItem("recentFilters"));
                        CT.cache[CT.settings.currentTab].retainFilters = CT.cache[CT.settings.currentTab].retainFilters || {};
                    }
                    $chkBoxes.each(function(_i, chkBox) {
                        $(chkBox)[((checksMap[filter.id] || checksMap["common"])(filter, paramsObj, chkBox)) ? "attr" : "removeAttr"]("checked", "checked");
                        if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                            if ($(chkBox).closest(".sideBlock").css("display") === "none") {
                                $(chkBox).removeAttr("checked");
                            } else {
                                if (CT.cache[CT.settings.currentTab].prevFilters != null && CT.cache[CT.settings.currentTab].prevFilters[filter.id]) {
                                    CT.cache[CT.settings.currentTab].retainFilters[filter.id] = CT.cache[CT.settings.currentTab].prevFilters[filter.id];
                                    localStorage.setItem("recentFilters", JSON.stringify(CT.cache[CT.settings.currentTab].retainFilters));
                                }
                            }
                        } else {
                            if (CT.cache[CT.settings.currentTab].h_retainFilters != "b") {
                                if ($(chkBox).attr("smartFilter") == 1 && filter.id != $(chkBox).attr("name"))
                                    $(chkBox).removeAttr("checked");
                            }
                        }
                        if (CT.subProd && CT.subProd == "wg") {
                            if (window.altFilters == "true" && filter.id == 'destinationsTheme') {
                                CT.utils.addHiddenField($currentTab.find('.filtersForm'), "destinationsTheme", $currentTab.find('.altFiltersForm input:checked').val())
                            }
                            if ($(chkBox).attr("checked") == "checked") {
                                $(chkBox).closest("label").addClass("selected");
                            }
                        }
                    });
                },

                slider: function(filter) {
                    //  if(filter.el !== ".taStarRating.rangeSlider"){
                    var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                    if (window.altFilters == "true") {
                        var $sliderContainer = $currentTab.find(".hrsFilterSlider.rangeSlider"),
                            min = parseInt(paramsObj[filter.id][0].split(",")[0], 10),
                            max = parseInt(paramsObj[filter.id][0].split(",")[1], 10);
                    } else {
                        var $sliderContainer = self.$el.find(filter.el),
                            min = parseInt(paramsObj[filter.id][0], 10),
                            max = parseInt(paramsObj[filter.id][1], 10);
                    }
                    //var min = parseInt(paramsObj[filter.id][0], 10), max = parseInt(paramsObj[filter.id][1], 10);
                    if (filter.rangeType !== "min" && filter.rangeType !== "max") {
                        $sliderContainer.slider("option", {
                            trigger: false,
                            "values": [min, max]
                        }).slider("option", {
                            trigger: true
                        });
                        //$sliderContainer.slider("option", "values", [min, max, false]);
                    } else {
                        $sliderContainer.slider("option", {
                            trigger: false,
                            "value": min
                        }).slider("option", {
                            trigger: true
                        });
                    }
                    if (window.altFilters == "true") {
                        $currentTab.find(".hrsFilter").val(paramsObj[filter.id]);
                    } else {
                        $sliderContainer.parent().find('input[name="' + filter.el.split('.')[1] + '"]').val(min + '-' + max);
                    }

                    //To retain filters
                    if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                        CT.cache[CT.settings.currentTab].retainFilters = CT.cache[CT.settings.currentTab].retainFilters || {};
                        if (filter.id != "price") {
                            CT.cache[CT.settings.currentTab].retainFilters[filter.id] = min + "-" + max;
                            localStorage.setItem("recentFilters", JSON.stringify(CT.cache[CT.settings.currentTab].retainFilters))
                        }
                    }
                    //$sliderContainer.priceslider({min : min, max : max, isReady : true});


                    //TODO: check the above line with mehraj and then remove the comments.

                    //}
                },

                tabs: function(filter) {
                    var $tabs = $('#ResultContainer_' + CT.settings.currentTab).find(filter.el + ' li');
                    $tabs.each(function(i, tab) {
                        var $tab = $(tab);
                        if (paramsObj[filter.id] && paramsObj[filter.id][0] && (paramToTabsMap[paramsObj[filter.id][0]] || paramsObj[filter.id][0]) == $tab.find("a").data("flt")) {
                            $tab.addClass("current");
                            if ($tab.find("a").hasClass("onlyAirBnb")) {
                                $('#ResultContainer_' + CT.settings.currentTab).find(".listView").addClass("airbnbTab");
                            } else {
                                $('#ResultContainer_' + CT.settings.currentTab).find(".listView").removeClass("airbnbTab")
                            }
                            self.$el.find('[name="' + filter.id + '"]').val(paramsObj[filter.id][0]);
                        } else {
                            if (!$tab.hasClass("listViewLink") && !$tab.hasClass("listViewLink"))
                                $tab.removeClass("current");
                        }
                    });
                },

                textBox: function(filter) {
                    var val = paramsObj[filter.id];

                    if (filter.id == 'hotelName')
                        $('#ResultContainer_' + CT.settings.currentTab).find('.smallSearch input, .mapViewSearch input').val(_.titleize(val));

                    if (filter.id == 'badgeFilter')
                        L('badge filter state');

                    self.$el.find('[name="' + filter.id + '"]').val(val);
                },
                radio: function(filter) {
                    var val = paramsObj[filter.id].join("-");
                    self.$el.find('[value="' + val + '"]').attr("checked", "true");
                    if (filter.id == "taStarRating") {
                        $.each($('nav.taStarRating input:checkbox'), function(index, ele) {
                            filValue = val.split('-')
                            eleval = ele.value.split('-')
                            if (parseFloat(filValue[0]) <= parseFloat(eleval[0])) {
                                $(this).prop('checked', true)
                            } else {
                                $(this).prop('checked', false)
                            }
                        })
                    }
                }
            };

            //if an empty object is sent dont run the prefill loop.
            if (paramsObj) {
                //TODO: for location prefill => if locaty filter is not there in the checkbox list , add the locality item to the container if the item is valid - mehraj
                _.forEach(filterTypes, function(filters, filterTypeKey) {
                    _.forEach(filters, function(filter, i) {
                        hasSeocondryFilters = (filter && filter.id && paramsObj[filter.id] && paramsObj[filter.id].length && _.indexOf(secondryFilterList, filter.id) != -1) || hasSeocondryFilters;
                        // set secondry filter flag
                        if (filter && filter.id && paramsObj[filter.id]) {
                            if (_.isArray(paramsObj[filter.id]) && paramsObj[filter.id][0] != '')
                                prefillTypes[filterTypeKey](filter);
                            else if (paramsObj[filter.id] != '')
                                prefillTypes[filterTypeKey](filter);
                        }

                    });
                });
            }

            if (hasSeocondryFilters) {
                self.$el.find(".showLink").trigger("click");
                // trigger "show more filters" link click, if the secondry filters are prefilled, so that the are shown by default.
            }
            //return filter
            return filter;
        },



        showFirstRunBanners: function(e) {
            if (e && _cookie != 1)
                CT.utils.cookies.create('srpPageBanner', 1, 365);
            var $container = $('#ResultContainer_' + CT.settings.currentTab),
                _cookie = CT.utils.cookies.read('srpPageBanner');

            if (_cookie == 1)
                $container.find('.instHeader').hide();
            else
                $container.find('.instHeader').show();
        },

        //Adds the filter settings elements 

        createFilterSettings: function(filtersSettings, filterName, arr) {
            $.each(arr, function(index, value) {
                var obj = value;
                if (filtersSettings[filterName].elements) {
                    filtersSettings[filterName].elements.push({
                        "value": obj.i,
                        "cls": obj.cls,
                        "hide": obj.i == "NOCAT" || obj.i == "p" ? true : false,
                        'dispName': obj.n,
                        "count": obj.d ? obj.d : obj.cnt,
                        "attr": "data-flt=" + filterName
                    });
                }
            });

            filtersSettings[filterName].elements = _.sortBy(filtersSettings[filterName].elements, function(element) {
                return element.dispName;
            });
        },
        tagsForFilter: function(allTags, city) {
            // Copy allTags casues we'll have to mutate it later
            allTags = allTags.slice();
            var namesOfPermittedTags = CT.settings.hotel.tagsFilterPriority[city];
            if (namesOfPermittedTags) {
                namesOfPermittedTags = namesOfPermittedTags.map(function (tagName) {
                    return tagName.toLowerCase();
                });
                var allTagsNames = allTags.map(function(tag) {
                    return tag.tagName.toLowerCase();
                })
                var tagsToDisplay = [], tagsToHide = [], i;
                // for (i = 0; i < namesOfPermittedTags.length; i++) {
                for (i = 0; i < 5; i++) {
                    var tagIndex = allTagsNames.indexOf(namesOfPermittedTags[i]);
                    if (tagIndex > -1) {
                        tagsToDisplay.push(allTags[tagIndex]);
                        allTags[tagIndex] = null;
                    }
                }
                tagsToHide = allTags.filter(function(tag) {
                    return tag;
                }).map(function(tag) {
                    tag.hide = true;
                    return tag;
                })
                if (!tagsToDisplay.length) {
                    return [];
                }
                return tagsToDisplay.concat(tagsToHide);
            }
            return [];
        },
        wgThemeCnt: function(arr) {
            var cnt = _.groupBy(arr, function(dth) {
                if (dth) {
                    return dth.n
                }
            })
            arr = _.uniq(arr, function(dth) {
                if (dth) {
                    return dth.n;
                }
            });
            for (var i = 0; i < arr.length; i++) {
                if (arr[i]) {
                    arr[i].cnt = cnt[arr[i].n].length;
                }
            }
            /*for(var k in arr){
                if(arr[k]){
                    arr[k].cnt = cnt[arr[k].n].length;
                }
            }*/
            return arr;
        },

        /**
         * @desc This renders the left sidebar containing filters
         */
        createFilters: function(mJson) { //TODO: clean up unwanted filter creation code - done
            //Mehods which binds data to render left side filters
            var filtersSettings = $.extend(true, {}, CT.settings[CT.app].filter);
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);

            //To enable payathotel and freecancellation count
            
            if(window.chunkyFiltersEnabled){
                filtersSettings.payAtHotel.elements[0].count = 0
                filtersSettings.payAtHotel.showcount = true; 
                filtersSettings.freeCancellation.elements[0].count = 0;
                filtersSettings.freeCancellation.showcount = true
                filtersSettings.deals.elements[0].count = 0;
                filtersSettings.deals.showcount = true;
            }

            //console.log('in createfilters', mJson)
            this.cityCode(mJson); //change the autosuggest data-url value;
            this.showFirstRunBanners();

            mJson = mJson || CT.masterJson.get();
            mJson.hmn = mJson.hmn ? mJson.hmn : 'Business';

            if (CT.subProd === "wg") {
                var weekendDest = CT.masterJson.get().wd,
                    destArray = [],
                    destinationsTheme = [],
                    hotelsTheme = [],
                    destinationsThemeCnt = [],
                    hotelsThemeCnt = [];
            }

            var hotelList, localities = [],
                amenities = [],
                roomType = [],
                propertyType = [],
                tagsFilter = [],
                lolfilter = [],
                allPrices = [],
                avgAllPrices = [],
                starRating = [],
                taRating = [],
                localitiesData = {
                    LDATA: []
                },
                amenitiesData = {
                    AMDATA: []
                },
                propertyData = {
                    PROPERTYTYPE: []
                },
                starData = {
                    STARDATA: []
                },
                taData = {
                    TARATING: []
                };

            // TODO: convert multi dimension array to a hash as below format and move to settings.js
            /*{
             atttr:"amWIFI",
             label:"Wi-Fi Access",
             cnt:0
         }*/
            var amenitiesObj = [];
            if(mJson.hmn === "Leisure"){
                amenitiesObj.push(
                    ["amPool", CT.messages.hotel.Pool, 0],
                    ["amWIFI", CT.messages.hotel.WIFIAccess, 0],
                    ["amAC", CT.messages.hotel.AirConditioning, 0],
                    ["amRestaurant", CT.messages.hotel.Restaurant, 0],
                    ["amBar", CT.messages.hotel.Bar, 0],
                    ["am24HrCheckin", CT.messages.hotel.ChkIn24Hr, 0],
                    ["amRoomService", CT.messages.hotel.RoomSrvc, 0],
                    ["amGym", CT.messages.hotel.Gym, 0],
                    ["amCafe", CT.messages.hotel.CoffeeShop, 0],
                    ["amBusinessCenter", CT.messages.hotel.BussinessCentre, 0]
                );
            } else if(mJson.hmn === "Business"){
                amenitiesObj.push(
                    ["am24HrCheckin", CT.messages.hotel.ChkIn24Hr, 0],
                    ["amAC", CT.messages.hotel.AirConditioning, 0],
                    ["amWIFI", CT.messages.hotel.WIFIAccess, 0],
                    ["amRestaurant", CT.messages.hotel.Restaurant, 0],
                    ["amBar", CT.messages.hotel.Bar, 0],
                    ["amBusinessCenter", CT.messages.hotel.BussinessCentre, 0],
                    ["amRoomService", CT.messages.hotel.RoomSrvc, 0],
                    ["amGym", CT.messages.hotel.Gym, 0],
                    ["amCafe", CT.messages.hotel.CoffeeShop, 0],
                    ["amPool", CT.messages.hotel.Pool, 0]
                );
            } else {
                 amenitiesObj.push(
                    ["amWIFI", CT.messages.hotel.WIFIAccess, 0],
                    ["amAC", CT.messages.hotel.AirConditioning, 0],
                    ["am24HrCheckin", CT.messages.hotel.ChkIn24Hr, 0],
                    ["amRestaurant", CT.messages.hotel.Restaurant, 0],
                    ["amBar", CT.messages.hotel.Bar, 0],
                    ["amCafe", CT.messages.hotel.CoffeeShop, 0],
                    ["amRoomService", CT.messages.hotel.RoomSrvc, 0],
                    //["amInternet", CT.messages.hotel.InternetAccess, 0], Removed from list on request from product team
                    ["amBusinessCenter", CT.messages.hotel.BussinessCentre, 0],
                    ["amPool", CT.messages.hotel.Pool, 0],
                    ["amGym", CT.messages.hotel.Gym, 0]
                );
            }
            if (mJson.ht && mJson.ht.ht)
                hotelList = mJson.ht.ht;
            else
                hotelList = mJson.ht;


            //for price range filter - start
            if ((window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b') {
                var count2k = 0,
                    count4k = 0,
                    count6k = 0,
                    count6kPlus = 0,
                    indiTotalPrice = 0,
                    FilterBottomLow = CT.settings.hotel.priceRange["bottomLow"],
                    FilterBottomHight = CT.settings.hotel.priceRange["bottomHigh"],
                    FilterMidLow = CT.settings.hotel.priceRange["midLow"],
                    FilterMidHight = CT.settings.hotel.priceRange["midHight"],
                    FilterExpensive = CT.settings.hotel.priceRange["expensive"],
                    maxInBucket = [],
                    currency2k = CT.utils.formatForCurrency(FilterBottomHight),
                    currency4k = CT.utils.formatForCurrency(FilterMidLow),
                    currency6k = CT.utils.formatForCurrency(FilterMidHight),
                    currency6kPlus = CT.utils.formatForCurrency(FilterMidHight)
                    ;

                var availCount = 0,
                    tmpJson = [];
                for (var k in CT.masterJson.get().ht) {
                    if (CT.masterJson.get().ht[k].priceInfo) {
                        tmpJson.push(CT.masterJson.get().ht[k]);
                        availCount++;

                    }
                };
                tmpJson.sort(function(a, b) {
                    if (a.priceInfo && b.priceInfo) {
                        return a.priceInfo.rms[0].tot > b.priceInfo.rms[0].tot ? 1 : -1;
                    }
                })
                CT.cache[CT.settings.currentTab].availableCount = availCount;
                CT.avaiActiveHotel = availCount;

                tmpJson.forEach(function (value, index){
                    indiTotalPrice = value.priceInfo.rms[0].tot;
                    maxInBucket.push(indiTotalPrice);
                    if ( indiTotalPrice > FilterBottomLow && indiTotalPrice <= FilterBottomHight ){
                        count2k++;
                    } else if ( indiTotalPrice > FilterBottomHight && indiTotalPrice <= FilterMidLow ){
                        count4k++;
                    } else if ( indiTotalPrice > FilterMidLow && indiTotalPrice <= FilterMidHight ){
                        count6k++;
                    } else if ( indiTotalPrice > FilterMidHight && indiTotalPrice <= FilterExpensive ){
                        count6kPlus++;
                    } 
                })
                console.log('maxInBucket', maxInBucket)  
                
            }
            //for price range filter - end

            _.forEach(hotelList, function(obj, index) {
                var price = 0;
                var avgPrice = 0;
                if (CT.app === 'dp') {
                    if (obj.priceInfo.pf) {
                        price += obj.priceInfo.pf;
                        allPrices.push(price);
                    }
                } else { //hotels
                    if (obj.priceInfo) {
                        price += obj.priceInfo.rms[0].tot;
                        avgPrice += obj.priceInfo.rms[0].avg;
                        allPrices.push(price);
                        avgAllPrices.push(avgPrice);
                    }
                }

                starRating[index] = obj.sr ? obj.sr : 0;
                taRating[index] = parseInt(obj.tar) || 0;
                //TODO:: Locality Filter :: 
                if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                    localities[index] = obj.ar;
                }
                
                // localities array
                if (obj.pt && obj.pt.length > 0) { //property type array
                    for (k = 0; k < obj.pt.length; k++) {
                        if (!obj.pt[k].code || !obj.pt[k].name) continue;
                        propertyType.push(CT.settings[CT.app].filters.constants.propertyHash[obj.pt[k].code] + '||' + obj.pt[k].code);
                    }
                } else {
                    propertyType.push("Hotels||NOCAT"); // add "_Hotels" underacore to push last in the list
                }
                var hotelsWeekendDest;
                if (CT.subProd === "wg" && obj.c && (hotelsWeekendDest = _.filter(weekendDest.d, {
                        'i': obj.c
                    })[0])) { // safe check for destination IDs which are not in the weekendDest.d list
                    destArray.push(hotelsWeekendDest);
                }

                if (obj.rt) {
                    roomType.push({
                        "i": obj.rt,
                        "n": obj.rt
                    });
                }

                if (obj.dth) {
                    if (obj.dth.length > 0) {
                        for (var i = 0; i < obj.dth.length; i++) {
                            destinationsTheme.push({
                                "i": obj.dth[i],
                                "n": CT.masterJson.get().wd.dth[obj.dth[i]],
                                "cls": "dt_" + obj.dth[i]
                            })
                        }
                    } else {
                        destinationsTheme.push({
                            "i": "NOCAT",
                            "n": CT.messages.hotel.OtherDestThm
                        })
                    }
                }
                if (obj.hth) {
                    if (obj.hth.length > 0) {
                        for (var i = 0; i < obj.hth.length; i++) {
                            hotelsTheme.push({
                                "i": obj.hth[i],
                                "n": CT.masterJson.get().wd.hth[obj.hth[i]],
                                "cls": "ht_" + obj.hth[i]
                            })
                        }
                    } else {
                        hotelsTheme.push({
                            "i": "NOCAT",
                            "n": CT.messages.hotel.OtherHotelThm
                        })
                    }
                }

                //changing amenities to biniary and counting amenities hotels count
                var amenitys = changeToBinary(obj.am);
                var f = 0;
                for (var j = 0; j < amenitys.length; j++) {
                    var _am;
                    if ($.browser.msie) _am = amenitys.split('')[j];
                    else _am = amenitys[j];
                    if (_am != 0 && amenitiesObj[j]) {
                        amenitiesObj[j][2]++;
                        f++;
                    }
                }
            });

            if (CT.app === 'dp') {
                if (mJson.fl) {
                    this.$el.find('.airLine').parent().parent().show(); //shows the airline dom element
                    var airData = this.getUniqueAirline(mJson.fl); //creating mustache json
                    this.render($('#airlineCode'), this.$el.find('.airLine'), airData); //mustache render
                }
            }
            if ( (window.priceSlider && (CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") !== 'b' || window.countryCode !== 'in')) ){
                if (_.min(allPrices) >= 0 && _.max(allPrices >= 0)) { //calculating min and max price.
                    if (_.min(allPrices) === Infinity) {
                        CT.cache[CT.settings.currentTab].filterValues.priceMinMax = {
                            "min": 0,
                            "max": 0
                        };
                    } else {
                        CT.cache[CT.settings.currentTab].filterValues.priceMinMax = {
                            "min": _.min(allPrices),
                            "max": _.max(allPrices)
                        };
                        CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax = {
                            "min": _.min(avgAllPrices),
                            "max": _.max(avgAllPrices)
                        };
                    }
                }
            }

            propertyType = arrayUniqueEleCnt(propertyType); //calculating count for property array.

            //sort property type with count
            propertyType = _.sortBy(propertyType, function(arrElement) {
                if (arrElement[0].indexOf('Hotels') >= 0)
                    return 0;
                return -(arrElement[1]);
            });
            starRating = _.uniq(starRating).sort(); //making unique and sort.
            taRating = _.uniq(taRating).sort(); //making unique and sort.

            //************* Creating template json & rendering.

            var s = CT.cache[CT.settings.currentTab].filterValues.priceMinMax;
            var priceSliderShow = true,
                tmp;
            if ((s.min === 0 && s.max === 0) || (s.min === s.max)) {
                priceSliderShow = false;
            }

            if ((window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b') {
                
                var priceFilterClasses = CT.settings.hotel.priceRange["NClasses"],
                    count2kClass = (priceFilterClasses.indexOf('count2k') > -1 ? '_count2k' : ''),
                    count4kClass = (priceFilterClasses.indexOf('count4k') > -1 ? '_count4k' : ''),
                    count6kClass = (priceFilterClasses.indexOf('count6k') > -1 ? '_count6k' : ''),
                    count6kPlusClass = (priceFilterClasses.indexOf('count6kPlus') > -1 ? '_count6kPlus' : '')
                    ;

                
                filtersSettings.priceFilter.elements.push({
                    'dispName': 'Below ' + currency2k,
                    "value": FilterBottomLow + " - " + FilterBottomHight,
                    "count": count2k,
                    "attr": (count2k > 0 ? "data-flt=priceFilter" : "disabled=disabled"),
                    "cls" : (count2k > 0 ? "price-filter-chk-box"+ count2kClass : 'is-disabled price-filter-chk-box'+count2kClass)
                });
                filtersSettings.priceFilter.elements.push({
                    'dispName': currency2k + " - " + currency4k,
                    "value": FilterBottomHight + "-" + FilterMidLow,
                    "count": count4k,
                    "attr": (count4k > 0 ? "data-flt=priceFilter" : "disabled=disabled"),
                    "cls" : (count4k > 0 ? "price-filter-chk-box"+ count4kClass : 'is-disabled price-filter-chk-box'+count4kClass)
                });
                filtersSettings.priceFilter.elements.push({
                    'dispName': currency4k + " - " + currency6k,
                    "value": FilterMidLow + "-" + FilterMidHight,
                    "count": count6k,
                    "attr": (count6k > 0 ? "data-flt=priceFilter" : "disabled=disabled"),
                    "cls" : (count6k > 0 ? "price-filter-chk-box"+ count6kClass : 'is-disabled price-filter-chk-box'+count6kClass)
                });
                filtersSettings.priceFilter.elements.push({
                    'dispName': 'Above ' + currency6k,
                    "value": FilterMidHight + "-" + Math.max.apply(null, maxInBucket),
                    "count": count6kPlus,
                    "attr": (count6kPlus > 0 ? "data-flt=priceFilter" : "disabled=disabled"),
                    "cls" : (count6kPlus > 0 ? "price-filter-chk-box"+ count6kPlusClass : 'is-disabled price-filter-chk-box'+count6kPlusClass)
                });

            } 
            if((window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b'){
                //copy min and max price to settings before creating filter
                if ((tmp = filtersSettings.price)) {
                    tmp.min = s.min;
                    tmp.max = s.max;
                    tmp.disabled = !priceSliderShow;
                }
            }
            if(CT.settings.hotel.filter.chain.elements.length <= 3){
                CT.settings.hotel.filter.chain.showMoreChains = 0;
            }
            filtersSettings.taStarRating.disabled = false;
            $.each([5, 4, 3, 2, 1], function(index, value) {
                var disabled = "",
                    faded = "";
                if (_.indexOf(starRating, value) < 0) {
                    if (value == 1 && _.indexOf(starRating, 0) < 0) {
                        disabled = "disabled=disabled";
                        faded = "is-disabled";
                    } else if (value != 1) {
                        disabled = "disabled=disabled";
                        faded = "is-disabled";
                    }
                }

                filtersSettings.starFilter.elements[index].attr = disabled;
                filtersSettings.starFilter.elements[index].cls = faded;
            })

            //push amenities data into settings
            if(amenitiesObj.length <= 3) {
                filtersSettings.amenity.showMore = false;
            }
            $.each(amenitiesObj, function(index, value) {
                var disable = "",
                    faded = "";
                if (value[2] == 0) {
                    disable = "disabled=disabled";
                    faded = "is-disabled";
                }
                //if(value[1] !== '24 Hour Check-in'){
                if (filtersSettings.amenity.elements) {
                    filtersSettings.amenity.elements.push({
                        "value": value[0],
                        "dispName": value[1],
                        "count": value[2],
                        "attr": "data-flt=am " + disable,
                        "cls": faded
                    });
                }

                //}
            });


            //push property types data into settings if app is not dp
            if (CT.app === 'dp') {
                this.$el.find('nav.propertyType').parent().hide();
            } else {
                if(propertyType.length <= 3) {
                    filtersSettings.propertyType.showMore = false;
                }
                //Property type
                $.each(propertyType, function(index, value) {
                    var pText = value[0].split('||');
                    if (filtersSettings.propertyType.elements) {
                        filtersSettings.propertyType.elements.push({
                            "value": pText[1],
                            'dispName': pText[0].replace('_', ''),
                            "count": value[1],
                            "attr": "data-flt=propertyType"
                        });
                    }
                });

                //sort property type filter by name
                filtersSettings.propertyType.elements = _.sortBy(filtersSettings.propertyType.elements, function(element) {
                    return element.dispName;
                });

                if (_.size(propertyType) == 1 && propertyType[0][0].split('||')[1] == 'NOCAT') {
                    this.hideFilter('propertyType');
                }
            }
            if (window.showTags && !!CT.tagsData) {
                var tags = this.tagsForFilter(CT.tagsData, mJson.cnm);
                if (!tags.length) {
                    // If tags exist, but none in CT.tagsData match ones given in priority
                    // list, therefore entire list is hidden, then hide tags filter it self
                    filtersSettings.tagsFilter.hideFilter = true;
                    this.$el.find('div.filters__section--tagsFilter').parent().hide();
                    // Add alltags after hiding entire div
                    tags = CT.tagsData;
                }
                $.each(tags, function(index, value) {
                    var tagsText = value
                    if (filtersSettings.tagsFilter.elements) {
                        filtersSettings.tagsFilter.elements.push({
                            "value": value.tagId + "_tag",
                            'dispName': value.tagName,
                            'cls': value.tagId + "_tag",
                            "attr": "data-flt=tagsFilter",
                            "hide": value.hide
                        });
                    }
                });
            } else {
                this.$el.find('div.filters__section--tagsFilter').parent().hide();
            }

            var lolfilterForCity = [];
            lolfilterForCity = CT.settings.hotel.lolfilter[mJson.cnm];
            if (lolfilterForCity && lolfilterForCity.length) {
                filtersSettings.lolfilter.elements = [];
                $.each(lolfilterForCity, function(index, value) {
                    var count = 0;
                    mJson.ht.forEach(function(hotel) {
                        if (hotel.ar === value && hotel.priceInfo) {
                            count += 1;
                        }
                    })
                    if (filtersSettings.lolfilter.elements) {
                        filtersSettings.lolfilter.elements.push({
                            "value": value.replace(/ /g, "+").replace(/-/g, "_"),
                            'dispName': value,
                            "attr": "data-flt=lolfilter",
                            "count": count
                        });
                    }
                });
            } else {
                filtersSettings.lolfilter.hideFilter = true;
                this.$el.find('div.filters__section--lolfilter').parent().hide();
            }

            //if(CT.subProd == "airBnb"){
            roomType = this.wgThemeCnt(roomType); //calculating count for roomType array.
            //Property type
            $.each(roomType, function(index, value) {
                if (filtersSettings.roomType.elements) {
                    filtersSettings.roomType.elements.push({
                        "value": value.i.replace(" ", "").toLowerCase(),
                        'dispName': value.n,
                        "count": value.cnt,
                        "attr": "data-flt=roomType"
                    });
                }
            });

            //sort property type filter by name
            filtersSettings.roomType.elements = _.sortBy(filtersSettings.roomType.elements, function(element) {
                return element.dispName;
            });

            //}
            if (CT.subProd === "wg") {

                //create destinations filter
                //this.createFilterSettings(filtersSettings,"destinations",weekendDest.d);

                destArray = this.wgThemeCnt(destArray);
                $.extend(false, CT.masterJson.get().wd.d, destArray);
                destArray = _.sortBy(destArray, function(element) {
                    if (element && element.cnt) {
                        return (-element.cnt);
                    }
                });
                filtersSettings.destinations.totCount = destArray.length;
                $.each(destArray, function(index, value) {
                    if (filtersSettings.destinations.elements) {
                        filtersSettings.destinations.elements.push({
                            "value": value.i,
                            'dispName': value.n,
                            "count": value.cnt,
                            "cls": window.altFilters == "false" ? index < filtersSettings.destinations.minCount ? "topDestinations" : "moreDestinations" : "",
                            "hide": window.altFilters == "false" ? index < filtersSettings.destinations.minCount ? false : true : "",
                            "destDriveTime": Int(value.t) != 0 ? Math.ceil(value.t / (60)) : 1,
                            "attr": "data-flt=destinations name=destinations"
                        });
                    }
                });
                filtersSettings.destinations.elements = _.sortBy(filtersSettings.destinations.elements, function(element) {
                    return element.dispName;
                });

                //Destiantion theme filter
                destinationsTheme = this.wgThemeCnt(destinationsTheme);
                this.createFilterSettings(filtersSettings, "destinationsTheme", destinationsTheme);

                if (_.size(destinationsTheme) == 1 && destinationsTheme[0].i == 'NOCAT') {
                    this.hideFilter('destinationsTheme');
                }

                //Hotel theme Filter
                hotelsTheme = this.wgThemeCnt(hotelsTheme);
                this.createFilterSettings(filtersSettings, "hotelsTheme", hotelsTheme);

                if (_.size(hotelsTheme) == 1 && hotelsTheme[0].i == 'NOCAT') {
                    this.hideFilter('hotelsTheme');
                }

            }

            //push localities data into settings
            var c = 0,
                areaLatlngObj = CT.masterJson.get().ar;

            //calculating count for localities and doing sort by count
            //TODO:: Locality Filter :: 
            if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                localities = (arrayUniqueEleCnt(localities).sort(function(a, b) {return a[1] - b[1]})).reverse();
            }
            
            CT.cache[CT.settings.currentTab].filterValues.areasLatlng = {
                data: []
            };

            //making changes and taking area information only from masterjson hotels list ( ignoring mJson.ar sent from backend ) - karthik
            if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                CT.cache[CT.settings.currentTab].filterValues.areasLatlng.data = areaLatlngObj ? areaLatlngObj[mJson.city] : undefined;
            
                //Keeping only top 6 locaalities from original localities list 
                //TODO:: Locality Filter :: Comment Below Line Start
                if (localities.length > 3) localities = localities.slice(0, 3);
            
                $.each(localities, function(index, value) {
                    var mJson = CT.masterJson.get()
                    var hotels = mJson.ht
                    var lat = 0, lng = 0, count = 0, tmp;
                    //TODO : performance improvement - loop through hotels and push into localities - karthik
                    _.each(hotels, function(hotel){
                        if (hotel.ar === value[0] && hotel.latlng) {
                            count++;
                            lat += hotel.latlng[0];
                            lng += hotel.latlng[1];
                        }
                    })

                    if (count > 0) {
                        CT.cache[CT.settings.currentTab].filterValues.areasLatlng.data.push({
                            "loc" : value[0],
                            "latlng" : [(lat / count), (lng / count)],
                            "avail" : true,
                            "cnt" : value[1]
                        });
                    } else {
                        CT.cache[CT.settings.currentTab].filterValues.areasLatlng.data.push({
                            "loc" : value[0],
                            "latlng" : [0, 0],
                            "avail" : false,
                            "cnt" : value[1]
                        });
                    }



                    var lText = value;
                    var alText = CT.settings[CT.app].filters.constants.locCheckboxText + ' name=area';
                    //TODO: move these hardcoded settings to one map - done
                    if (c < CT.settings[CT.app].filters.constants.locAreaFilterCnt) {
                        localitiesData.LDATA.push({
                            "ldata" : lText[0],
                            "cnt" : value[1],
                            "id" : value[0].replace(/\s+/g, '_'),
                            "value" : $.trim(lText[0]),
                            "extra" : alText
                        });
                        CT.utils.searchAreaPoi.prevAddedLoc.push(lText[0]);
                    } else {
                        if (CT.areaVal == value[0]) {
                            localitiesData.LDATA.push({
                                "ldata" : lText[0],
                                "cnt" : value[1],
                                "id" : value[0].replace(/\s+/g, '_'),
                                "value" : $.trim(lText[0]),
                                "extra" : alText
                            });
                            CT.utils.searchAreaPoi.prevAddedLoc.push(lText[0]);
                        }
                    }
                    c++;
                });
            }
            
            //variable to store previously added locations in the lhs filter
            var tabCache = CT.cache[CT.settings.currentTab];
            tabCache.prevAddedLoc = [];


            //PRM-10918
            if (CT.settings[CT.app].ignoreCityPoi.indexOf(mJson.city.toString()) != -1) {
                mJson.hmn = 'Business';
            }

            var areasConcatList = [],
                topAreasByHotels = [],
                topPoisByHotels = [],
                totalTopAreasByHotels = mJson.hmn === 'Business' ? 5 : 3,
                _index = 0;

                if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                    //TODO:: Locality Filter 
                    if(totalTopAreasByHotels.length <= 5 ) {
                        filtersSettings.localities.showMore = false;
                    } 
                }    
            _.each(mJson.ar, function(areas) {
                areasConcatList = areasConcatList.concat(areas);
            });
            areasConcatList = _.sortBy(areasConcatList, function(area) {
                if (area.ht) {
                    return -area.ht;
                }
            });

            _.each(areasConcatList, function(_ar) {
                if (_ar.ht > 0) {
                    CT.cache[CT.settings.currentTab].filterValues.areasLatlng.data.push({
                        "loc": _ar.nm,
                        "latlng": _ar.latlng ? _ar.latlng : [0, 0],
                        "avail": true,
                        "cnt": _ar.ht
                    });
                    var alText = CT.settings[CT.app].filters.constants.locCheckboxText + ' name=area';
                    var _tobj = {
                        "ldata": _ar.nm,
                        "cnt": _ar.ht,
                        "id": _ar.nm.replace(/\s+/g, '_'),
                        "value": $.trim(_ar.nm),
                        "extra": alText
                    };
                    if (_index < totalTopAreasByHotels) {
                        topAreasByHotels.push(_tobj);
                        tabCache.prevAddedLoc.push(_ar.nm);
                        _index++;
                    }
                    filtersSettings.locality.totCount++;
                }
            });

            tmp = CT.cache[CT.settings.currentTab].filterValues.areasLatlng;
            //to get the exact count of areas having
            filtersSettings.locality.totCount = 0;
            _.each(tmp.data, function(area) {
                if (area.cnt && area.cnt > 0)
                    filtersSettings.locality.totCount++;
            });

            //Doing sorty by poi hotel count
            if (!$.isEmptyObject(mJson.poi)) {

                //TODO:: Locality Filter :: 
                if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                    _.each(mJson.poi, function(poiCity, index) {
                        mJson.poi[index] = _.sortBy(poiCity, function(poiList) {
                            return -poiList.ht;
                        });
                    });

                    var mainCityPoi = mJson.poi[mJson.city],cc=0;
                }

                var mainCityPoi = [],
                    cc = 0;
                _.each(mJson.poi, function(pois) {
                    mainCityPoi = mainCityPoi.concat(pois);
                });

                // sort based on rank.
                mainCityPoi = _.sortBy(mainCityPoi, function(poi) {
                    return poi.rank;
                });

                // pick top 10 and then 3 by number of hotels.
                mainCityPoi = mainCityPoi.slice(0, 10);
                mainCityPoi = _.sortBy(mainCityPoi, function(poi) {
                    return -poi.ht;
                });
                _.each(mainCityPoi, function(pData, index) {
                    //TODO:: Locality Filter 
                    if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                        var alText = "data-flt=location data-location=p name=poi";
                    } else {
                        var alText = "data-flt=area data-location=p name=poi";
                    }
                    
                    if (pData.ht !== 0 && _.indexOf(CT.settings[CT.app].filters.constants.poiShowData, pData.cat1) >= 0) {
                        if (cc < CT.settings[CT.app].filters.constants.locAreaFilterCnt && mJson.hmn !== 'Business') {
                            topPoisByHotels.push({
                                "ldata": pData.nm,
                                "cnt": pData.ht,
                                "id": pData.nm.replace(/\s+/g, '_'),
                                "value": $.trim(pData.nm),
                                "extra": alText
                            });
                            tabCache.prevAddedLoc.push(pData.nm);
                            filtersSettings.locality.totCount++;
                            cc++
                        } else {
                            filtersSettings.locality.totCount++;
                        }
                    }
                });
            }
            localitiesData.LDATA = [];
            if (mJson.hmn !== 'Business') {
                localitiesData.LDATA = localitiesData.LDATA.concat(topPoisByHotels, topAreasByHotels);
            } else {
                localitiesData.LDATA = topAreasByHotels;
            }
            _.forEach(localitiesData.LDATA, function(eachLocality) {
                if (filtersSettings.locality.elements) {
                    filtersSettings.locality.elements.push({
                        "value": (eachLocality.value == 'Mg Road' ? (eachLocality.value = 'MG Road') : (eachLocality.value)),
                        'dispName': (eachLocality.ldata == 'Mg Road' ? (eachLocality.ldata = 'MG Road') : (eachLocality.ldata)),
                        "count": eachLocality.cnt,
                        "attr": eachLocality.extra,
                        "id": eachLocality.id
                    });
                }

            });

            //sort property type filter by name
            /*filtersSettings.locality.elements = _.sortBy(filtersSettings.locality.elements, function(element) {
                return element.dispName;
            });*/

            //debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug- FOR QA
            if (mJson.dbg) {
                this.debugMode();
                var _sup = mJson.dbg.sup
                _.each(_sup, function(supObj, supVal) {
                    filtersSettings.dbg.elements.push({
                        dispName: _.keys(supObj)[0],
                        count: _.values(supObj)[0],
                        value: supVal,
                        'id': _.keys(supObj)[0]
                    })
                });

            }

            //debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug- FOR QA
            L('1')
            // var taRatingLength = {
            //     "5": 0,
            //     "45": 0,
            //     "4": 0,
            //     "35": 0
            // };
            // var starFilerlength = {
            //     "5": 0,
            //     "4": 0,
            //     "3": 0,
            //     "2": 0,
            //     "1": 0
            // }
            // var payAtHotelCount = 0
            // var freeCancellationCount = 0
            // var quickeysCount = 0
            // var weSleepCount = 0
            // _.filter(mJson.ht, function(hotelcount) {
            //     if (hotelcount.tar == 5) {
            //         taRatingLength["5"]++;
            //     } else if (hotelcount.tar >= 4.5) {
            //         taRatingLength["45"]++;
            //     } else if (hotelcount.tar >= 4) {
            //         taRatingLength["4"]++
            //     } else if (hotelcount.tar >= 3.5) {
            //         taRatingLength["35"]++
            //     }
            //     if (hotelcount.sr == 5) {
            //         starFilerlength[5]++
            //     } else if (hotelcount.sr == 4) {
            //         starFilerlength[4]++
            //     } else if (hotelcount.sr == 3) {
            //         starFilerlength[3]++
            //     } else if (hotelcount.sr == 2) {
            //         starFilerlength[2]++
            //     } else if (hotelcount.sr == 1) {
            //         starFilerlength[1]++
            //     }
            //     if (hotelcount.pp) {
            //         payAtHotelCount++
            //     }
            //     if (hotelcount.fc) {
            //         freeCancellationCount++
            //     }
            //     if (hotelcount.sb && hotelcount.sb.sdr === 1) {
            //         quickeysCount++
            //     }
            //     if (hotelcount.sb && hotelcount.sb.wsh > 0) {
            //         weSleepCount++
            //     }

            // })
            // var hotelWithDealsCount = _.filter(CT.masterJson.get().ht, function(hotel) {
            //     return hotel.priceInfo && hotel.priceInfo.oi && !hotel.displayOnlyRule ? true : false;
            // });
            // if (weSleepCount > 0) {
            //     filtersSettings.weSleep.elements[0].count = weSleepCount
            //     filtersSettings.weSleep.showcount = true
            // }
            // if (payAtHotelCount > 0) {
            //     filtersSettings.payAtHotel.elements[0].count = payAtHotelCount
            //     filtersSettings.payAtHotel.showcount = true
            // }
            // if (freeCancellationCount > 0) {
            //     filtersSettings.freeCancellation.elements[0].count = freeCancellationCount
            //     filtersSettings.freeCancellation.showcount = true
            // }
            // if (hotelWithDealsCount.length > 0) {
            //     filtersSettings.deals.elements[0].count = hotelWithDealsCount.length
            //     filtersSettings.deals.showcount = true
            //     filtersSettings.deals.countCls = "deaslCnt"
            // }
            // if (quickeysCount > 0) {
            //     filtersSettings.quickeys.elements[0].count = quickeysCount
            //     filtersSettings.quickeys.showcount = true
            // }
            // _.each(taRatingLength, function(value, index) {
            //     var ele = _.find(filtersSettings.taStarRating.elements, function(ele) {
            //         return index == ele.val
            //     });
            //     if (ele)
            //         ele.count = value;
            // });
            // _.each(starFilerlength, function(value, index) {
            //     var ele = _.find(filtersSettings.starFilter.elements, function(ele) {
            //         return index == ele.value
            //     })
            //     if (ele)
            //         ele.count = value
            // })
            _.forEach(filtersSettings, function(settings, name) {
                this.updateFilter(name, settings);
            }, this);

            this.cityCode(CT.masterJson.get());
            //add    status to all the filters
            this.toggleFilter('*');
            var that = this;
            if (!window.chunkyFiltersEnabled) {
                this.toggleFilter('amenity');
            }
            if (CT.subProd == "wg" && window.altFilters == "false") {
                //this.toggleFilter("hotelsTheme")
                $currentTab.find("#distanceFilter").show();
            } else if (CT.subProd == "wg" && window.altFilters == "true") {
                $currentTab.find(".distanceSliderSec").show();
                $currentTab.find(".expFilter").show();
                $currentTab.find(".filterCol").show();
            }

           
            /* patch to handle special offer section*/
            /* Start */
            $currentTab.find('.deals').closest(".sideBlock").show();
            var specialFilterArr = ['.deals','.payAtHotel','.freeCancellation'];
            $currentTab.find(specialFilterArr.toString()).closest('.sideBlock:visible').addClass('wrapper--specialOffers').last().removeClass('wrapper--specialOffers').css("cssText", "padding-top: 3px !important;padding-bottom: 10px !important;");
            $currentTab.find(specialFilterArr.toString()).closest('div.wrapper').removeClass('pt10 pb10');
            $currentTab.find(".wrapper--smallSearch").removeClass('pt10 pb10').addClass('clearFix');
            $currentTab.find('.deals').closest(".sideBlock").css("cssText", "padding-top: 10px !important;");

                /* End */
            
            if(CT.settings.hotel.filter.chain.elements.length === 0){
                $currentTab.find('.chain').closest(".sideBlock").hide();    
            }

            return this;
        },

        fltAirlineData: function(e, settings) {
            if(false){
                var airlineCombinations = CT.settings[CT.app].filters.constants.airlineCombinations;
                var airlineinputs = this.$el.find('select.airLine').val() //this.$el.find('ul.airLine li input:checked')
                    ,
                    ids = [airlineinputs],
                    cheapfareFlightSolutionArr = [],
                    $cTab = CT.settings.currentTab,
                    triptype = CT.masterJson.get().fl.jsons.searchType.isIntl ? 'isIntl' : 'domRt';
                this.$el.find('#noCheapAirline').hide();
                if (airlineinputs.length > 0) {
                    //              _.forEach(airlineinputs, function(index, value) {
                    //                  var airlineId = $(index).attr('id')
                    //                  if(airlineCombinations[airlineId] && airlineCombinations[airlineId].length > 0){
                    //                      _.forEach(airlineCombinations[airlineId],function (index1,value1){
                    //                          ids.push(index1);
                    //                      });
                    //                  }else
                    //                      ids.push(airlineId);
                    //              });
                    cheapfareFlightSolutionArr = this.calcCheapfareFilghts(CT.masterJson.get().fl, ids);
                }
                if (cheapfareFlightSolutionArr[0] !== undefined && cheapfareFlightSolutionArr[1] !== undefined) {
                    CT.FlightSolution.updateChFLight(cheapfareFlightSolutionArr[0], cheapfareFlightSolutionArr[1], '', triptype, cheapfareFlightSolutionArr[2])
                } else {
                    var onwardcheapFli = (CT.masterJson.get().fl.orgCon).split('-');
                    var returncheapFli = (CT.masterJson.get().fl.orgCrt).split('-');

                    //var text = "Showing packages with cheapest airline and " + airlineinputs.val() + " due to unavailability of flights for both ways";
                    var text = CT.messages.hotel.pkgCheapAir + airlineinputs + CT.messages.hotel.dueToUnavailability;

                    if (cheapfareFlightSolutionArr[0] === undefined && cheapfareFlightSolutionArr[1] === undefined) {
                        // when all airline are unchecked, pick the default flight which is sent in the JSON.
                        CT.masterJson.get().fl.con = CT.masterJson.get().fl.orgCon;
                        CT.masterJson.get().fl.crt = CT.masterJson.get().fl.orgCrt;
                        CT.FlightSolution.updateChFLight(onwardcheapFli[0], returncheapFli[0], '', triptype, CT.FlightSolution.areSelectedFlightsACombo());
                    } else if (cheapfareFlightSolutionArr[0] === undefined) {
                        this.$el.find('#noCheapAirline').show().html(text);
                        CT.FlightSolution.updateChFLight(onwardcheapFli[0], cheapfareFlightSolutionArr[1], '', triptype, cheapfareFlightSolutionArr[2]);
                    } else if (cheapfareFlightSolutionArr[1] === undefined) {
                        this.$el.find('#noCheapAirline').show().html(text);
                        CT.FlightSolution.updateChFLight(cheapfareFlightSolutionArr[0], returncheapFli[0], '', triptype, cheapfareFlightSolutionArr[2]);
                    } else {
                        CT.masterJson.get().fl.con = CT.masterJson.get().fl.orgCon;
                        CT.masterJson.get().fl.crt = CT.masterJson.get().fl.orgCrt;
                        CT.FlightSolution.updateChFLight(onwardcheapFli[0], returncheapFli[0], '', triptype, CT.FlightSolution.areSelectedFlightsACombo());
                    }
                }

                //this.showAllHotelsLink().sendFltObj(settings);
                this.sendFltObj(settings);

                return this;
            }
        },



        toolBarFltData: function(e, settings) {
            var currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                $elem = currentTab.find("aside.left"),
                ele;
            if (e) ele = $(e.target)
            else ele = $(currentTab.find("ul.toolBarControls")[1]).find('li.current a');

            if (ele.attr('data-flt') == "shortListed") {
                CT.fire("disableLhrFilter", [true]);
            } else {
                CT.fire("disableLhrFilter", [false]);
                $elem.removeClass("disabled");
            }

            this.$el.find('.toolBarControls li').removeClass('current');
            ele.parent().addClass('current');

            currentTab.find('.badgeFilter').val(ele.attr('data-flt'));

            //this.showAllHotelsLink();//.sendFltObj(settings);

            if (e) { // if element is clicked
                CT.fire('filters.triggeredOnElements', [CT.applyTheseFilters]);
            }

            this.fltData('', '');
            return false;
        },




        updateClasses: function( /* jQuery */ $clickedFilter) {
            
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab)
            if (!$clickedFilter) return this
            if (CT.subProd && CT.subProd == "wg" && !window.isMobileUA) {
                this.scrollToTop();
                    //this.$el.trigger("sticky_kit:detach");
                    //this.$el.trigger("sticky_kit:destroy");

            }
            CT.cache[CT.settings.currentTab].filterClickedEle = $clickedFilter.closest("nav").attr("class");
            if ($clickedFilter.attr('checked') == 'checked') {
                CT.cache[CT.settings.currentTab].filterClickedEleChecked = true
                $clickedFilter.parent().addClass('selected');
            } else {
                CT.cache[CT.settings.currentTab].filterClickedEleChecked = false
                $clickedFilter.parent().removeClass('selected');
            }
        },

        /*
         * Hide destinations on move of slider
         */
        hideDestinations: function(obj) {
            var $eleMap = this.$el.find(".destinations").find("li");
            var $topEleMap = this.$el.find(".destinations").find("li.topDestinations");
            var topDestHiddenCnt = 0;
            for (var i = 0; i < $eleMap.length; i++) {
                if ($($eleMap[i]).attr('data-hrs')) {
                    var tmpHrs = $($eleMap[i]).attr("data-hrs");

                    if (Int(tmpHrs) <= obj.value[1] && Int(tmpHrs) >= obj.value[0]) {
                        $($($eleMap[i]).find("label")).removeClass("disabled");
                        $($eleMap[i]).addClass("toShowEle")
                    } else {
                        $($($eleMap[i]).find("label")).addClass("disabled");
                    }
                    if (obj.value[1] == 10 && Int(tmpHrs) >= 10) {
                        $($($eleMap[i]).find("label")).removeClass("disabled");
                    }
                }
            }
            for (var i = 0; i < $topEleMap.length; i++) {
                if ($($topEleMap[i]).find("label").hasClass("disabled")) {
                    topDestHiddenCnt++
                }
            }
            if (topDestHiddenCnt == $topEleMap.length) {
                var $toShwEle = this.$el.find(".destinations").find("li.toShowEle");
                $toShwEle.show();
                if (this.$el.find(".destinations").find(".allDestinations a").hasClass("shwLess")) {
                    this.$el.find(".destinations").find(".allDestinations a").removeClass("shwLess").addClass("shwMore")
                }
                this.$el.find(".destinations").find(".allDestinations a").trigger("click");
                this.$el.find(".destinations").find(".allDestinations a").html("+ View more destinations")
                this.$el.find(".destinations").find(".allDestinations a").removeClass("shwLess").addClass("shwMore");
                this.$el.find(".destinations").find(".allDestinations").hide();
            } else {

                this.$el.find(".destinations").find(".allDestinations a").removeClass("shwMore").addClass("shwLess");
                this.$el.find(".destinations").find(".allDestinations a").trigger("click");
                this.$el.find(".destinations").find(".allDestinations").show();
            }
        },
        /*
         * Updated the browser url query params to persist the filters informtion, with is used for managing filter states.
         */
        setUrlParams: function(paramsHash, e) {
            var copyingFilterParams = CT.cache[CT.settings.currentTab].searchParams.all.appliedFiltersParmas;
            delete CT.cache[CT.settings.currentTab].searchParams.all.appliedFiltersParmas;
            
            var searchParams = _.deserialize(CT.cache[CT.settings.currentTab].searchParams.all); // TODO change window.location.href to data.url
            
            // remove all the filter params
            _.forEach(CT.settings[CT.app].filterParamList, function(filterParam) {
                delete searchParams[filterParam];
                //TODO:: Locality Filter :: 
                if (( window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ) { 
                    if(CT.cache[CT.settings.currentTab].retainFilters)
                    delete CT.cache[CT.settings.currentTab].retainFilters[filterParam]
                }
            });
            if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                //Cache to retain Filters
                CT.cache[CT.settings.currentTab].retainFilters = CT.cache[CT.settings.currentTab].retainFilters || {};
                // add the current filter state
                if (e) {
                    var filterName = $(e.target).attr("name");
                    if (!paramsHash[filterName]) {
                        CT.cache[CT.settings.currentTab].retainFilters[filterName] ? delete CT.cache[CT.settings.currentTab].retainFilters[filterName] : "";
                        delete CT.cache[CT.settings.currentTab].retainFilters["lastUpdated"];
                    }
                }

            }
            for (var k in paramsHash) {
                if (paramsHash[k].length > 0) {
                    if (paramsHash[k] instanceof Array && k != 'area' && k != 'poi') {
                        searchParams[k] = paramsHash[k].join("-");
                        //Store only when changed....Initially prop and star are selected and amenities are not selected--VijayKrish
                        if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                            if (e && $(e.target).attr("name") == k && (k != "propertyType" || k != "chain"))
                                CT.cache[CT.settings.currentTab].retainFilters[k] = paramsHash[k].join("-");
                        }
                    } else {
                        searchParams[k] = paramsHash[k];
                        if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                            if (k != "price" && k != "area" && k != "poi")
                                CT.cache[CT.settings.currentTab].retainFilters[k] = paramsHash[k];
                        }
                    }
                } else if (searchParams[k]) {
                    delete searchParams[k];

                }

            }
            if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                if (!$.isEmptyObject(CT.cache[CT.settings.currentTab].retainFilters)) {
                    var currentTime = new Date().getTime();
                    CT.cache[CT.settings.currentTab].retainFilters["lastUpdated"] = currentTime;
                }
                localStorage.setItem("recentFilters", JSON.stringify(CT.cache[CT.settings.currentTab].retainFilters));
            }
            if (CT.cache[CT.settings.currentTab].viewType) {
                searchParams["view"] = CT.cache[CT.settings.currentTab].viewType;
            }
            if (CT.subProd && CT.subProd == "wg") {
                delete searchParams.city;
            }
            CT.settings.routes.navigate('/results?' + _.serialize(searchParams), {
                trigger: false,
                replace: true
            })
            CT.cache[CT.settings.currentTab].searchParams.all.appliedFiltersParmas = copyingFilterParams;
            CT.cache[CT.settings.currentTab].searchParams.all = searchParams;
            return this;
        },




        //debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug- FOR QA
        debugMode: function(that) {
            var _paramsHash = _.deserialize(window.location.href.split('results?')[1]),
                _adults = [],
                _child = [];
            if (_paramsHash.showDebug) {

                _.each(_paramsHash, function(val, key) {
                    if (val !== "" && key.indexOf('adults') >= 0) _adults.push({
                        'value': val
                    })
                    if (val !== "" && key.indexOf('child') >= 0) _child.push({
                        'value': val
                    })
                })
                var formObj = {
                    city: _paramsHash.city,
                    state: _paramsHash.state,
                    countryCode: _paramsHash.country,
                    checkIn: _paramsHash.chk_in, //'26/4/2013',
                    checkOut: _paramsHash.chk_out, //'27/4/2013',
                    noOfRooms: _paramsHash.num_rooms,

                    adults: _adults,
                    children: _child,

                    sid: CT.settings.hotel.sid
                }

                $('#ResultContainer_' + CT.settings.currentTab).append(CT.to_html('debugForm', {
                    'debug': formObj
                }))
                var html = '<p><a onclick="javascript:$(\'#ResultContainer_' + CT.settings.currentTab + ' .searchCountForm\').submit()" href="javascript:void(0)">' + CT.messages.hotel.SrchCountAudit + '</a></p>';
                $('#ResultContainer_' + CT.settings.currentTab + ' .filters').prepend(html)

            }
        },
        //debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug- FOR QA




        showHideShowAll: function(e) {
            
            if(e){
                var /* jQuery */ $clicked = $(e.target) 

                var inputLen = $clicked.parents('.filterContent').find('input:checked').length
                var allinputLen = $clicked.parents('.filterContent').find('input').length

                if (window.chunkyFiltersEnabled && inputLen == 0) {
                    $clicked.parents('.sideBlock').find('.showAll').hide();
                }
                else if (inputLen <= allinputLen) {
                    $clicked.parents('.sideBlock').find('.showAll').show();
                }
                else {
                    $clicked.parents('.sideBlock').find('.showAll').hide();
                }
            } 
            else {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                var checkedEle = $currentTab.find('input:checked');
                _.forEach(checkedEle,function(e, index){
                    $(e).parents('.sideBlock').find('.showAll').show();
                });
            }
        },

        fltData: function(e, settings) {
            // check here if the parent of e.target is tags filter, call triggerTagsFilter
            if (e && e.target && e.target.parentElement.parentElement.classList.value === "tagsFilter") {
                CT.fire('triggerTagsFilter', [e, true]);
                var serializedData = _.deserialize(this.$el.find('form').serialize(), hashModifiers);
                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                    "filterType": 'Tags Filter',
                    "filterValue": serializedData.tagsFilter.map(
                        function(tagId) {
                            tagId = tagId.split('_')[0];
                            return CT.tagsData.find(function(tag) {
                                return tagId == tag.tagId;
                            }).tagName;
                        }
                    ).join(','),
                    "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                    "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                });
                return
            }
            //window.L("calling fltData");

            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                tmp, _status = '';
            var areadistance = ""
            if (CT.masterJson.get().clni && 
              CT.masterJson.get().clni.clat && 
              CT.masterJson.get().clni.clng &&
              CT.isLocationEnabled == true) {
                var cityLat = CT.masterJson.get().clni.clat
                var cityLng = CT.masterJson.get().clni.clng
                if (CT.cache[CT.settings.currentTab].autoCompleteLatitude != "" && CT.cache[CT.settings.currentTab].autoCompleteLatitude != undefined) {
                    var areadistance = CT.utils.helperFunctions.getDistanceFromLatLonInKm(CT.cache[CT.settings.currentTab].autoCompleteLatitude, CT.cache[CT.settings.currentTab].autoCompleteLangitude, cityLat, cityLng)
                }
            }
            if (areadistance != "" && areadistance > 50) {
                CT.cache[CT.settings.currentTab].arealDistancegreater = true
            } else {
                CT.cache[CT.settings.currentTab].arealDistancegreater = false
            }
            var paramsObj = CT.cache[CT.settings.currentTab].searchParams.all;
            if (CT.cache[CT.settings.currentTab].searchParams.all.showFewFilter != "" &&
                CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" &&
                CT.isLocationEnabled == true &&
                CT.cache[CT.settings.currentTab].arealDistancegreater != true) {
                $('nav.showFewFilter input').attr('checked', true)
            }
            CT.cache[CT.settings.currentTab].currentTargetClicked = ""

            if (e) {
                if (paramsObj.gn && paramsObj.gn === true) {
                    var obj = {
                        "sid": CT.cache[CT.settings.currentTab].sid,
                        "ppcr": CT.settings[CT.app].guidedNavForLog[$(e.target).closest("nav").attr("class")],
                        "st": 4,
                        "ar": ""
                    }
                    $.extend(true, obj, CT.cache[CT.settings.currentTab].pinPointSearchParams);
                    CT.utils.helperFunctions.dashBoardLogging(obj)
                }
                CT.cache[CT.settings.currentTab].currentTargetClicked = e.currentTarget

                //hide nearby cities notification
                
                if (e.currentTarget.name == "taStarRating") {
                    var $target = e.currentTarget;
                    var pEle = 'label';
                    var index = $($target).parents(pEle).index() //$target.parents('li').index();
                    if ($target.checked == true) {
                        $($target).parents('.taStarRating').find('input').attr('checked', false)
                        $($target).parents('.taStarRating').find(''+ pEle +':lt(' + index + '),'+ pEle +':eq(' + index + ')').find('input:checkbox').attr('checked', true);
                    } else {
                        if ($($target).parents('.taStarRating').find(''+ pEle +':gt(' + index + ')').find('input:checkbox').attr('checked')) {
                            $target.checked = true
                        }
                        $($target).parents('.taStarRating').find(''+ pEle +':gt(' + index + ')').find('input:checkbox').attr('checked', false);
                    }
                }
            } else {
                this.showHideShowAll();
            }

            // 1) update classes and ui first
            this.updateClasses($clicked)

            /*if (CT.applyTheseFilters.am.length > 0)
                this.$el.trigger("amenities.show", [true]);
            else
                this.$el.trigger("amenities.show", [false]);*/
            //this.showAllHotelsLink()/*.sendFltObj(settings);*/
            if (CT.subProd && CT.subProd == "wg") {
                this.$el.find('.filtersForm input').removeAttr("disabled");
            }
            if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == true && CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" && CT.isLocationEnabled == true && CT.cache[CT.settings.currentTab].arealDistancegreater != true) {
                $('nav.showFewFilter input').attr('checked', true)
            }
            if (CT.cache[CT.settings.currentTab].arealDistancegreater == true || CT.masterJson.get().hdfmn == "") {
                $('nav.showFewFilter input').attr('checked', false)
            }
            var locationUrldata = _.deserialize(window.location.search)
            var serializedData = _.deserialize(this.$el.find('form').serialize(), hashModifiers);
            if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == false || 
              CT.cache[CT.settings.currentTab].showFewHotelsDistance == "") {
                serializedData.showFewFilter = ""
                $('nav.showFewFilter input').attr('checked', false)
            }
            if(locationUrldata.poi!="" && 
              CT.cache[CT.settings.currentTab].latitude=="" &&
               CT.cache[CT.settings.currentTab].longitude=="" 
               && CT.isLocationEnabled==true){
                serializedData.showFewFilter = ""
                $('nav.showFewFilter input').attr('checked', false)
               CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal = false
            }

            //if tags are already applied than keep them
            if(locationUrldata.tagsFilter){
                serializedData.tagsFilter = locationUrldata.tagsFilter
            }
            
            if (!settings || !settings.onload) { // change url with filter params if the flow is not onload.
                this.setUrlParams(serializedData, e);
            }
            if (e && serializedData) {
                try {
                    if (window.moengageEnabled && CT.utils.moengageTrackingObj && serializedData) {
                        var minPrice = "";
                        var maxPrice = "";
                        var minPriceSelected = (serializedData.price && serializedData.price != "") ? serializedData.price.split("-")[0] : "";
                        var maxPriceSelected = (serializedData.price && serializedData.price != "") ? serializedData.price.split("-")[1] : "";
                        var filterMoengageObj = CT.utils.moengageTrackingObj;
                        filterMoengageObj.pahf = serializedData.payAtHotel ? "y" : "n";
                        filterMoengageObj.ppf = "";
                        filterMoengageObj.fc = serializedData.freeCancellation ? "y" : "n";
                        filterMoengageObj.pll = minPrice;
                        filterMoengageObj.pls = minPriceSelected;
                        filterMoengageObj.phl = maxPrice;
                        filterMoengageObj.phs = maxPriceSelected;
                        filterMoengageObj.sr1 = (serializedData.starFilter && serializedData.starFilter.indexOf("1") > -1) ? "y" : "n";
                        filterMoengageObj.sr2 = (serializedData.starFilter && serializedData.starFilter.indexOf("2") > -1) ? "y" : "n";
                        filterMoengageObj.sr3 = (serializedData.starFilter && serializedData.starFilter.indexOf("3") > -1) ? "y" : "n";
                        filterMoengageObj.sr4 = (serializedData.starFilter && serializedData.starFilter.indexOf("4") > -1) ? "y" : "n";
                        filterMoengageObj.sr5 = (serializedData.starFilter && serializedData.starFilter.indexOf("5") > -1) ? "y" : "n";
                        filterMoengageObj.tal = (serializedData.taStarRating && serializedData.taStarRating.split("-")[0]) ? serializedData.taStarRating.split("-")[0] : "N/A";
                        filterMoengageObj.tah = (serializedData.taStarRating && serializedData.taStarRating.split("-")[1]) ? serializedData.taStarRating.split("-")[1] : "N/A";
                        filterMoengageObj.ls = serializedData.area ? "y" : "n";
                        filterMoengageObj.lv = serializedData.area ? serializedData.area : "";
                        filterMoengageObj.prps = serializedData.propertyType ? "y" : "n";
                        filterMoengageObj.prpv = serializedData.propertyType ? serializedData.propertyType : "";
                        filterMoengageObj.as = serializedData.amenity ? "y" : "n";
                        filterMoengageObj.av = serializedData.amenity ? serializedData.amenity : "";
                        CT.utils.helperFunctions.tpTrack({
                            'tp': 'moengage',
                            'category': 'hfa',
                            'values': filterMoengageObj
                        });
                    }
                } catch (e) {}
            }

            this.applyFilters(serializedData);
            //this.showAllHotelsLink();
            // var priceFilterValuesOnSrp = [];
            
            if (e) {
                
                if($(e.target).is(':checked')){
                    CT.utils.trackers.mixpanelTrackingData.NumberOfFilters = String(parseInt(CT.utils.trackers.mixpanelTrackingData.NumberOfFilters) + 1);
                } else {
                    CT.utils.trackers.mixpanelTrackingData.NumberOfFilters = String(parseInt(CT.utils.trackers.mixpanelTrackingData.NumberOfFilters) - 1);
                }
                if ( $(e.target).closest("nav").attr("class") === "priceFilter" && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b' ) {
                    // priceFilterValuesOnSrp.push($(e.target).val())
                    //_status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Price', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_Price_Checkbox',
                        "filterValue": serializedData.priceFilter.join(','),
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "deals") {
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_WithDeals', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_withDeals',
                        "filterValue": _status,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "popHotels") {
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_BestSellers', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_bestSellers',
                        "filterValue": _status,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "payAtHotel") {
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_PayAtHotel', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_payAtHotel',
                        "filterValue": _status,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "freeCancellation") {
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_FreeCancellation', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_freeCancellation',
                        "filterValue": _status,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "quickeys") {
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_quickeys', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_quickKeys',
                        "filterValue": _status,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "starFilter") {
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Star', 'Star' + e.target.value + "_" + _status, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_star',
                        "filterValue": ('Star' + e.target.value + "_" + _status),
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "taStarRating") {
                    _status = $(e.target).val() ? $(e.target).val() : "N/A"
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_taStarRating', 'Star' + e.target.value + "_" + _status, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_taStarRating',
                        "filterValue": String(_status),
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "locality") {
                    var label = _.capitalize($(e.target).attr("data-flt")) + "_" + $(e.target).attr("value");
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Location', label + "_" + _status, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_locSelected',
                        "filterValue": (label + "_" + _status),
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "lolfilter") {
                    // var label = _.capitalize($(e.target).attr("data-flt")) + "_" + $(e.target).attr("value");
                    var label = $(e.target).attr("value");
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Location', label + "_" + _status, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'Locality',
                        "filterValue": label,
                        "status": _status,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if ($(e.target).closest("nav").attr("class") === "destinations") {
                    var label = _.capitalize($(e.target).attr("data-flt")) + "_" + $(e.target).next("span").html().trim(" ");
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Destinations', label + "_" + _status, '100');
                } else if ($(e.target).closest("nav").attr("class") === "destinationsTheme") {
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_DestinationsTheme', 'DestinationsTheme' + $(e.target).next("span").html().trim(" ") + "_" + _status, '100');
                } else if ($(e.target).closest("nav").attr("class") === "hotelsTheme") {
                    _status = $(e.target).is(':checked') ? "On" : "Off";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_HotelsTheme', 'HotelsTheme' + $(e.target).next("span").html().trim(" ") + "_" + _status, '100');
                } else if ($(e.target).closest("nav").attr("class") === "priceFilter") {
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR_2col', 'H_Filter_Bucket_Price', 'HotelBucketPrice' + e.target.value, '100');
                } else if ($(e.target).closest("nav").attr("class") === "chain") {
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_hotelChain',
                        "filterValue": $(e.target).val(),
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                }
                $currentTab.trigger('nearByNotification.hide');
                if ($currentTab.find(".srpInpageMessage").length > 0) {
                    CT.cache[CT.settings.currentTab].removeUndo = true;
                } else {
                    CT.cache[CT.settings.currentTab].removeUndo = false;
                }
                var /* jQuery */ $clicked = $(e.target)
                this.showHideShowAll(e)
                CT.cache[CT.settings.currentTab].filterClicked = true
                CT.cache[CT.settings.currentTab].mapDragged = false;
                if($(e.target).closest("nav").attr("class") !="showFewFilter"){
                prevFilterEle.push(CT.cache[CT.settings.currentTab].recentFilterData ? CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle[CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.length - 1] : undefined)
                currentFilterEle.push($(e.target).closest("nav").attr("class"));
                prevSerializedData.push(CT.cache[CT.settings.currentTab].recentFilterData ? CT.cache[CT.settings.currentTab].recentFilterData.currentSerializedData[CT.cache[CT.settings.currentTab].recentFilterData.currentSerializedData.length - 1] : undefined)
                currentSerializedData.push(_.deserialize(this.$el.find('form').serialize(), hashModifiers));
                CT.cache[CT.settings.currentTab].recentFilterData = {
                    "prevFilterEle": prevFilterEle,
                    "currentFilterEle": currentFilterEle,
                    "prevSerializedData": prevSerializedData,
                    "currentSerializedData": currentSerializedData
                }
            }
                if ((tmp = $(e.target).closest("nav")).attr("class") === "locality") {
                    CT.masterJson.get().clusterMapItems = undefined;

                    if (tmp.find('input:checked').length > 1 || tmp.find('input:checked').length == 0)
                        $currentTab.find('.smallSearch input, .mapViewSearch input').val('');

                    if (!CT.cache[CT.settings.currentTab].onLoad) {
                        CT.cache[CT.settings.currentTab].hideMessages.localityNotification = true;
                    }
                }
                var _eventTarget = $(e.target);
                if (_eventTarget.parents(".propertyType").length >= 1) {
                    // user is filtering based on property types.
                    var code = '',
                        action = 'H_Filter_Prop',
                        _status = '';
                    if (_eventTarget.is("input")) {
                        code = _eventTarget.attr("value");
                        _status = _eventTarget.is(":checked") ? "On" : "Off";
                    } else if (_eventTarget.is("a")) {
                        action = 'H_Filter_PropOnly';
                        code = _eventTarget.siblings("[type=checkbox]").attr("value");
                        _status = "On";
                    }
                    // send a trackGAEvent.
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', action, code + "_" + _status, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_propType',
                        "filterValue": code + "_" + _status,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                } else if (_eventTarget.parents(".amenity").length >= 1) {
                    // user is filtering based on amenity.
                    var code = '',
                        action = 'H_Filter_Amenities',
                        _status = '';
                    if (_eventTarget.is("input")) {
                        code = _eventTarget.attr("value");
                        _status = _eventTarget.is(":checked") ? "On" : "Off";
                    }
                    // send a trackGAEvent.
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', action, code + "_" + _status, '100');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                        "filterType": 'filter_amenities',
                        "filterValue": code + "_" + _status,
                        "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                    });
                }
            }
            return this;
        },




        setData: function( /* Hash of hotels*/ ht) { // 'ht' = { exact : [], others : [] }
            var cache = CT.cache[CT.settings.currentTab]
                //cache.filteredHt = _.groupBy(json.ht, prop('id'))
            if (!ht.others) {
                ht.others = []
            }
            cache.filteredHt = ht
            return cache.filteredHt
        },


        getData: function() {
            return CT.cache[CT.settings.currentTab].filteredHt
        },


        // @return Returns a grouped object of exact and 'other' hotels
        getExactAreaHotels: function( /* Array of checked areas*/ areas, /* Array hotels*/ filtered) {
            if (!areas) return {
                'true': [],
                'false': filtered
            }
            if (CT.isLocationEnabled == true) {
                var areaInfo = CT.utils.findAreaLatLng(areas[0])
                var localityId = areaInfo.localityId;
                var grouped = _.groupBy(filtered, function(hotel) {
                    if (hotel.hasSpriteIcon && hotel.classToarea) {
                        delete hotel.hasSpriteIcon;
                        delete hotel.classToarea;
                    }
                    if (hotel.distanceFromAreaString)
                        delete hotel.distanceFromAreaString;
                    if (hotel.distanceFromLocation)
                        delete hotel.distanceFromLocation;
                    if (hotel.areaSearch || hotel.poiSearch || hotel.isgoogleSearch) {
                        hotel.areaSearch = false
                        hotel.poiSearch = false
                            // hotel.isgoogleSearch = false
                    }
                    if (_.indexOf(areas, $.trim(hotel.ar)) >= 0) {
                        hotel.hasSpriteIcon = "<i class='hotelSprite mapPinLocality'></i>";
                        hotel.classToarea = "poiName highlightMe";
                        if (!hotel.isgoogleSearch)
                            hotel.areaSearch = true;
                        hotel.locId = localityId;
                        return true;
                    } else
                        return false
                });
                $('nav.sorters .location').text("");

            } else {
                var grouped = _.groupBy(filtered, function(hotel) {
                    return _.indexOf(areas, $.trim(hotel.ar)) >= 0
                })

            }
            return {
                'true': grouped['true'] || [],
                'false': grouped['false'] || []
            }
        },



        // @return Returns a grouped object of pois and 'other' hotels
        getExactPoiHotels: function( /* Array of checked pois */ pois, /* Array hotels */ filtered) {
            if (!pois) return {
                'true': [],
                'false': filtered
            }
            var found;
            if (CT.isLocationEnabled == true) {
                var poiInfo = CT.utils.findPOILatlng(pois[0]);
                if (poiInfo.latlng)
                    var poiLatLng = poiInfo.latlng;
                else
                    var poiLatLng = CT.cache[CT.settings.currentTab].googleSortedPoiLatLng;
                var localityId = poiInfo.localityId;
                var grouped = _.groupBy(filtered, function(hotel) {
                    if (hotel.hasSpriteIcon && hotel.classToarea) {
                        delete hotel.hasSpriteIcon;
                        delete hotel.classToarea;
                    }
                    if (hotel.distanceFromAreaString)
                        delete hotel.distanceFromAreaString;
                    if (hotel.distanceFromLocation)
                        delete hotel.distanceFromLocation;
                    if (hotel.areaSearch || hotel.poiSearch || hotel.isgoogleSearch) {
                        hotel.areaSearch = false
                        hotel.poiSearch = false
                            // hotel.isgoogleSearch = false
                    }
                    found = _.find(pois, function(poi) {
                        if (poiLatLng && hotel.latlng) {
                            var distanceFromArea = CT.utils.findDistance(poiLatLng, hotel.latlng);
                            hotel.distanceFromLocation = parseInt(distanceFromArea * 1000)
                            if (!hotel.isgoogleSearch)
                                hotel.poiSearch = true;
                            hotel.locId = localityId;
                            if (distanceFromArea > 1000)
                                hotel.distanceFromAreaString = distanceFromArea.toFixed(1) % 1 !== 0 ? (distanceFromArea.toFixed(1) + " km from " + poi) : (distanceFromArea.toFixed() + " km from " + poi);
                            else
                                hotel.distanceFromAreaString = distanceFromArea.toFixed(1) + " km from " + poi;
                            return true
                        } else
                            hotel.distanceFromLocation = 63720000;
                    })
                    return found ? true : false
                })
                if ($("#ResultContainer_" + CT.settings.currentTab).find("nav.sorters .location").css("display") == "none") {
                    $("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters .location').text('Distance from ' + pois[0]).css('display', 'block');
                    $("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters .location').trigger("click");
                }
            } else {
                var grouped = _.groupBy(filtered, function(hotel) {
                    found = _.find(pois, function(poi) {
                        var poiLatLng = CT.utils.findPOILatlng(poi)
                        if ((poiLatLng && hotel.latlng) && CT.utils.findDistance(poiLatLng, hotel.latlng) <= CT.settings[CT.app].filters.constants.areaPoiRadius) return true
                    })
                    return found ? true : false
                })
            }
            return {
                'true': grouped['true'] || [],
                'false': grouped['false'] || []
            }
        },




        getRadialHotels: function( /* String*/ areas, /* Array hotels*/ filtered) {
            if (!areas) return {
                'true': [],
                'false': filtered
            }
            var found;
            if (CT.isLocationEnabled == true) {
                var areaInfo = CT.utils.findAreaLatLng(areas[0])
                var arLatLng = areaInfo.latlng;
                var grouped = _.groupBy(filtered, function(hotel) {
                    if (hotel.hasSpriteIcon && hotel.classToarea) {
                        delete hotel.hasSpriteIcon;
                        delete hotel.classToarea;
                    }
                    if (hotel.distanceFromAreaString)
                        delete hotel.distanceFromAreaString;
                    if (hotel.distanceFromLocation)
                        delete hotel.distanceFromLocation;
                    if (hotel.areaSearch || hotel.poiSearch || hotel.isgoogleSearch) {
                        hotel.areaSearch = false
                        hotel.poiSearch = false
                        hotel.isgoogleSearch = false
                    }
                    found = _.find(areas, function(area) {
                        if (arLatLng && hotel.latlng) {
                            var distanceFromArea = CT.utils.findDistance(arLatLng, hotel.latlng);
                            hotel.distanceFromLocation = parseInt(distanceFromArea * 1000)
                            if (distanceFromArea > 1000)
                                hotel.distanceFromAreaString = distanceFromArea.toFixed(1) % 1 !== 0 ? (distanceFromArea.toFixed(1) + " km from " + area) : (distanceFromArea.toFixed() + " km from " + area);
                            else
                                hotel.distanceFromAreaString = distanceFromArea.toFixed(1) + " km from " + area;
                            return true
                        } else
                            hotel.distanceFromLocation = 637200;
                    })
                    return found ? true : false
                })
            } else {
                var grouped = _.groupBy(filtered, function(hotel) {
                    found = _.find(areas, function(area) {
                        var arLatLng = CT.utils.findAreaLatLng(area)
                        if ((arLatLng && hotel.latlng) && CT.utils.findDistance(arLatLng, hotel.latlng) <= CT.settings[CT.app].filters.constants.areaPoiRadius) return true
                    })
                    return found ? true : false
                })
            }
            return {
                'true': grouped['true'] || [],
                'false': grouped['false'] || []
            }
        },



        /*  hideFilters : function(key,arr){
            var filtersList = ["destinationsTheme","hotelsTheme"];
            var destListshown = $(".destinations").find("li")
            _.each(filtersList,function(ele){
                var liList = $("."+ele).find("li label");
                for(var k in liList){
                    if(!liList[k].hasClass("disabled")){
                        
                    }
                } 
            })
            
        },*/
        getFilterCnt: function(arr) {
            var cnt = _.groupBy(arr, function(dth) {
                if (dth) {
                    return dth.n
                }
            })
            arr = _.uniq(arr, function(dth) {
                if (dth) {
                    return dth.n;
                }
            });
            for (var i = 0; i < arr.length; i++) {
                if (arr[i]) {
                    arr[i].cnt = cnt[arr[i].n].length;
                }
            }
        },
        hideFilters: function(filtered) {
            var destinationsList = [],
                destinationsThemeList = [],
                hotelsThemeList = [];

            _.forEach(filtered, function(obj, index) {
                destinationsList.push({
                    "n": obj.c.toString()
                });
                //if(CT.cache[CT.settings.currentTab].filterClickedEle != "destinationsTheme"){
                if (obj.dth) {
                    if (obj.dth.length > 0) {
                        for (var i = 0; i < obj.dth.length; i++) {
                            destinationsThemeList.push({
                                "n": obj.dth[i]
                            })
                        }
                    } else {
                        destinationsThemeList.push({
                            "n": "NOCAT"
                        })
                    }
                }
                /*}else{
                    var inpItem = $(".destinationsTheme").find("li input");
                    for(var k=0;k<inpItem.length;k++){
                        if($(inpItem[k]).closest("label").hasClass("disabled") == false){
                            destinationsThemeList.push({"n":inpItem[k].value})
                        }
                    }
                }*/
                //if(CT.cache[CT.settings.currentTab].filterClickedEle != "hotelsTheme"){
                if (obj.hth) {
                    if (obj.hth.length > 0) {
                        for (var i = 0; i < obj.hth.length; i++) {
                            hotelsThemeList.push({
                                "n": obj.hth[i]
                            })
                        }
                    } else {
                        hotelsThemeList.push({
                            "n": "NOCAT"
                        })
                    }
                }
                /*}else{
                    var inpItem = $(".hotelsTheme").find("li input");
                    for(var k=0;k<inpItem.length;k++){
                        if($(inpItem[k]).closest("label").hasClass("disabled") == false){
                            hotelsThemeList.push({"n":inpItem[k].value})
                        }
                    }
                }*/
            })

            destinationsList = this.wgThemeCnt(destinationsList);
            destinationsThemeList = this.wgThemeCnt(destinationsThemeList);
            hotelsThemeList = this.wgThemeCnt(hotelsThemeList);
            //console.log(destinationsList);
            //console.log(destinationsThemeList);
            //console.log(hotelsThemeList);
            if (window.altFilters == "true") {
                var filtersList = ["destinations", "hotelsTheme"];

            } else {
                var filtersList = ["destinations", "destinationsTheme", "hotelsTheme"];

            }
            _.each(filtersList, function(ele) {
                if (CT.cache[CT.settings.currentTab].filterClickedEle != ele) {
                    var inpItem = $("." + ele).find("li input");
                    for (var k = 0; k < inpItem.length; k++) {
                        var isPresent = _.find(eval(ele + "List"), {
                            'n': $(inpItem[k]).val()
                        });
                        if (isPresent == undefined) {
                            $(inpItem[k]).closest("label").addClass("disabled");
                            $(inpItem[k]).attr("disabled", "disabled")
                        } else {
                            $(inpItem[k]).closest("label").removeClass("disabled");
                            $(inpItem[k]).removeAttr("disabled");
                            $(inpItem[k]).closest("label").find('small').html(isPresent.cnt);
                        }
                    }
                    if (ele == "destinations") {
                        var $topEleMap = $("." + ele).find("li.topDestinations");
                        var topDestHiddenCnt = 0;
                        var destCount = $("." + ele).find("li label").length - $("." + ele).find("li label.disabled").length;
                        for (var i = 0; i < $topEleMap.length; i++) {
                            if ($($topEleMap[i]).find("label").hasClass("disabled")) {
                                topDestHiddenCnt++
                            }
                        }
                        if (window.altFilters == false) {
                            if (topDestHiddenCnt == $topEleMap.length) {
                                var $toShwEle = $("." + ele).find("li.toShowEle");
                                $toShwEle.show();
                                if ($("." + ele).find(".allDestinations a").hasClass("shwLess")) {
                                    $("." + ele).find(".allDestinations a").removeClass("shwLess").addClass("shwMore")
                                }
                                $("." + ele).find(".allDestinations a").trigger("click");
                                $("." + ele).find(".allDestinations a").html("+ View " + destCount + " more destinations")
                                $("." + ele).find(".allDestinations a").removeClass("shwLess").addClass("shwMore");
                                $("." + ele).find(".allDestinations").hide();
                            } else {
                                $("." + ele).find(".allDestinations a").removeClass("shwMore").addClass("shwLess");
                                $("." + ele).find(".allDestinations a").trigger("click");
                                $("." + ele).find(".allDestinations").show();
                            }
                        }

                    }
                } else {
                    var inpItem = $("." + ele).find("li input");
                    var isSelectedCnt = 0;
                    for (var k = 0; k < inpItem.length; k++) {
                        var isPresent = _.find(eval(ele + "List"), {
                            'n': $(inpItem[k]).val()
                        });

                        if (isPresent == undefined) {
                            //$(inpItem[k]).closest("label").addClass("disabled");
                            if ($(inpItem[k]).closest("label").hasClass("disabled") == true) {
                                $(inpItem[k]).attr("disabled", "disabled")
                            }

                        } else {
                            /*if($(inpItem[k]).closest("label").hasClass("disabled") == true){
                                $(inpItem[k]).closest("label").removeClass("disabled");
                                $(inpItem[k]).removeAttr("disabled");
                            }*/
                            //$(inpItem[k]).closest("label").removeClass("disabled");
                            if ($(inpItem[k]).closest("label").hasClass("disabled") == true) {
                                $(inpItem[k]).closest("label").removeClass("disabled");
                            }
                            isSelectedCnt++
                            $(inpItem[k]).closest("label").find('small').html(isPresent.cnt);
                        }
                    }
                    if (isSelectedCnt == inpItem.length) {
                        $("." + ele).find("li input").removeAttr("disabled");
                        $("." + ele).find("li label").removeClass("disabled")
                    }
                }
            })

            CT.cache[CT.settings.currentTab].filterClickedEle = undefined;


            /*var filtersList = ["destinationsTheme","hotelsTheme"];
            //_.each(filtersList,function(ele){
                var inpItem = $(".destinationsTheme").find("li input");
                for(var k in inpItem){
                    var isPresent = _.contains("destinationsThemeList", inpItem[k].value);
                    if(isPresent == false){
                        $(inpItem[k]).closest("label").addClass("disabled");
                    }else{
                        $(inpItem[k]).closest("label").removeClass("disabled");
                    }
                } 
            //})
            
            */
        },
        hotelContainsLocalities: function(hotel, localities) {
            var answer = false;
            localities.forEach(function(locality) {
                answer = answer || hotel.ar.indexOf(locality) !== -1;
            })
            return answer;
        },
        applyBasicFilters: function( /* Hash of filters*/ applyFilters, /* Array */ filtered) {
            
            var allQueryParams = CT.cache.tabsMap[CT.settings.currentTab]
            console.log("allQueryParams", allQueryParams);
            if (window.localities && window.localities.length) {
                // var localities = allQueryParams.localities.split(',');
                var localities = window.localities;
                console.log("localities", localities);
                filtered = filtered.filter(function(hotel) {
                    return filter.hotelContainsLocalities(hotel, localities);
                })
            }
            
            var tmp;
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
            var hideClearFilterCnt = 0;
            var tmpResults;
            var resultSet = [];
            tmp = _.keys(applyFilters);
            if (!(_.indexOf(tmp, 'starFilter') >= 0))
                applyFilters.starFilter = "";

            if (!(_.indexOf(tmp, 'propertyType') >= 0))
            //applyFilters.propertyType = [" "]
                applyFilters.propertyType = "";

            if (this.$el.find('.nearByCities').length > 0 && !(_.indexOf(tmp, 'nearByCities') >= 0))
                applyFilters.nearByCities = 'off'

            if (CT.subProd == "wg") {
                if (!(_.indexOf(tmp, 'destinations') >= 0))
                    applyFilters.destinations = "";

                if (!(_.indexOf(tmp, 'destinationsTheme') >= 0))
                    applyFilters.destinationsTheme = "";

                if (!(_.indexOf(tmp, 'hotelsTheme') >= 0))
                    applyFilters.hotelsTheme = "";

            }

            _.each(applyFilters, function(filterArr, key) {
                if (filterArr != '') {
                    /*if(CT.subProd && CT.subProd == "wg"){
                        filtered = _(CT.masterJson.get().ht).filter(filterByProp(key, filterArr)).value();
                    }else{
                        filtered = _(filtered).filter(filterByProp(key, filterArr)).value();
                    }*/
                    // if((event.target.value=="4.5-5" && $('.taStarRating li input:checked').val()=="4.5-5") || $('.taStarRating li input:checked').val()=="4.5-5"){
                    //     filtered= _(filtered).filter(function(obj){if(obj.tar>=4.5){return true}}).value()
                    // }else{
                    filtered = _(filtered).filter(filterByProp(key, filterArr)).value();
                    // }
                    /*if(filtered.length != CT.masterJson.get().ht.length){
                        //resultSet.push($.extend( false, resultSet ,filtered));
                        resultSet = resultSet.concat(filtered)
                    }*/
                    if (CT.subProd && CT.subProd == "wg" && window.altFilters == "true") {
                        filter.updateAltFiltersClass(key, filterArr);
                    }
                } else if (filterArr == "" && (key == "destinationsTheme" || key == "hotelsTheme")) {
                    if (CT.subProd && CT.subProd == "wg" && window.altFilters == "true") {
                        hideClearFilterCnt++;
                    }
                }
            });
            /*if(resultSet.length == 0){
            //  resultSet = resultSet.concat(filtered)
        }*/ //
            if (CT.subProd && CT.subProd == "wg") {
                filter.hideFilters(filtered);
                if (window.altFilters == "true" && hideClearFilterCnt == 2) {
                    $currentTab.find(".othersFilterButton").removeClass("setFilterButton");
                }
            }
            CT.cache[CT.settings.currentTab].updateStarRatingCount = false
            CT.cache[CT.settings.currentTab].updateTaRatingCount = false
            var $target = CT.cache[CT.settings.currentTab].currentTargetClicked
            if ($target != "" && $target.checked == true && $target.name == "starFilter") {
                CT.cache[CT.settings.currentTab].updateStarRatingCount = true
            }
            if ($target != "" && $target.checked == true && $target.name == "taStarRating") {
                CT.cache[CT.settings.currentTab].updateTaRatingCount = true
            }
            //if (filtered)
              //  this.$el.find('.filtersForm').trigger("filter.repaintFilterCount", [filtered])
            if(window.chunkyFiltersEnabled){
                this.repaintFilterCounts();
            }
            return {
                exact: filtered
            }

        },
        repaintFilterCounts: function(e){
            
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab).find('.filtersForm');
            
            //var startTime = new Date().getTime();
            //This list indicates for which all filters we are updating/displaying the count
            //TODO:: Locality Filter :: Remove localities from below line 
            var updateFilterList = ["taStarRating","starFilter","payAtHotel","freeCancellation","chain","amenity","propertyType","deals", "localities"];
            
            var appliedFilters = this.getFilterFormData();
            //console.log("apply filter --- >> " , appliedFilters);

            //This object will consist of filters other than updateFilterList to apply initiallty on masterjson
            var otherFilters = {};

            if(appliedFilters["taStarRating"]){
                appliedFilters["taStarRating"] = appliedFilters["taStarRating"].split("-");
            }
            if(appliedFilters["price"]){
                appliedFilters["price"] = appliedFilters["price"].split("-");
            }
            
            appliedFilters = _.each(appliedFilters,function(value,key,json){
                if(value == ""){
                    delete json[key];
                }else if(_.indexOf(updateFilterList , key) < 0){
                    otherFilters[key] = json[key];
                    delete json[key];
                }
            });


            // console.log("appliedFilters  --- >> " ,appliedFilters);
            // console.log("otherApplied filters -- >> ", otherFilters);
            
            var mJson = CT.masterJson.get().ht;
            if(otherFilters){
                _.each(otherFilters, function(filterArr, key) {
                    if (filterArr != '') {
                        mJson = _(mJson).filter(filterByProp(key, filterArr)).value();   
                    } 
                });
            }
            
            if (CT.cache[CT.settings.currentTab].longitude != "" && CT.cache[CT.settings.currentTab].latitude != "") {
                if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == true &&
                    CT.isLocationEnabled &&
                    CT.cache[CT.settings.currentTab].pointOfIntrestValue != "" &&
                    CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" &&
                    CT.isLocationEnabled == true){
                    mJson =  _.filter(mJson,function(hotel){
                        return hotel.priceInfo;
                    });
                }
            }
            /* Star Rating Count Start */
            var starRatingCount = {
                "star5": 0,
                "star4": 0,
                "star3": 0,
                "star2": 0,
                "star1": 0
            };
            var filterExceptStar = _.clone(appliedFilters);
            if(filterExceptStar.hasOwnProperty("starFilter")){
                delete filterExceptStar["starFilter"];
            }
            var starRatingFilteredData =mJson;
            _.each(filterExceptStar, function(filterArr, key) {
                if (filterArr != '') {
                    starRatingFilteredData = _(starRatingFilteredData).filter(filterByProp(key, filterArr)).value();   
                } 
            });
            _.each(starRatingFilteredData, function(hotel){
                if(hotel.sr == 5){
                    starRatingCount["star5"] ++;
                }else if(hotel.sr == 4){
                    starRatingCount["star4"] ++;
                }else if(hotel.sr == 3){
                    starRatingCount["star3"] ++;
                }else if(hotel.sr == 2){
                    starRatingCount["star2"] ++;
                }else if(hotel.sr == 1){
                    starRatingCount["star1"] ++;
                }else{
                    starRatingCount["star1"] ++;
                    //console.log("no start rating found for this hotel");
                }
            })
            // console.log("starrating filtered data --->>>> " ,starRatingFilteredData);
            // console.log("starrating filtered count --->>>> ",starRatingCount);
            /* Star Rating Count End*/


            /* TA Rating Count Start */
            var taRatingCount = {
                "tar5": 0,
                "tar45": 0,
                "tar4": 0,
                "tar35": 0,
                "tar3": 0
            };
            var filterExceptTA = _.clone(appliedFilters);
            if(filterExceptTA.hasOwnProperty("taStarRating")){
                delete filterExceptTA["taStarRating"];
            }
            var taRatingFilteredData =mJson;
                _.each(filterExceptTA, function(filterArr, key) {
                    if (filterArr != '') {
                        taRatingFilteredData = _(taRatingFilteredData).filter(filterByProp(key, filterArr)).value();   
                    } 
                });
            _.each(taRatingFilteredData, function(hotel){
                if (hotel.tar == 5) {
                    taRatingCount["tar5"]++
                    taRatingCount["tar45"]++
                    taRatingCount["tar4"]++
                    taRatingCount["tar35"]++
                    taRatingCount["tar3"]++
                } else if (hotel.tar >= 4.5) {
                    taRatingCount["tar45"]++
                    taRatingCount["tar4"]++
                    taRatingCount["tar35"]++
                    taRatingCount["tar3"]++
                } else if (hotel.tar >= 4) {
                    taRatingCount["tar4"]++
                    taRatingCount["tar35"]++
                    taRatingCount["tar3"]++
                } else if (hotel.tar >= 3.5) {
                    taRatingCount["tar35"]++
                    taRatingCount["tar3"]++
                } else if (hotel.tar >= 3) {
                    taRatingCount["tar3"]++
                }
            })
            // console.log("taRating filtered data --->>>> ",taRatingFilteredData);
            // console.log("taRating filtered count --->>>> ",taRatingCount);
            /* TA Rating Count End*/

            /* Pah count start*/
            var payAtHotelCount = 0;
            var filterExceptPAH = _.clone(appliedFilters);
            if(filterExceptPAH.hasOwnProperty("payAtHotel")){
                delete filterExceptPAH["payAtHotel"];
            }
            var pahFilteredData =mJson;
            _.each(filterExceptPAH, function(filterArr, key) {
                if (filterArr != '') {
                    pahFilteredData = _(pahFilteredData).filter(filterByProp(key, filterArr)).value();   
                } 
            });
            payAtHotelCount = _.filter(pahFilteredData,function(hotel){
                return hotel.pp && hotel.pp == 1;
            }).length;
            // console.log("pah filtered data --->>>> ",pahFilteredData);
            //console.log("pah filtered count --->>>> ",payAtHotelCount);
            /* Pah count End*/

            /* free cancellation start*/
            var fcHotelCount = 0;
            var filterExceptFC = _.clone(appliedFilters);
            if(filterExceptFC.hasOwnProperty("freeCancellation")){
                delete filterExceptFC["freeCancellation"];
            }
            var fcFilteredData =mJson;
            _.each(filterExceptFC, function(filterArr, key) {
                if (filterArr != '') {
                    fcFilteredData = _(fcFilteredData).filter(filterByProp(key, filterArr)).value();   
                } 
            });
            fcHotelCount = _.filter(fcFilteredData,function(hotel){
                return hotel.fc && hotel.fc == true;
            }).length;
            //fcFilteredData ? fcFilteredData.length : fcHotelCount;
            // console.log("fc filtered data --->>>> ",fcFilteredData);
            // console.log("fc filtered count --->>>> ",fcHotelCount);
            /* free cancellation count End*/

            /*Hotel chain count start*/
            var hotelChainFiteredData = mJson;
            var filterExcepthotelChain = _.clone(appliedFilters);
            if(filterExcepthotelChain.hasOwnProperty("chain")){
                delete filterExcepthotelChain["chain"];
            }

            _.each(filterExcepthotelChain, function(filterArr, key) {
                if (filterArr != '') {
                    hotelChainFiteredData = _(hotelChainFiteredData).filter(filterByProp(key, filterArr)).value();   
                } 
            });

            var hotelChainCount = {};

            hotelChainCount = _.groupBy(hotelChainFiteredData,function(hotel){
                    return hotel.ch;
            });
                
            //for updating modal window hotel chain count
            _.each(CT.cache[CT.settings.currentTab].sortedHotelChains,function(val,idx){
                if(hotelChainCount.hasOwnProperty(val.name)){
                    CT.cache[CT.settings.currentTab].sortedHotelChains[idx].count = hotelChainCount[val.name].length;
                }else{
                    CT.cache[CT.settings.currentTab].sortedHotelChains[idx].count = 0;   
                }
            });

            // console.log("hotelChain filtered data ---->>> ",hotelChainFiteredData);
             //console.log("hotelChainCount --- >>> ", hotelChainCount);
            
            /*Hotel chain count End*/

            /*Hotel Amenities count start*/
            var hotelAmenitiesFltData = mJson;
            var filterExceptAmenity = _.clone(appliedFilters);
            if(filterExceptAmenity.hasOwnProperty("amenity")){
                //Commenting below line as that is creating issue with count
                //delete filterExceptAmenity["amenity"];
            }
            _.each(filterExceptAmenity, function(filterArr, key) {
                if (filterArr != '') {
                    hotelAmenitiesFltData = _(hotelAmenitiesFltData).filter(filterByProp(key, filterArr)).value();   
                } 
            });

            //console.log("filter except amenities " , filterExceptAmenity)

            
            var hotelAmenitiesCount = {};
            _.each(amenitiesMap,function(amenity,index){
                hotelAmenitiesCount[amenity.class] = 0;
            })

            // Hotel amenites filter number is calculated from a property in hotel object in hotel-content response(ht)
            // Previously am was the property used, now amn is used instead. The value of the propery is a hexadecimal
            // which is converted to binary and used against a map, amenitiesMap is the map used!
            _.each(hotelAmenitiesFltData,function(hotel){
                 if (hotel.amn) {
                    var amenitys = changeToBinary(hotel.amn);
                    amenitys = amenitys.split("").reverse().join("");
                    _.forEach(amenitys, function(value, index){
                        if(value != 0){
                            if(!hotelAmenitiesCount[amenitiesMap[index].class]){
                                hotelAmenitiesCount[amenitiesMap[index].class] = 0;
                            }
                            hotelAmenitiesCount[amenitiesMap[index].class]++
                        }
                    });
                }
            });
            hotelAmenitiesCount["amWIFI"] += hotelAmenitiesCount["amInternet"];
            hotelAmenitiesCount["amPickDrop"] += hotelAmenitiesCount["amAirportShuttle"];
            // hotelAmenitiesCount["amGym"] += hotelAmenitiesCount["amFitnessCenter"];
            
            //console.log("amenities filtered data ----- >>> ", hotelAmenitiesFltData);
            // console.log("amenities filtered count ----- >>> ", hotelAmenitiesCount);

            /*Hotel Amenities count End*/

            /*Property type Count Start*/
            var propTypeFltData = mJson;
            var filtExceptPT = _.clone(appliedFilters);
            if(filtExceptPT.hasOwnProperty("propertyType")){
                delete filtExceptPT["propertyType"];
            }
            _.each(filtExceptPT, function(filterArr, key) {
                if (filterArr != '') {
                    propTypeFltData = _(propTypeFltData).filter(filterByProp(key, filterArr)).value();   
                } 
            });

            var hotelPropCount = {
                "NOCAT" : 0
            };
            _.each(propTypeFltData,function(hotel){
                if (hotel.pt && hotel.pt.length>0) {
                    _.each(hotel.pt,function(value){
                        if(hotelPropCount.hasOwnProperty(value.code)){
                            hotelPropCount[value.code] ++;
                        }else{
                            hotelPropCount[value.code] =1;   
                        }
                    })
                }else{
                    hotelPropCount["NOCAT"] ++;
                }
            });
            // console.log("property filtered data is ---- >> ", propTypeFltData);
            // console.log("property filter count is ---- >>> ", hotelPropCount);
            /*Proeperty type count End*/

            /*Hotel with deals start*/
                var dealsData = mJson;
                var filtExceptDeals = _.clone(appliedFilters);
                if(filtExceptDeals.hasOwnProperty("deals")){
                    delete filtExceptDeals["deals"];
                }
                _.each(filtExceptDeals, function(filterArr, key) {
                    if (filterArr != '') {
                        dealsData = _(dealsData).filter(filterByProp(key, filterArr)).value();   
                    } 
                });

                var dealsData = _.filter(dealsData, function(dealHotel) {
                    return dealHotel.priceInfo && dealHotel.priceInfo.oi && !dealHotel.displayOnlyRule ? true : false;
                });

                var hotelDealsCount =  dealsData.length;

                //console.log("hotelDealsCount --- >> " , hotelDealsCount);
                
            /*Hotel with deals End*/

            /*star filter count update start*/
            $currentTab.find('span.star5').html(starRatingCount["star5"]);
            $currentTab.find('span.star4').html(starRatingCount["star4"]);
            $currentTab.find('span.star3').html(starRatingCount["star3"]);
            $currentTab.find('span.star2').html(starRatingCount["star2"]);
            $currentTab.find('span.star1').html(starRatingCount["star1"]);
            disableFilter($currentTab.find('.starFilter [value=1]'), 0 ,starRatingCount["star1"]);
            disableFilter($currentTab.find('.starFilter [value=2]'), 0 ,starRatingCount["star2"]);
            disableFilter($currentTab.find('.starFilter [value=3]'), 0 ,starRatingCount["star3"]);
            disableFilter($currentTab.find('.starFilter [value=4]'), 0 ,starRatingCount["star4"]);
            disableFilter($currentTab.find('.starFilter [value=5]'), 0 ,starRatingCount["star5"]);
            /*star filter count update END*/

            /*TA filter count update start*/
            $currentTab.find('span.tar45').html(taRatingCount["tar45"]);
            $currentTab.find('span.tar4').html(taRatingCount["tar4"]);
            $currentTab.find('span.tar35').html(taRatingCount["tar35"]);
            $currentTab.find('span.tar3').html(taRatingCount["tar3"]);
            disableFilter($currentTab.find('.taStarRating [value="3.5-5"]'), 0 ,taRatingCount["tar35"]);
            disableFilter($currentTab.find('.taStarRating [value="3-5"]'), 0 ,taRatingCount["tar3"]);
            disableFilter($currentTab.find('.taStarRating [value="4.5-5"]'), 0 ,taRatingCount["tar45"]);
            disableFilter($currentTab.find('.taStarRating [value="4-5"]'), 0 ,taRatingCount["tar4"]);
            /*TA filter count update END*/

            /*PAH filter count start*/
            $currentTab.find('[value=pah]').parent().find('span.pah').html(payAtHotelCount);
            disableFilter($currentTab.find('[value=pah]'), 0 ,payAtHotelCount);
            /*PAH filter count End*/

            /*Free cancellation filter count start*/
            $currentTab.find('[value=fc]').parent().find('span.fc').html(fcHotelCount)
            disableFilter($currentTab.find('[value=fc]'), 0 ,fcHotelCount);
            /*Free cancellation filter count End*/
            var cEle = 'span';
            /*Amemnities Filter Count Start*/
            $currentTab.find('nav.amenity').find('input').each(function(idx, ele) {
                disableFilter(ele, idx, hotelAmenitiesCount[ele.value]);
                $currentTab.find(ele).parent().find(''+ cEle +'.'+ ele.value +'').html(hotelAmenitiesCount[ele.value]);
            });
            /*Amemnities Filter Count End*/

            /*Hotel Chain filter count start*/
            $currentTab.find('nav.chain').find('input').each(function(idx, ele) {
                var chainCount = 0;
                if(hotelChainCount[ele.value]){
                    chainCount = hotelChainCount[ele.value].length;
                }
                disableFilter(ele, idx, chainCount);
                $currentTab.find(ele).parent().find('span.chainCount').html('(' + chainCount+ ')');
            });
            /*Hotel Chain filter count End*/

            /*Property Type filter count start*/
            $currentTab.find('nav.propertyType').find('input').each(function(idx, ele) {
                var propCount = 0;
                if(hotelPropCount[ele.value]){
                    propCount = hotelPropCount[ele.value];
                }
                disableFilter(ele, idx, propCount);
                $currentTab.find(ele).parent().find(''+ cEle +'.'+ ele.value +'').html(propCount);
            });
            /*Property Type filter count End*/

            /*hotel deals count update start*/
            disableFilter($currentTab.find('[value=deals]'), 0 ,hotelDealsCount);
            $currentTab.find('[value=deals]').parent().find('span.deals').html(hotelDealsCount);
            /*hotel deals count update End*/

            function disableFilter(ele, id, count){
                if(!count && !$currentTab.find(ele).prop('checked')){
                    $currentTab.find(ele).prop("disabled", true).parent().addClass('is-disabled');
                } else {
                    $currentTab.find(ele).prop("disabled", false).parent().removeClass('is-disabled');   
                }
                if(id > 2 &&  !$(ele).parent().hasClass('shwMore')){
                    $currentTab.find(ele).parent().addClass('shwLess').hide();
                }
            }
            // var endTime = new Date().getTime();
            // var diff = endTime - startTime;
            // console.log("TIme taken for applying fiters count is ", diff);
            //Scroll to view 
            var firstLi = $('.listView li.listItem:visible:first');
            var documentScrollTop = $(document).scrollTop();
            if(firstLi.length > 0 && documentScrollTop > 250 ){
                firstLi[0].scrollIntoView();
            }
        },

        

        updateAltFiltersClass: function(key, filterArr) {
            
            var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
            if (key == "hrsFilterSlider" || key == "destinations") {
                if (key == "hrsFilterSlider") {
                    var tmpArr = filterArr.split("-");
                    if (tmpArr[0] != "0" || tmpArr[1] != "10") {
                        $currentTab.find(".distanceFilterButton").addClass("setFilterButton");
                    } else if (tmpArr[0] == "0" && tmpArr[1] == "10") {
                        $currentTab.find(".distanceFilterButton").removeClass("setFilterButton");
                    }
                } else {
                    $currentTab.find(".distanceFilterButton").addClass("setFilterButton");
                }

            } else if (key == "price") {
                
                //var tmpArr = filterArr.split("-");
                if (Int(filterArr[0]) != CT.cache[CT.settings.currentTab].filterValues.priceMinMax.min || Int(filterArr[1]) != CT.cache[CT.settings.currentTab].filterValues.priceMinMax.max) {
                    $currentTab.find(".priceFilterButton").addClass("setFilterButton");
                } else if (Int(filterArr[0]) == CT.cache[CT.settings.currentTab].filterValues.priceMinMax.min && Int(filterArr[1]) == CT.cache[CT.settings.currentTab].filterValues.priceMinMax.max) {
                    $currentTab.find(".priceFilterButton").removeClass("setFilterButton");
                }
            } else if (key == "taStarRating") {
                //var tmpArr = filterArr.split("-");
                if (filterArr[0] != "1" || filterArr[1] != "5") {
                    $currentTab.find(".taFilterButton").addClass("setFilterButton");
                } else if (filterArr[0] == "1" && filterArr[1] == "5") {
                    $currentTab.find(".taFilterButton").removeClass("setFilterButton");
                }
            } else if (key == "destinationsTheme" || key == "hotelsTheme") {
                $currentTab.find(".othersFilterButton").addClass("setFilterButton");
            }
        },

        applyLocalityFilters: function( /* Array of area filters*/ areas, /*Array of pois */ pois, /* Array */ filtered) {
            var groupedExactHt = filter.getExactAreaHotels(areas, filtered)
            var poiExactHt = filter.getExactPoiHotels(pois, groupedExactHt['false'])
            if (CT.cache[CT.settings.currentTab].GNFilterApplied && CT.cache[CT.settings.currentTab].GNFilterApplied == true) {
                var radialHt = filter.getRadialHotels(areas, poiExactHt['true'])
            } else {
                var radialHt = filter.getRadialHotels(areas, poiExactHt['false'])
            }
            return {
                exact: groupedExactHt['true'],
                others: CT.isLocationEnabled ? poiExactHt['true'].concat(radialHt['true']).concat(radialHt["false"]) : poiExactHt['true'].concat(radialHt['true'])
            }
        },
        //Following function part of Location 1.0
        applyPoiSorter: function(filtered) {
            var topPoi = CT.utils.getTopPoi();
            if (topPoi) {
                var topPoiLat = parseFloat(topPoi.lat);
                var topPoiLng = parseFloat(topPoi.lng);
                _.each(filtered, function(hotel) {
                    if (hotel.latlng) {
                        var distanceFromArea = CT.utils.helperFunctions.getDistanceFromLatLonInKm(topPoiLat, topPoiLng, hotel.latlng[0], hotel.latlng[1]);
                        hotel.distanceFromLocation = parseInt(distanceFromArea * 1000)
                        if (distanceFromArea > 1000)
                            hotel.distanceFromAreaString = distanceFromArea.toFixed(1) % 1 !== 0 ? (distanceFromArea.toFixed(1) + " km from " + topPoi.nm) : (distanceFromArea.toFixed() + " km from " + topPoi.nm);
                        else
                            hotel.distanceFromAreaString = distanceFromArea.toFixed(1) + " km from " + topPoi.nm;
                    }
                });
                return {
                    exact: filtered
                }
            } else {
                return {
                    exact: filtered
                }
            }
        },
        showAllTags: function(hotels) {
            function getSelectedTagListForHotel(tagsList){
                return _.intersection(tagsList , selectedTagsListIds);
            }

            if(window.showTags && CT.tagsData) {
                var selectedTags = CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter;
                var selectedTagsListIds = selectedTags ? selectedTags.replace(/_tag/g , "").split("-") : [];
            
                // console.warn("showAllTags");
                _.each(hotels.exact, function(hotel) {
                    if (hotel.tags) {
                        var data = {};
                        hotel.selectedTags = getSelectedTagListForHotel(hotel.tags);
                        data.tagsList = _.filter(CT.tagsData,function(ele) {
                            return _.indexOf(hotel.tags, ele.tagId) >=0
                        })
                        _.each(data.tagsList, function(tag) {
                            // console.log("tag", tag);
                            tag.selected = _.contains(hotel.selectedTags, tag.tagId);
                            // if() {
                            //     // if tag is in hotel.selectedTags then set selected to true!
                            // }
                        })
                        hotel.tagsMarkup = CT.to_html('tagListTpl', data);
                        // console.log("selectedTags", selectedTags);
                        // console.log("hotel.selectedTags", hotel.selectedTags);
                        // console.log("hotel.tagsList", hotel.tagsList);
                        // console.log("hotel.tagsMarkup", hotel.tagsMarkup);
                    }else{
                        hotel.selectedTags = null;
                        hotel.tagsMarkup = null;
                        hotel.tagsPrioritySum = 0;
                    }
                });
                // hotel.tagsMarkup = CT.to_html('tagListTpl', data);
                // console.log("hotel.selectedTags", hotel.selectedTags);
                // console.log("data", data);
            }
            return hotels;
        },
        applyTagsFilter : function(filtered){
            if(window.showTags && CT.tagsData){
                var selectedTags = CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter;
                var selectedTagsListIds = selectedTags ? selectedTags.replace(/_tag/g , "").split("-") : [];

                function getSelectedTagListForHotel(tagsList){
                    return _.intersection(tagsList , selectedTagsListIds);
                }

                function filterSlectedTagData(tags){
                    var data = {};
                    data.tagsList = _.filter(CT.tagsData,function(ele){
                        return _.indexOf(tags, ele.tagId) >=0
                    })
                    // console.warn("data.tagsList", data.tagsList);
                    data.tagsList = _.map(data.tagsList,function(ele,idx){
                        if(idx > 2 ){
                            ele.isHidden = true;
                        }else{
                            ele.isHidden = false;
                        }
                        return ele;
                    })
                    if(data.tagsList.length > 3){
                        data.isShowMore = true;
                        data.showMoreTxt = "+" + (data.tagsList.length - 3) + " more";
                    }
                    return data;
                }

                function showHideTagsSortEle(){
                    var $dealSortEle = $('#ResultContainer_' + CT.settings.currentTab).find("section.secondaryBar nav.sorters a[data-sort='deal']").hide();
                    $dealSortEle.hide().parent("li").hide();
                }

                function getPrioritySum(tagList){
                    return _.reduce(tagList,function(prev,curr){
                        return prev + CT.tagsPriorityHash[curr];
                    },0)
                }
                if(selectedTags){
                    _.each(filtered, function(hotel) {
                        if (hotel.tags) {
                            hotel.selectedTags = getSelectedTagListForHotel(hotel.tags);
                            var data = filterSlectedTagData(hotel.selectedTags);
                            hotel.tagsPrioritySum = getPrioritySum(hotel.selectedTags);
                            hotel.tagsMarkup = CT.to_html('tagListTpl', data);
                            // console.log("hotel.selectedTags", hotel.selectedTags);
                            // console.log("data", data);
                        }else{
                            hotel.selectedTags = null;
                            hotel.tagsMarkup = null;
                            hotel.tagsPrioritySum = 0;
                        }
                    });
                } else {
                    _.each(filtered, function(hotel) {
                            hotel.selectedTags = null;
                            hotel.tagsMarkup = null;
                            hotel.tagsPrioritySum = 0;
                    });
                }
                showHideTagsSortEle();
            }
            return {
                exact : filtered
            }
        },

        applyFilters: function( /* Object */ applyFilters) {
            console.log("applyFilters 1", applyFilters);
            var lolFilterParams = CT.cache.tabsMap[CT.settings.currentTab]['lolfilter'] || [];
            if (lolFilterParams.length) {
                applyFilters.lolfilter = lolFilterParams.replace(/\+/g, " ").replace(/-/g, "#").replace(/_/g, "-").split("#") || [];
            }
            window.localities = (window.lolOnlyLocalites || []).concat(applyFilters.lolfilter || []);

           // window.L("calling applyFilters");
        //    if (applyFilters.tagsFilter.length) {
        //         CT.isLocationEnabled = false;
        //         delete applyFilters.showFewFilter
        //    }
            var filtered = $('body').hasClass('mapView') ? (applyFilters.mapObj ? applyFilters.mapObj : CT.masterJson.get().clusterMapItems ? CT.masterJson.get().clusterMapItems : '') : '';
            var hasLocalitySearch = false
            var options = {
                idx: 0
            }
            var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
            var paramsObj = CT.cache[CT.settings.currentTab].searchParams.all;
            if (paramsObj.gn && paramsObj.gn === true) {
                if ($currentTab.find('.badgeFilter li').hasClass('current') != true) {
                    $currentTab.find('.badgeFilter li:first').addClass('current');
                }
                var gnShownSession = sessionStorage.getItem("gnShownSession");
                if (gnShownSession == null || gnShownSession == 'undefined') {
                    sessionStorage.setItem("gnShownSession", true);
                }
                $currentTab.find('.pinPointTab li').removeClass('current');
                delete CT.cache[CT.settings.currentTab].searchParams.all.gn;
                $currentTab.find('.pinPointBlockDone').hide();
            }
            if (CT.subProd != "wg") {
                delete CT.cache[CT.settings.currentTab].searchParams.all.from;
            }
            //hide nearby localities notification
            $('#ResultContainer_' + CT.settings.currentTab).trigger('nearByNotification.hide');

            if (applyFilters.amenities) options.hasAmenities = true
            if (applyFilters.price) applyFilters.price = applyFilters.price.split('-')
            if (applyFilters.taStarRating) applyFilters.taStarRating = applyFilters.taStarRating.split('-')
            var applyLocationFilters = filtered ? filtered : CT.masterJson.get().ht
            var locationSearched = _.deserialize(window.location.search)
            if (CT.cache[CT.settings.currentTab].longitude != "" && CT.cache[CT.settings.currentTab].latitude != "") {
                if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == true && CT.cache[CT.settings.currentTab].pointOfIntrestValue != "" && CT.isLocationEnabled == true) {
                    var searchedPoiAddress = CT.cache[CT.settings.currentTab].pointOfIntrestValue
                    _.each(applyLocationFilters, function(item) {
                        if (item.hasSpriteIcon && item.classToarea) {
                            delete item.hasSpriteIcon;
                            delete item.classToarea;
                        } else {
                            if (item.distanceFromAreaString)
                                delete item.distanceFromAreaString;
                        }
                        if (item.areaSearch) {
                            item.areaSearch = false;
                        }
                        if (item.distanceFromLocation)
                            delete item.distanceFromLocation;
                        if (item.latlng) {
                            var hotelLat = item.latlng[0];
                            var hotelLng = item.latlng[1];
                            var distanceFromArea = CT.utils.helperFunctions.getDistanceFromLatLonInKm(CT.cache[CT.settings.currentTab].latitude, CT.cache[CT.settings.currentTab].longitude, hotelLat, hotelLng);
                            var locationInMetres = distanceFromArea * 1000;
                            item.isgoogleSearch = true;
                            CT.utils.helperFunctions.addLocationDetails(item, {
                                area: searchedPoiAddress,
                                lat: CT.cache[CT.settings.currentTab].latitude,
                                lng: CT.cache[CT.settings.currentTab].longitude
                            });
                            item.distanceFromLocation = distanceFromArea;
                            if (distanceFromArea) {
                                if (locationInMetres > 1000)
                                    item.distanceFromAreaString = distanceFromArea.toFixed(1) % 1 !== 0 ? (distanceFromArea.toFixed(1) + " km from " + searchedPoiAddress) : (distanceFromArea.toFixed() + " km from " + searchedPoiAddress);
                                else
                                    item.distanceFromAreaString = distanceFromArea.toFixed(1) + " km from " + searchedPoiAddress;
                            }
                        } else
                            item.distanceFromLocation = 6372;
                    })
                }
            }
            if (applyFilters.tagsFilter && applyFilters.tagsFilter.length) {
                // CT.isLocationEnabled = false;
                applyFilters.showFewFilter = [];
            }
            filtered = filter.applyBasicFilters(applyFilters, filtered || CT.masterJson.get().ht)
            console.log("applyFilters 2", applyFilters);

            // applyTagsFilter is responsible for applying tag filters, 
            // but in does some ohter hocus-pocus(features that are forgotten) too, so keeping it for that
            filtered = filter.applyTagsFilter(filtered.exact);
            // Does the actuall selection and showing of tags by using templates to genrate html
            filtered = filter.showAllTags(filtered);
            
            if (CT.isLocationEnabled == true && !(applyFilters.tagsFilter && applyFilters.tagsFilter.length)) {
                if (CT.cache[CT.settings.currentTab].googleSortedPoi || CT.cache[CT.settings.currentTab].googleSortedArea)
                    filtered = filter.applyLocalityFilters(CT.cache[CT.settings.currentTab].googleSortedArea, CT.cache[CT.settings.currentTab].googleSortedPoi, filtered.exact)
                else if (applyFilters.area)
                    filtered = filter.applyLocalityFilters(applyFilters.area, applyFilters.poi, filtered.exact)
                else if (CT.cache[CT.settings.currentTab].searchParams.all.poi && CT.cache[CT.settings.currentTab].searchParams.all.poi[0] != "" && applyFilters.area)
                    filtered = filter.applyLocalityFilters(applyFilters.area, CT.cache[CT.settings.currentTab].searchParams.all.poi, filtered.exact)
                else {
                    var marketNature = CT.masterJson.get().hmn;
                    if (marketNature == "Leisure" || marketNature == "Pilgrimage")
                        filtered = filter.applyPoiSorter(filtered.exact);
                }
            } else {
                if (applyFilters.area || applyFilters.poi)
                    filtered = filter.applyLocalityFilters(applyFilters.area, applyFilters.poi, filtered.exact)
                else {
                    var marketNature = CT.masterJson.get().hmn;
                    if (marketNature == "Leisure" || marketNature == "Pilgrimage")
                        filtered = filter.applyPoiSorter(filtered.exact);
                }
            }
            //console.log('AFTER ALL FILTERS', filtered)
            // filtered list ready. Fire results update\
            CT.fire('sorters.update', [this.setData(filtered), options])
            //Once the filters are applied Scroll the results to top
            this.scrollToTop(150, 600, 'easeOutCubic');
        },

        afterChangeflights: function(mobj) {
            
            var _allPrices = [],
                _prMin, _prMax, $currentResultDiv = $('#ResultContainer_' + CT.settings.currentTab);

            //calculating price for each hotel
            _.forEach(mobj.ht, function(hotel, index) {
                hotel = $.extend(true, hotel, CT.FlightSolution.calFormatPrice(hotel, hotel.priceInfo.pf, hotel.priceInfo.ps, hotel.priceInfo.airpf, hotel.priceInfo.airps, hotel.priceInfo.hotelpf, hotel.priceInfo.hotelps, hotel.sfsfd));

                //To find min and max prices, pushing all prices to one array.
                if (CT.app === 'dp' && hotel.priceInfo.pf) _allPrices.push(hotel.priceInfo.pf);
                else if (hotel.priceInfo) _allPrices.push(hotel.priceInfo.rms[0].tot);
            });

            //calculating min and max prices.
            _prMin = _.min(_allPrices);
            _prMax = _.max(_allPrices);

            //changing page min max values.
            CT.cache[CT.settings.currentTab].filterValues.priceMinMax = {
                "min": _prMin,
                "max": _prMax
            };

            //resetting slider
            var _sobj = [{
                "wrapper": ".price.rangeSlider",
                "container": ".price",
                "min": _prMin,
                "max": _prMax
            }];
            _.forEach(_sobj, function(val, index) {
                this.$el.find(val.wrapper).slider("option", {
                    "min": val.min,
                    "max": val.max,
                    "trigger": false,
                    "values": [val.min, val.max]
                }).slider({
                    "trigger": true
                });
            }, this);

            //overwrting price hidden input value.
            $currentResultDiv.find('.filtersForm').find('input[name="price"]').val(_prMin + '-' + _prMax)

            filter.setData({
                exact: mobj.ht
            });
            filter.fltData();
        },




        create: function(e, name, type) {
            this.createFilter(name, type);
            this.toggleFilter('nearByCities', 'show');
        },




        update: function(e, mobj, paramsHash, currentResultView) {
            
            mobj = mobj || CT.masterJson.get();
            paramsHash = paramsHash || CT.cache[CT.settings.currentTab].searchParams.all;

            // TODO: prem-move to hotels common place
            function isFilterParam(param) {
                return (_.indexOf(CT.settings[CT.app].filterParamList, param) != -1);
                // if the param is there in the exception list return true.
            }

            // TODO: prem-move to hotels common place
            function getFilterParams(paramsObj) {
                if (CT.app != "dp" && !paramsObj.gn) {
                    var filterParam = {},
                        tmp;
                    for (var k in paramsObj) {
                        if (isFilterParam(k)) {
                            if (k == 'area' || k == 'poi') {
                                tmp = [];
                                tmp.push(paramsObj[k]);
                                filterParam[k] = _.isArray(paramsObj[k]) ? paramsObj[k] : tmp;
                            } else {
                                if (k == 'hotelName')
                                    filterParam[k] = paramsObj[k];
                                else
                                    filterParam[k] = _.isArray(paramsObj[k]) ? paramsObj[k] : paramsObj[k].split("-");
                            }
                            //TODO: move "-" to settings.js
                        }
                    }
                    return filterParam;
                } else {
                    if (paramsObj.gn && paramsObj.gn === "true") {
                        $('#ResultContainer_' + CT.settings.currentTab).find('.smallSearch input, .mapViewSearch input').val("")
                        delete paramsObj.gn;
                        for (var k in paramsObj) {
                            if (_.contains(CT.settings[CT.app].filterParamList, k) == true) {
                                delete paramsObj[k];
                                if (CT.cache[CT.settings.currentTab].searchParams.all[k]) {
                                    delete CT.cache[CT.settings.currentTab].searchParams.all[k]
                                }
                            }

                        }
                        CT.settings.routes.navigate('/results?' + _.serialize(paramsObj), {
                            trigger: false,
                            replace: true
                        })
                    }
                    return null;
                }
            }
            var filterValues = CT.cache[CT.settings.currentTab].filterValues = {};
            _.each(['beforeChkAvailFilters', 'checkAvailFlag', 'priceMinMax', 'hotelPriceSliderObj', 'hotelTASliderObj', 'hotelStarSliderObj', 'showall', 'undoFilterObj', 'showAll'], function(name) {
                if (name !== 'showAll')
                    filterValues[name] = []
                else
                    filterValues[name] = false
            })

            this.createFilters(mobj).setData({
                exact: mobj.ht
            });
            this.updateFilters(getFilterParams(CT.cache[CT.settings.currentTab].searchParams.all)).fltData(null, {
                onload: true
            });
            //For Retaining Filters
            if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                if ($.isEmptyObject(CT.cache[CT.settings.currentTab].retainFilters)) //set Session Storage key to null when true
                    localStorage.setItem("recentFilters", null);
                else {
                    var currentTime = new Date().getTime();
                    CT.cache[CT.settings.currentTab].retainFilters["lastUpdated"] = currentTime;
                    localStorage.setItem("recentFilters", JSON.stringify(CT.cache[CT.settings.currentTab].retainFilters));
                }
            }
        },
        scrollToTop : function(timeout, scrollSpeed, easing) {
            timeout = timeout || 0;
            scrollSpeed = scrollSpeed || 400;
            easing = easing || 'swing';
            setTimeout(function(){
                 $('body').animate({"scrollTop": "0px"}, scrollSpeed, easing);
             }, timeout);
        }
    };


    /**
     * Subcriptions
     ***************************************************************************************/

    // This is the first call from the results page which builds the basic UI for filters
    CT.subscribe('filters.init', function(currentResultView, /* Hash */ obj) { // where 'obj' can be paramsHash or staticJson
        var filterView, commonFilterViewSettings;

        filter.$el = currentResultView.$(CT.settings.selectors.filters);
        filter.settings = obj // for initialize method

        filterView = View("commonFilter", filter, cf);

        //initialize sorter
        CT.fire('sorters.init', [{},
            filterView
        ]);

        L('filter view created', filterView);
    });


    CT.subscribe('filters.apply', function(mapObj) {
        if (window.localities.length) {
            window.showLolBanner = false;
        }
        var $currentResultDiv = $('#ResultContainer_' + CT.settings.currentTab)
        if (CT.subProd && CT.subProd == "wg") {
            $currentResultDiv.find('.filtersForm input').removeAttr("disabled");
        }        
        var serializedData = $currentResultDiv.find('.filtersForm').serialize();
        var deserializeData = _.deserialize(serializedData, hashModifiers);

        filter.setUrlParams(deserializeData);

        deserializeData["mapObj"] = CT.masterJson.get().clusterMapItems ? CT.masterJson.get().clusterMapItems : undefined;
        filter.applyFilters(deserializeData);
    });

    CT.subscribe('filters.callback', function(obj) {
        var html = '',
            fLeft = '',
            fRight = '',
            hrsVal = '',
            hrsMarkup = "",
            subTitle = '',
            tmp, $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
        //  CT.cache[CT.settings.currentTab].filterClicked = true
        CT.cache[CT.settings.currentTab].mapDragged = false;

        //TODO: move below messaging to messages file
        switch (obj.name) {

            case 'price':  
            if ((window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.priceCheckBox && CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b'){
                var availCount = 0,
                    tmpJson = []
                ;
                for (var k in CT.masterJson.get().ht) {
                    if (CT.masterJson.get().ht[k].priceInfo) {
                        tmpJson.push(CT.masterJson.get().ht[k]);
                        availCount++;
                    }
                };
                tmpJson.sort(function(a, b) {
                    if (a.priceInfo && b.priceInfo) {
                        return a.priceInfo.rms[0].tot > b.priceInfo.rms[0].tot ? 1 : -1;
                    }
                })
                CT.cache[CT.settings.currentTab].availableCount = availCount;
                CT.avaiActiveHotel = availCount;

                var count2k = 0,
                    count4k = 0,
                    count6k = 0,
                    count6kPlus = 0,
                    indiTotalPrice = 0,
                    FilterBottomLow = CT.settings.hotel.priceRange["bottomLow"],
                    FilterBottomHight = CT.settings.hotel.priceRange["bottomHigh"],
                    FilterMidLow = CT.settings.hotel.priceRange["midLow"],
                    FilterMidHight = CT.settings.hotel.priceRange["midHight"],
                    FilterExpensive = CT.settings.hotel.priceRange["expensive"],
                    maxInBucket = [],
                    currency2k = CT.utils.formatForCurrency(FilterBottomHight),
                    currency4k = CT.utils.formatForCurrency(FilterMidLow),
                    currency6k = CT.utils.formatForCurrency(FilterMidHight),
                    currency6kPlus = CT.utils.formatForCurrency(FilterMidHight),
                    priceFilterClasses = CT.settings.hotel.priceRange["NClasses"],
                    targetPriceFilterWraper2kEl = $currentTab.find(".price-filter-chk-box"+ (priceFilterClasses.indexOf('count2k') > -1 ? '_count2k' : '')),
                    targetPriceFilterWraper4kEl = $currentTab.find(".price-filter-chk-box"+(priceFilterClasses.indexOf('count4k') > -1 ? '_count4k' : '')),
                    targetPriceFilterWraper6kEl = $currentTab.find(".price-filter-chk-box"+ (priceFilterClasses.indexOf('count6k') > -1 ? '_count6k' : '')),
                    targetPriceFilterWraper6PluskEl = $currentTab.find(".price-filter-chk-box"+ (priceFilterClasses.indexOf('count6kPlus') > -1 ? '_count6kPlus' : ''))
                    filter2kHTML = '',
                    filter4kHTML = '',
                    filter6kHTML = '',
                    filter6PlusHTML = ''
                    ;
                    
                tmpJson.forEach(function (value, index){
                    indiTotalPrice = value.priceInfo.rms[0].tot;
                    maxInBucket.push(indiTotalPrice);
                    if ( indiTotalPrice > FilterBottomLow && indiTotalPrice <= FilterBottomHight ){
                        count2k++;
                    } else if ( indiTotalPrice > FilterBottomHight && indiTotalPrice <= FilterMidLow ){
                        count4k++;
                    } else if ( indiTotalPrice > FilterMidLow && indiTotalPrice <= FilterMidHight ){
                        count6k++;
                    } 
                    else if ( indiTotalPrice > FilterMidHight && indiTotalPrice <= FilterExpensive ){
                        count6kPlus++;
                    } 
                })
                
                filter2kHTML = 'Below ' + currency2k + ' (<span class="'+ FilterBottomLow + '-' + FilterBottomHight +'">'+count2k+'</span>)';
                filter4kHTML = currency2k + ' - ' + currency4k + ' (<span class="'+ FilterBottomHight + '-' + FilterMidLow +'">'+count4k+'</span>)';;
                filter6kHTML = currency4k + ' - ' + currency6k + ' (<span class="'+ FilterMidLow + '-' + FilterMidHight +'">'+count6k+'</span>)';;
                filter6PlusHTML = currency6k + ' + ' + ' (<span class="'+ FilterMidHight + '-' + Math.max.apply(null, maxInBucket) +'">'+count6kPlus+'</span>)';
                
                targetPriceFilterWraper2kEl.find('.control__label').html(filter2kHTML);
                targetPriceFilterWraper4kEl.find('.control__label').html(filter4kHTML);
                targetPriceFilterWraper6kEl.find('.control__label').html(filter6kHTML);
                targetPriceFilterWraper6PluskEl.find('.control__label').html(filter6PlusHTML);
            }
                //html = "From <span class='curr INR'>Rs. </span> " + CT.utils.formatForCurrency(obj.value[0], 0, true) + " to <span class='curr INR'>Rs. </span> " + CT.utils.formatForCurrency(obj.value[1], 0, true);
                fLeft = CT.utils.formatForCurrency(obj.value[0]) + CT.messages.hotel.To + CT.utils.formatForCurrency(obj.value[1]);
                if (CT.subProd && CT.subProd == "wg" && window.altFilters == "true") {
                    $currentTab.find(".priceFilterButton small").html(fLeft)
                }
            break;
            case 'taStarRating':
                if (obj.value1[0] === 1) {
                    fLeft = CT.messages.hotel.AnyRating;
                } else if (obj.value1[0] === 5) {
                    fLeft = CT.messages.hotel.Rating + "5";
                } else {
                    fLeft = CT.messages.hotel.Rating + obj.value1[0] + CT.messages.hotel.andAbove;
                }
                if (CT.subProd && CT.subProd == "wg" && window.altFilters == "true") {
                    $currentTab.find(".taFilterButton small").html(fLeft)
                }
                break;
            case 'starFilter':
                html = obj.value[0] + CT.messages.hotel.StarTo + obj.value[1] + CT.messages.hotel.Star;
                break;
            case 'hrsFilterSlider':
                leftHrs = obj.value[0];
                rightHrs = obj.value[1];
                //hrsVal = obj.value1[0] == 0 ? obj.value[1]:obj.value1[0];
                leftHrsTmp = leftHrs == "10" ? leftHrs + CT.messages.hotel.Hour + "+" : leftHrs >= 2 ? leftHrs + CT.messages.hotel.Hour : "";
                rightHrsTmp = rightHrs == "10" ? rightHrs + CT.messages.hotel.Hour + "+" : rightHrs + CT.messages.hotel.Hour
                if (leftHrs >= 2) {
                    hrsMarkup = CT.messages.hotel.DriveTime + leftHrs + CT.messages.hotel.HourTo + rightHrs + CT.messages.hotel.Hour;
                } else {
                    hrsMarkup = rightHrs == "10" ? CT.messages.hotel.DriveTimeUpto + rightHrs + CT.messages.hotel.Hour : CT.messages.hotel.DriveTimeUpto + rightHrs + CT.messages.hotel.Hour;
                }
                //hrsMarkup = hrsVal == "10"?"Drive "+hrsVal+"h & more":"Upto "+hrsVal+"h drive"
                //hrsMarkupTmp = hrsVal == "10"?hrsVal+"h+":hrsVal+"h"
                if (window.altFilters == "false") {
                    $currentTab.find(".hrsFilter").val(obj.value);
                    $currentTab.find(".distanceSlider h3 span").html(hrsMarkup);
                    $currentTab.find(".distanceSlider .left").html(leftHrsTmp);
                    $currentTab.find(".distanceSlider .right").html(rightHrsTmp);
                } else {
                    //fLeft = hrsMarkup.split(":")[1].replace("upto","Upto");
                    //fLeft += " drive";
                    //$currentTab.find(".distanceFilterButton small").html(fLeft)
                    //$currentTab.find(".distanceSlider h3 span").html(hrsMarkup);
                }
                $currentTab.find(".hrsFilter").val(obj.value);
                //$currentTab.find(".distanceSlider h5 span").html(hrsMarkup);
                //$currentTab.find(".distanceSlider .left").html(leftHrsTmp);
                //$currentTab.find(".distanceSlider .right").html(rightHrsTmp);


                break;
            default:
                break;
        }
        tmp = $('.' + obj.name).closest('.sideBlock');
        if (fLeft != '')
            tmp.find('.displayFilterValue .fLeft').html(fLeft);
        if (fRight != '')
            tmp.find('.displayFilterValue .fRight').html(fRight);
        if (subTitle != '')
            tmp.find('h5 small').html(subTitle);
    })


    //TODO: use DRY concepts
    CT.subscribe('sliderMoved', function(prObj) {
        var options = $(prObj.ref).slider("option"),
            label = '';
        //var pr = prObj.value || prObj
        var pr = prObj.value;
        var paramsObj = CT.cache[CT.settings.currentTab].searchParams.all;

        if (options.range != true) {
            pr = [prObj.value, options[options.range]]
        }


        var $currentResultDiv = $('#ResultContainer_' + CT.settings.currentTab)
            //hide nearby cities notification
        $currentResultDiv.trigger('nearByNotification.hide');

        if ($currentResultDiv.find(".srpInpageMessage").length > 0) {
            CT.cache[CT.settings.currentTab].removeUndo = true;
        } else {
            CT.cache[CT.settings.currentTab].removeUndo = false;
        }
        
        if (CT.subProd && CT.subProd == "wg") {
            $currentResultDiv.find('.filtersForm input').removeAttr("disabled");
            if (window.altFilters == "true") {
                $.each($currentResultDiv.find('.destinations input'), function(index1, value1) {
                    $(value1).attr('checked', false) //.removeClass('marked');
                    $(value1).closest("label").removeClass("selected")
                })
            }

        }
        var serializedData = $currentResultDiv.find('.filtersForm').find('input[name="' + prObj.name + '"]').val(pr[0] + '-' + pr[1]).end().serialize()
        prevFilterEle.push(CT.cache[CT.settings.currentTab].recentFilterData ? CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle[CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.length - 1] : undefined)
        currentFilterEle.push(prObj.name);
        prevSerializedData.push(CT.cache[CT.settings.currentTab].recentFilterData ? CT.cache[CT.settings.currentTab].recentFilterData.currentSerializedData[CT.cache[CT.settings.currentTab].recentFilterData.currentSerializedData.length - 1] : undefined)
        currentSerializedData.push(_.deserialize(serializedData, hashModifiers));
        CT.cache[CT.settings.currentTab].recentFilterData = {
            "prevFilterEle": prevFilterEle,
            "currentFilterEle": currentFilterEle,
            "prevSerializedData": prevSerializedData,
            "currentSerializedData": currentSerializedData
        }




        serializedData = _.deserialize(serializedData, hashModifiers)
        if (CT.cache[CT.settings.currentTab].GNFilterApplied == undefined || CT.cache[CT.settings.currentTab].GNFilterApplied == false) {
            filter.setUrlParams(serializedData).applyFilters(serializedData);
        }
        if (paramsObj.gn && paramsObj.gn === true) {
            var obj = {
                "sid": CT.cache[CT.settings.currentTab].sid,
                "ppcr": CT.settings[CT.app].guidedNavForLog[prObj.name],
                "st": 4,
                "ar": ""
            }
            $.extend(true, obj, CT.cache[CT.settings.currentTab].pinPointSearchParams);
            CT.utils.helperFunctions.dashBoardLogging(obj)
        }
        
        if (prObj.name == "price") {
            var direction = $(prObj.ref).find("a.uiSelected").is(".right") ? "Right" : "Left";
            label = prObj.value.toString();
            var category = 'Hotels_TR'
            CT.utils.helperFunctions.trackGAEventWrapper(category, 'H_Filter_Price', label, '100');
            CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                "filterType": 'filter_Price',
                "filterValue": label,
                "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
            });
        } else if (prObj.name == "taStarRating") {
            label = prObj.value;
            var category = 'Hotels_TR'
            CT.utils.helperFunctions.trackGAEventWrapper(category, 'H_Filter_TA', label, '100');
            CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Applied", {
                "filterType": 'filter_TARating',
                "filterValue": label,
                "numHotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                "numHotelsAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
            });
        } else if (prObj.name == "hrsFilterSlider") {
            //  filter.hideDestinations(prObj)
            var direction = $(prObj.ref).find("a.uiSelected").is(".right") ? "Right" : "Left";
            label = prObj.value.toString();
            CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_Hrs_Slider', label, '100');
        }
        //filter.fltData();
    });

    //  CT.subscribe('starSliderMoved', function(prObj) {
    //      CT.cache[CT.settings.currentTab].filterValues.hotelStarSliderObj = prObj.value;
    //      filter.fltData();
    //  });
    //  CT.subscribe('taSliderMoved', function(_taObj) {
    //      CT.cache[CT.settings.currentTab].filterValues.hotelTASliderObj = _taObj.value[0];
    //      filter.fltData();
    //  });

    CT.subscribe('airlinesfilters.ready', function(mobj) {
        filter.afterChangeflights(mobj);
    });

    CT.subscribe('undolastfilter.init', function() {
        filter.undoLastFilter();
    });

    CT.subscribe('hotelKeywordSearch.init', function(val) {
        filter.hotelKeywordSearch('', val)
    });


    return filter;
}, CT.settings);
